(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea208"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea208"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fGVKa", function(module, exports) {

$parcel$export(module.exports, "register", () => $b6c791f0d5223d0b$export$6503ec6e8aabbaf, (v) => $b6c791f0d5223d0b$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b6c791f0d5223d0b$export$f7ad0328861e2f03, (v) => $b6c791f0d5223d0b$export$f7ad0328861e2f03 = v);
var $b6c791f0d5223d0b$export$6503ec6e8aabbaf;
var $b6c791f0d5223d0b$export$f7ad0328861e2f03;
"use strict";
var $b6c791f0d5223d0b$var$mapping = new Map();
function $b6c791f0d5223d0b$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b6c791f0d5223d0b$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b6c791f0d5223d0b$var$resolve(id) {
    var resolved = $b6c791f0d5223d0b$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b6c791f0d5223d0b$export$6503ec6e8aabbaf = $b6c791f0d5223d0b$var$register;
$b6c791f0d5223d0b$export$f7ad0328861e2f03 = $b6c791f0d5223d0b$var$resolve;

});

parcelRegister("6aWQp", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", () => $47f152838eccd126$export$bdfd709ae4826697, (v) => $47f152838eccd126$export$bdfd709ae4826697 = v);
var $47f152838eccd126$export$bdfd709ae4826697;
var $47f152838eccd126$export$c9e73fbda7da57b6;
var $47f152838eccd126$export$5a759dc7a1cfb72a;
"use strict";
var $47f152838eccd126$var$bundleURL = {};
function $47f152838eccd126$var$getBundleURLCached(id) {
    var value = $47f152838eccd126$var$bundleURL[id];
    if (!value) {
        value = $47f152838eccd126$var$getBundleURL();
        $47f152838eccd126$var$bundleURL[id] = value;
    }
    return value;
}
function $47f152838eccd126$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $47f152838eccd126$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $47f152838eccd126$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $47f152838eccd126$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$47f152838eccd126$export$bdfd709ae4826697 = $47f152838eccd126$var$getBundleURLCached;
$47f152838eccd126$export$c9e73fbda7da57b6 = $47f152838eccd126$var$getBaseURL;
$47f152838eccd126$export$5a759dc7a1cfb72a = $47f152838eccd126$var$getOrigin;

});

parcelRegister("3qgcu", function(module, exports) {

$parcel$export(module.exports, "pipeline", () => pipeline);
$parcel$export(module.exports, "regex_whitespace", () => regex_whitespace);
$parcel$export(module.exports, "init_filter", () => init_filter);
$parcel$export(module.exports, "init_stemmer_or_matcher", () => init_stemmer_or_matcher);
parcelRequire("kCqCN");

var $i3Bki = parcelRequire("i3Bki");
function pipeline(str, normalize, split, _collapse) {
    if (str) {
        if (normalize) str = replace(str, /** @type {Array<string|RegExp>} */ normalize);
        if (this.matcher) str = replace(str, this.matcher);
        if (this.stemmer && 1 < str.length) str = replace(str, this.stemmer);
        if (_collapse && 1 < str.length) str = collapse(str);
        if (split || "" === split) {
            const words = str.split(/** @type {string|RegExp} */ split);
            return this.filter ? filter(words, this.filter) : words;
        }
    }
    return str;
}
const regex_whitespace = /[\p{Z}\p{S}\p{P}\p{C}]+/u;
// https://github.com/nextapps-de/flexsearch/pull/414
//export const regex_whitespace = /[\s\xA0\u2000-\u200B\u2028\u2029\u3000\ufeff!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/
const regex_normalize = /[\u0300-\u036f]/g;
function normalize(str) {
    if (str.normalize) str = str.normalize("NFD").replace(regex_normalize, "");
    return str;
}
function init_filter(words) {
    const filter = (0, $i3Bki.create_object)();
    for(let i = 0, length = words.length; i < length; i++)filter[words[i]] = 1;
    return filter;
}
function init_stemmer_or_matcher(obj, is_stemmer) {
    const keys = (0, $i3Bki.get_keys)(obj), length = keys.length, final = [];
    let removal = "", count = 0;
    for(let i = 0, key, tmp; i < length; i++){
        key = keys[i];
        tmp = obj[key];
        if (tmp) {
            final[count++] = regex(is_stemmer ? "(?!\\b)" + key + "(\\b|_)" : key);
            final[count++] = tmp;
        } else removal += (removal ? "|" : "") + key;
    }
    if (removal) {
        final[count++] = regex(is_stemmer ? "(?!\\b)(" + removal + ")(\\b|_)" : "(" + removal + ")");
        final[count] = "";
    }
    return final;
}
function replace(str, regexp) {
    for(let i = 0, len = regexp.length; i < len; i += 2){
        str = str.replace(regexp[i], regexp[i + 1]);
        if (!str) break;
    }
    return str;
}
function regex(str) {
    return new RegExp(str, "g");
}
function collapse(string) {
    let final = "", prev = "";
    for(let i = 0, len = string.length, char; i < len; i++)if ((char = string[i]) !== prev) final += prev = char;
    return final;
}
function filter(words, map) {
    const length = words.length, filtered = [];
    for(let i = 0, count = 0; i < length; i++){
        const word = words[i];
        if (word && !map[word]) filtered[count++] = word;
    }
    return filtered;
} // const chars = {a:1, e:1, i:1, o:1, u:1, y:1};
 //
 // function collapse_repeating_chars(string){
 //
 //     let collapsed_string = "",
 //         char_prev = "",
 //         char_next = "";
 //
 //     for(let i = 0; i < string.length; i++){
 //
 //         const char = string[i];
 //
 //         if(char !== char_prev){
 //
 //             if(i && (char === "h")){
 //
 //                 if((chars[char_prev] && chars[char_next]) || (char_prev === " ")){
 //
 //                     collapsed_string += char;
 //                 }
 //             }
 //             else{
 //
 //                 collapsed_string += char;
 //             }
 //         }
 //
 //         char_next = (
 //
 //             (i === (string.length - 1)) ?
 //
 //                 ""
 //             :
 //                 string[i + 1]
 //         );
 //
 //         char_prev = char;
 //     }
 //
 //     return collapsed_string;
 // }

});
parcelRegister("kCqCN", function(module, exports) {
/**
 * @interface
 */ function $f02c02665815b99b$export$80e70052c6153de() {
    this.cache = null;
    this.matcher = null;
    this.stemmer = null;
    this.filter = null;
}
/**
 * @param {!string} str
 * @param {boolean|Array<string|RegExp>=} normalize
 * @param {boolean|string|RegExp=} split
 * @param {boolean=} collapse
 * @returns {string|Array<string>}
 */ //IndexInterface.prototype.pipeline;
/**
 * @param {!number|string} id
 * @param {!string} content
 */ $f02c02665815b99b$export$80e70052c6153de.prototype.add;
/**
 * @param {!number|string} id
 * @param {!string} content
 */ $f02c02665815b99b$export$80e70052c6153de.prototype.append;
/**
 * @param {!string|Object} query
 * @param {number|Object=} limit
 * @param {Object=} options
 * @returns {Array<number|string>}
 */ $f02c02665815b99b$export$80e70052c6153de.prototype.search;
/**
 * @param {!number|string} id
 * @param {!string} content
 */ $f02c02665815b99b$export$80e70052c6153de.prototype.update;
/**
 * @param {!number|string} id
 */ $f02c02665815b99b$export$80e70052c6153de.prototype.remove;
function $f02c02665815b99b$export$567ed11f878acad9() {
    this.field = null;
    /** @type IndexInterface */ this.index = null;
}

});

parcelRegister("i3Bki", function(module, exports) {

$parcel$export(module.exports, "parse_option", () => $d255760e1170f211$export$952e4699767d54aa);
$parcel$export(module.exports, "create_object_array", () => $d255760e1170f211$export$ef70783d1acb931a);
$parcel$export(module.exports, "create_object", () => $d255760e1170f211$export$5c30cbca21b2d575);
$parcel$export(module.exports, "get_keys", () => $d255760e1170f211$export$8848baa1b2a3aeb6);
$parcel$export(module.exports, "concat", () => $d255760e1170f211$export$ee1b3e54f0441b22);
$parcel$export(module.exports, "sort_by_length_down", () => $d255760e1170f211$export$3b235e93dd1df04f);
$parcel$export(module.exports, "is_array", () => $d255760e1170f211$export$e11d765514e26475);
$parcel$export(module.exports, "is_string", () => $d255760e1170f211$export$2a124c24c597fe41);
$parcel$export(module.exports, "is_object", () => $d255760e1170f211$export$167528a9b5133c2f);
$parcel$export(module.exports, "is_function", () => $d255760e1170f211$export$b451353ebd749597);
function $d255760e1170f211$export$952e4699767d54aa(value, default_value) {
    return "undefined" != typeof value ? value : default_value;
}
function $d255760e1170f211$export$ef70783d1acb931a(count) {
    const array = Array(count);
    for(let i = 0; i < count; i++)array[i] = $d255760e1170f211$export$5c30cbca21b2d575();
    return array;
}
function $d255760e1170f211$export$841a3b58e9c90461(count) {
    const array = Array(count);
    for(let i = 0; i < count; i++)array[i] = [];
    return array;
}
function $d255760e1170f211$export$8848baa1b2a3aeb6(obj) {
    return Object.keys(obj);
}
function $d255760e1170f211$export$5c30cbca21b2d575() {
    return Object.create(null);
}
function $d255760e1170f211$export$ee1b3e54f0441b22(arrays) {
    return [].concat.apply([], arrays);
}
function $d255760e1170f211$export$3b235e93dd1df04f(a, b) {
    return b.length - a.length;
}
function $d255760e1170f211$export$e11d765514e26475(val) {
    return val.constructor === Array;
}
function $d255760e1170f211$export$2a124c24c597fe41(val) {
    return "string" == typeof val;
}
function $d255760e1170f211$export$167528a9b5133c2f(val) {
    return "object" == typeof val;
}
function $d255760e1170f211$export$b451353ebd749597(val) {
    return "function" == typeof val;
}

});


parcelRegister("7lXuI", function(module, exports) {

$parcel$export(module.exports, "default", () => $55a8a4ed8f963b43$export$2e2bcd8739ae039);
//import { promise as Promise } from "../polyfill.js";

var $i3Bki = parcelRequire("i3Bki");

var $6KmHx = parcelRequire("6KmHx");
let pid = 0;
/**
 * @param {Object=} options
 * @constructor
 */ function WorkerIndex(options) {
    if (!(this instanceof WorkerIndex)) return new WorkerIndex(options);
    let opt;
    if (options) {
        if ((0, $i3Bki.is_function)(opt = options.encode)) options.encode = opt.toString();
    } else options = {};
    // the factory is the outer wrapper from the build
    // we use "self" as a trap for node.js
    let factory = (self || window)._factory;
    if (factory) factory = factory.toString();
    const is_node_js = "undefined" == typeof window && self.exports, _self = this;
    this.worker = create(factory, is_node_js, options.worker);
    this.resolver = (0, $i3Bki.create_object)();
    if (!this.worker) return;
    if (is_node_js) this.worker.on("message", function(msg) {
        _self.resolver[msg.id](msg.msg);
        delete _self.resolver[msg.id];
    });
    else this.worker.onmessage = function(msg) {
        msg = msg.data;
        _self.resolver[msg.id](msg.msg);
        delete _self.resolver[msg.id];
    };
    this.worker.postMessage({
        task: "init",
        factory: factory,
        options: options
    });
}
var $55a8a4ed8f963b43$export$2e2bcd8739ae039 = WorkerIndex;
register("add");
register("append");
register("search");
register("update");
register("remove");
function register(key) {
    WorkerIndex.prototype[key] = WorkerIndex.prototype[key + "Async"] = function() {
        const self1 = this, args = [].slice.call(arguments), arg = args[args.length - 1];
        let callback;
        if ((0, $i3Bki.is_function)(arg)) {
            callback = arg;
            args.splice(args.length - 1, 1);
        }
        const promise = new Promise(function(resolve) {
            setTimeout(function() {
                self1.resolver[++pid] = resolve;
                self1.worker.postMessage({
                    task: key,
                    id: pid,
                    args: args
                });
            });
        });
        if (callback) {
            promise.then(callback);
            return this;
        } else return promise;
    };
}
function create(factory, is_node_js, worker_path) {
    let worker;
    try {
        worker = is_node_js ? eval('new (require("worker_threads")["Worker"])(__dirname + "/node/node.js")') : factory ? new Worker(URL.createObjectURL(new Blob([
            "onmessage=" + (0, $6KmHx.default).toString()
        ], {
            type: "text/javascript"
        }))) : new Worker((0, $i3Bki.is_string)(worker_path) ? worker_path : "worker/worker.js", {
            type: "module"
        });
    } catch (e) {}
    return worker;
}

});
parcelRegister("6KmHx", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e98a5ef11268487$export$2e2bcd8739ae039);

var $7Sysm = parcelRequire("7Sysm");
function $4e98a5ef11268487$export$2e2bcd8739ae039(data) {
    data = data.data;
    /** @type Index */ const index = self._index, args = data.args, task = data.task;
    switch(task){
        case "init":
            const options = data.options || {}, factory = data.factory, encode = options.encode;
            options.cache = /* normalize: */ /* collapse: */ /* normalize: */ /* collapse: */ /* normalize: */ /* collapse: */ /* normalize: */ /* collapse: */ /* collapse: */ !1;
            if (encode && 0 === encode.indexOf("function")) options.encode = Function("return " + encode)();
            if (factory) {
                // export the FlexSearch global payload to "self"
                Function("return " + factory)()(self);
                /** @type Index */ self._index = new self.FlexSearch.Index(options);
                // destroy the exported payload
                delete self.FlexSearch;
            } else self._index = new (0, $7Sysm.default)(options);
            break;
        default:
            const id = data.id, message = index[task].apply(index, args);
            postMessage("search" === task ? {
                id: id,
                msg: message
            } : {
                id: id
            });
    }
}

});
parcelRegister("7Sysm", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bc84de699ab5c0e$export$2e2bcd8739ae039);
/**!
 * FlexSearch.js
 * Author and Copyright: Thomas Wilkerling
 * Licence: Apache-2.0
 * Hosted by Nextapps GmbH
 * https://github.com/nextapps-de/flexsearch
 */ parcelRequire("kCqCN");

var $9Xzy7 = parcelRequire("9Xzy7");

var $i3Bki = parcelRequire("i3Bki");

var $3qgcu = parcelRequire("3qgcu");

var $dLKCm = parcelRequire("dLKCm");

var $2Uxqa = parcelRequire("2Uxqa");

var $5LjRe = parcelRequire("5LjRe");

var $k9egy = parcelRequire("k9egy");

var $bGlnC = parcelRequire("bGlnC");

var $cuQ14 = parcelRequire("cuQ14");
/**
 * @constructor
 * @implements IndexInterface
 * @param {Object=} options
 * @param {Object=} _register
 * @return {Index}
 */ function $5bc84de699ab5c0e$var$Index(options, _register) {
    if (!(this instanceof $5bc84de699ab5c0e$var$Index)) return new $5bc84de699ab5c0e$var$Index(options);
    let charset, lang, tmp;
    if (options) {
        options = (0, $bGlnC.default)(options);
        charset = options.charset;
        lang = options.lang;
        if ((0, $i3Bki.is_string)(charset)) {
            if (-1 === charset.indexOf(":")) charset += ":default";
            charset = (0, $dLKCm.global_charset)[charset];
        }
        if ((0, $i3Bki.is_string)(lang)) lang = (0, $dLKCm.global_lang)[lang];
    } else options = {};
    let resolution, optimize, context = options.context || {};
    this.encode = options.encode || charset && charset.encode || (0, $9Xzy7.encode);
    this.register = _register || (0, $i3Bki.create_object)();
    this.resolution = resolution = options.resolution || 9;
    this.tokenize = tmp = charset && charset.tokenize || options.tokenize || "strict";
    this.depth = "strict" === tmp && context.depth;
    this.bidirectional = (0, $i3Bki.parse_option)(context.bidirectional, /* append: */ /* skip update: */ /* skip_update: */ !0);
    this.optimize = optimize = (0, $i3Bki.parse_option)(options.optimize, !0);
    this.fastupdate = (0, $i3Bki.parse_option)(options.fastupdate, !0);
    this.minlength = options.minlength || 1;
    this.boost = options.boost;
    // when not using the memory strategy the score array should not pre-allocated to its full length
    this.map = optimize ? (0, $i3Bki.create_object_array)(resolution) : (0, $i3Bki.create_object)();
    this.resolution_ctx = resolution = context.resolution || 1;
    this.ctx = optimize ? (0, $i3Bki.create_object_array)(resolution) : (0, $i3Bki.create_object)();
    this.rtl = charset && charset.rtl || options.rtl;
    this.matcher = (tmp = options.matcher || lang && lang.matcher) && (0, $3qgcu.init_stemmer_or_matcher)(tmp, !1);
    this.stemmer = (tmp = options.stemmer || lang && lang.stemmer) && (0, $3qgcu.init_stemmer_or_matcher)(tmp, !0);
    this.filter = (tmp = options.filter || lang && lang.filter) && (0, $3qgcu.init_filter)(tmp);
    this.cache = (tmp = options.cache) && new (0, $k9egy.default)(tmp);
}
var $5bc84de699ab5c0e$export$2e2bcd8739ae039 = $5bc84de699ab5c0e$var$Index;
//Index.prototype.pipeline = pipeline;
/**
 * @param {!number|string} id
 * @param {!string} content
 */ $5bc84de699ab5c0e$var$Index.prototype.append = function(id, content) {
    return this.add(id, content, !0);
};
// TODO:
// string + number as text
// boolean, null, undefined as ?
/**
 * @param {!number|string} id
 * @param {!string} content
 * @param {boolean=} _append
 * @param {boolean=} _skip_update
 */ $5bc84de699ab5c0e$var$Index.prototype.add = function(id, content, _append, _skip_update) {
    if (content && (id || 0 === id)) {
        if (!_skip_update && !_append && this.register[id]) return this.update(id, content);
        content = this.encode("" + content);
        const length = content.length;
        if (length) {
            // check context dupes to skip all contextual redundancy along a document
            const dupes_ctx = (0, $i3Bki.create_object)(), dupes = (0, $i3Bki.create_object)(), depth = this.depth, resolution = this.resolution;
            for(let i = 0; i < length; i++){
                let term = content[this.rtl ? length - 1 - i : i], term_length = term.length;
                // skip dupes will break the context chain
                if (term && term_length >= this.minlength && (depth || !dupes[term])) {
                    let score = $5bc84de699ab5c0e$var$get_score(resolution, length, i), token = "";
                    switch(this.tokenize){
                        case "full":
                            if (2 < term_length) {
                                for(let x = 0; x < term_length; x++){
                                    for(let y = term_length; y > x; y--)if (y - x >= this.minlength) {
                                        const partial_score = $5bc84de699ab5c0e$var$get_score(resolution, length, i, term_length, x);
                                        token = term.substring(x, y);
                                        this.push_index(dupes, token, partial_score, id, _append);
                                    }
                                }
                                break;
                            }
                        // fallthrough to next case when term length < 3
                        case "reverse":
                            // skip last round (this token exist already in "forward")
                            if (1 < term_length) {
                                for(let x = term_length - 1; 0 < x; x--){
                                    token = term[x] + token;
                                    if (token.length >= this.minlength) {
                                        const partial_score = $5bc84de699ab5c0e$var$get_score(resolution, length, i, term_length, x);
                                        this.push_index(dupes, token, partial_score, id, _append);
                                    }
                                }
                                token = "";
                            }
                        // fallthrough to next case to apply forward also
                        case "forward":
                            if (1 < term_length) {
                                for(let x = 0; x < term_length; x++){
                                    token += term[x];
                                    if (token.length >= this.minlength) this.push_index(dupes, token, score, id, _append);
                                }
                                break;
                            }
                        // fallthrough to next case when token has a length of 1
                        default:
                            // case "strict":
                            if (this.boost) score = Math.min(0 | score / this.boost(content, term, i), resolution - 1);
                            this.push_index(dupes, term, score, id, _append);
                            // context is just supported by tokenizer "strict"
                            if (depth) {
                                if (1 < length && i < length - 1) {
                                    // check inner dupes to skip repeating words in the current context
                                    const dupes_inner = (0, $i3Bki.create_object)(), resolution = this.resolution_ctx, keyword = term, size = Math.min(depth + 1, length - i);
                                    dupes_inner[keyword] = 1;
                                    for(let x = 1; x < size; x++){
                                        term = content[this.rtl ? length - 1 - i - x : i + x];
                                        if (term && term.length >= this.minlength && !dupes_inner[term]) {
                                            dupes_inner[term] = 1;
                                            const context_score = $5bc84de699ab5c0e$var$get_score(resolution + (length / 2 > resolution ? 0 : 1), length, i, size - 1, x - 1), swap = this.bidirectional && term > keyword;
                                            this.push_index(dupes_ctx, swap ? keyword : term, context_score, id, _append, swap ? term : keyword);
                                        }
                                    }
                                }
                            }
                    }
                }
            }
            this.fastupdate || (this.register[id] = 1);
        }
    }
    return this;
};
/**
 * @param {number} resolution
 * @param {number} length
 * @param {number} i
 * @param {number=} term_length
 * @param {number=} x
 * @returns {number}
 */ function $5bc84de699ab5c0e$var$get_score(resolution, length, i, term_length, x) {
    // console.log("resolution", resolution);
    // console.log("length", length);
    // console.log("term_length", term_length);
    // console.log("i", i);
    // console.log("x", x);
    // console.log((resolution - 1) / (length + (term_length || 0)) * (i + (x || 0)) + 1);
    // the first resolution slot is reserved for the best match,
    // when a query matches the first word(s).
    // also to stretch score to the whole range of resolution, the
    // calculation is shift by one and cut the floating point.
    // this needs the resolution "1" to be handled additionally.
    // do not stretch the resolution more than the term length will
    // improve performance and memory, also it improves scoring in
    // most cases between a short document and a long document
    return i && 1 < resolution ? length + (term_length || 0) <= resolution ? i + (x || 0) : 0 | (resolution - 1) / (length + (term_length || 0)) * (i + (x || 0)) + 1 : 0;
}
/**
 * @private
 * @param dupes
 * @param value
 * @param score
 * @param id
 * @param {boolean=} append
 * @param {string=} keyword
 */ $5bc84de699ab5c0e$var$Index.prototype.push_index = function(dupes, value, score, id, append, keyword) {
    let arr = keyword ? this.ctx : this.map;
    if (!dupes[value] || keyword && !dupes[value][keyword]) {
        if (this.optimize) arr = arr[score];
        if (keyword) {
            dupes = dupes[value] || (dupes[value] = (0, $i3Bki.create_object)());
            dupes[keyword] = 1;
            arr = arr[keyword] || (arr[keyword] = (0, $i3Bki.create_object)());
        } else dupes[value] = 1;
        arr = arr[value] || (arr[value] = []);
        if (!this.optimize) arr = arr[score] || (arr[score] = []);
        if (!append || !arr.includes(id)) {
            arr[arr.length] = id;
            // add a reference to the register for fast updates
            if (this.fastupdate) {
                const tmp = this.register[id] || (this.register[id] = []);
                tmp[tmp.length] = arr;
            }
        }
    }
};
/**
 * @param {string|Object} query
 * @param {number|Object=} limit
 * @param {Object=} options
 * @returns {Array<number|string>}
 */ $5bc84de699ab5c0e$var$Index.prototype.search = function(query, limit, options) {
    if (!options) {
        if (!limit && (0, $i3Bki.is_object)(query)) {
            options = /** @type {Object} */ query;
            query = options.query;
        } else if ((0, $i3Bki.is_object)(limit)) options = /** @type {Object} */ limit;
    }
    let result = [], length, context, suggest, offset = 0;
    if (options) {
        query = options.query || query;
        limit = options.limit;
        offset = options.offset || 0;
        context = options.context;
        suggest = options.suggest;
    }
    if (query) {
        query = /** @type {Array} */ this.encode("" + query);
        length = query.length;
        // TODO: solve this in one single loop below
        if (1 < length) {
            const dupes = (0, $i3Bki.create_object)(), query_new = [];
            for(let i = 0, count = 0, term; i < length; i++){
                term = query[i];
                if (term && term.length >= this.minlength && !dupes[term]) {
                    // this fast path can just apply when not in memory-optimized mode
                    if (!this.optimize && !suggest && !this.map[term]) // fast path "not found"
                    return result;
                    else {
                        query_new[count++] = term;
                        dupes[term] = 1;
                    }
                }
            }
            query = query_new;
            length = query.length;
        }
    }
    if (!length) return result;
    limit || (limit = 100);
    let depth = this.depth && 1 < length && !1 !== context, index = 0, keyword;
    if (depth) {
        keyword = query[0];
        index = 1;
    } else if (1 < length) query.sort((0, $i3Bki.sort_by_length_down));
    for(let arr, term; index < length; index++){
        term = query[index];
        // console.log(keyword);
        // console.log(term);
        // console.log("");
        if (depth) {
            arr = this.add_result(result, suggest, limit, offset, 2 === length, term, keyword);
            // console.log(arr);
            // console.log(result);
            // when suggestion enabled just forward keyword if term was found
            // as long as the result is empty forward the pointer also
            if (!suggest || !1 !== arr || !result.length) keyword = term;
        } else arr = this.add_result(result, suggest, limit, offset, 1 === length, term);
        if (arr) return /** @type {Array<number|string>} */ arr;
        // apply suggestions on last loop or fallback
        if (suggest && index == length - 1) {
            let length = result.length;
            if (!length) {
                if (depth) {
                    // fallback to non-contextual search when no result was found
                    depth = 0;
                    index = -1;
                    continue;
                }
                return result;
            } else if (1 === length) // fast path optimization
            return $5bc84de699ab5c0e$var$single_result(result[0], limit, offset);
        }
    }
    return (0, $5LjRe.intersect)(result, limit, offset, suggest);
};
/**
 * Returns an array when the result is done (to stop the process immediately),
 * returns false when suggestions is enabled and no result was found,
 * or returns nothing when a set was pushed successfully to the results
 *
 * @private
 * @param {Array} result
 * @param {Array} suggest
 * @param {number} limit
 * @param {number} offset
 * @param {boolean} single_term
 * @param {string} term
 * @param {string=} keyword
 * @return {Array<Array<string|number>>|boolean|undefined}
 */ $5bc84de699ab5c0e$var$Index.prototype.add_result = function(result, suggest, limit, offset, single_term, term, keyword) {
    let word_arr = [], arr = keyword ? this.ctx : this.map;
    if (!this.optimize) arr = $5bc84de699ab5c0e$var$get_array(arr, term, keyword, this.bidirectional);
    if (arr) {
        let count = 0;
        const arr_len = Math.min(arr.length, keyword ? this.resolution_ctx : this.resolution);
        // relevance:
        for(let x = 0, size = 0, tmp, len; x < arr_len; x++){
            tmp = arr[x];
            if (tmp) {
                if (this.optimize) tmp = $5bc84de699ab5c0e$var$get_array(tmp, term, keyword, this.bidirectional);
                if (offset) {
                    if (tmp && single_term) {
                        len = tmp.length;
                        if (len <= offset) {
                            offset -= len;
                            tmp = null;
                        } else {
                            tmp = tmp.slice(offset);
                            offset = 0;
                        }
                    }
                }
                if (tmp) {
                    // keep score (sparse array):
                    //word_arr[x] = tmp;
                    // simplified score order:
                    word_arr[count++] = tmp;
                    if (single_term) {
                        size += tmp.length;
                        if (size >= limit) break;
                    }
                }
            }
        }
        if (count) {
            if (single_term) // fast path optimization
            // offset was already applied at this point
            return $5bc84de699ab5c0e$var$single_result(word_arr, limit, 0);
            result[result.length] = word_arr;
            return;
        }
    }
    // return an empty array will stop the loop,
    // to prevent stop when using suggestions return a false value
    return !suggest && word_arr;
};
function $5bc84de699ab5c0e$var$single_result(result, limit, offset) {
    if (1 === result.length) result = result[0];
    else result = (0, $i3Bki.concat)(result);
    return offset || result.length > limit ? result.slice(offset, offset + limit) : result;
}
function $5bc84de699ab5c0e$var$get_array(arr, term, keyword, bidirectional) {
    if (keyword) {
        // the frequency of the starting letter is slightly less
        // on the last half of the alphabet (m-z) in almost every latin language,
        // so we sort downwards (https://en.wikipedia.org/wiki/Letter_frequency)
        const swap = bidirectional && term > keyword;
        arr = arr[swap ? term : keyword];
        arr = arr && arr[swap ? keyword : term];
    } else arr = arr[term];
    return arr;
}
$5bc84de699ab5c0e$var$Index.prototype.contain = function(id) {
    return !!this.register[id];
};
$5bc84de699ab5c0e$var$Index.prototype.update = function(id, content) {
    return this.remove(id).add(id, content);
};
/**
 * @param {boolean=} _skip_deletion
 */ $5bc84de699ab5c0e$var$Index.prototype.remove = function(id, _skip_deletion) {
    const refs = this.register[id];
    if (refs) {
        if (this.fastupdate) // fast updates performs really fast but did not fully cleanup the key entries
        for(let i = 0, tmp; i < refs.length; i++){
            tmp = refs[i];
            tmp.splice(tmp.indexOf(id), 1);
        }
        else {
            $5bc84de699ab5c0e$var$remove_index(this.map, id, this.resolution, this.optimize);
            if (this.depth) $5bc84de699ab5c0e$var$remove_index(this.ctx, id, this.resolution_ctx, this.optimize);
        }
        _skip_deletion || delete this.register[id];
        if (this.cache) this.cache.del(id);
    }
    return this;
};
/**
 * @param map
 * @param id
 * @param res
 * @param optimize
 * @param {number=} resolution
 * @return {number}
 */ function $5bc84de699ab5c0e$var$remove_index(map, id, res, optimize, resolution) {
    let count = 0;
    if ((0, $i3Bki.is_array)(map)) {
        // the first array is the score array in both strategies
        if (!resolution) {
            resolution = Math.min(map.length, res);
            for(let x = 0, arr; x < resolution; x++){
                arr = map[x];
                if (arr) {
                    count = $5bc84de699ab5c0e$var$remove_index(arr, id, res, optimize, resolution);
                    if (!optimize && !count) // when not memory optimized the score index should removed
                    delete map[x];
                }
            }
        } else {
            const pos = map.indexOf(id);
            if (-1 !== pos) // fast path, when length is 1 or lower then the whole field gets deleted
            {
                if (1 < map.length) {
                    map.splice(pos, 1);
                    count++;
                }
            } else count++;
        }
    } else for(let key in map){
        count = $5bc84de699ab5c0e$var$remove_index(map[key], id, res, optimize, resolution);
        if (!count) delete map[key];
    }
    return count;
}
$5bc84de699ab5c0e$var$Index.prototype.searchCache = (0, $k9egy.searchCache);
$5bc84de699ab5c0e$var$Index.prototype.export = (0, $cuQ14.exportIndex);
$5bc84de699ab5c0e$var$Index.prototype.import = (0, $cuQ14.importIndex);
(0, $2Uxqa.default)($5bc84de699ab5c0e$var$Index.prototype);

});
parcelRegister("9Xzy7", function(module, exports) {

$parcel$export(module.exports, "encode", () => $740533145f48400d$export$c564cdbbe6da493);
parcelRequire("kCqCN");

var $3qgcu = parcelRequire("3qgcu");
const $740533145f48400d$export$270f8a265cdb7a58 = /* normalize: */ /* collapse: */ /* normalize: */ /* collapse: */ /* normalize: */ /* collapse: */ /* normalize: */ /* collapse: */ !1;
const $740533145f48400d$export$660b2ee2d4fb4eff = "";
var $740533145f48400d$export$2e2bcd8739ae039 = {
    encode: $740533145f48400d$export$c564cdbbe6da493,
    rtl: !1,
    tokenize: ""
};
function $740533145f48400d$export$c564cdbbe6da493(str) {
    return (0, $3qgcu.pipeline).call(this, /* string: */ ("" + str).toLowerCase(), !1, /* split: */ (0, $3qgcu.regex_whitespace), !1);
}

});

parcelRegister("dLKCm", function(module, exports) {

$parcel$export(module.exports, "global_lang", () => $a063d36e8f690dec$export$240dd687449f055c);
$parcel$export(module.exports, "global_charset", () => $a063d36e8f690dec$export$c63ff56643f09e5d);
const $a063d36e8f690dec$export$240dd687449f055c = {};
const $a063d36e8f690dec$export$c63ff56643f09e5d = {};
function $a063d36e8f690dec$export$69dee88f152bef8d(name, charset) {
    $a063d36e8f690dec$export$c63ff56643f09e5d[name] = charset;
}
function $a063d36e8f690dec$export$b5daeabefb05ee6b(name, lang) {
    $a063d36e8f690dec$export$240dd687449f055c[name] = lang;
}

});

parcelRegister("2Uxqa", function(module, exports) {

$parcel$export(module.exports, "default", () => $21eabc7251f50121$export$2e2bcd8739ae039);
parcelRequire("kCqCN");

var $i3Bki = parcelRequire("i3Bki");
function $21eabc7251f50121$export$2e2bcd8739ae039(prototype) {
    $21eabc7251f50121$var$register(prototype, "add");
    $21eabc7251f50121$var$register(prototype, "append");
    $21eabc7251f50121$var$register(prototype, "search");
    $21eabc7251f50121$var$register(prototype, "update");
    $21eabc7251f50121$var$register(prototype, "remove");
}
function $21eabc7251f50121$var$register(prototype, key) {
    prototype[key + "Async"] = function() {
        /** @type {IndexInterface|DocumentInterface} */ const self = this, args = /*[].slice.call*/ arguments, arg = args[args.length - 1];
        let callback;
        if ((0, $i3Bki.is_function)(arg)) {
            callback = arg;
            delete args[args.length - 1];
        }
        const promise = new Promise(function(resolve) {
            setTimeout(function() {
                self.async = !0;
                const res = self[key].apply(self, args);
                self.async = !1;
                resolve(res);
            });
        });
        if (callback) {
            promise.then(callback);
            return this;
        } else return promise;
    };
}

});

parcelRegister("5LjRe", function(module, exports) {

$parcel$export(module.exports, "intersect", () => $4320bed38a12c3c0$export$1f4807a235930d45);
$parcel$export(module.exports, "intersect_union", () => $4320bed38a12c3c0$export$b1044624651dae94);

var $i3Bki = parcelRequire("i3Bki");
function $4320bed38a12c3c0$export$1f4807a235930d45(arrays, limit, offset, suggest) {
    const length = arrays.length;
    let result = [], check, check_suggest, size = 0;
    if (suggest) suggest = [];
    // process terms in reversed order often has advantage for the fast path "end reached".
    // also a reversed order prioritize the order of words from a query.
    for(let x = length - 1; 0 <= x; x--){
        const word_arr = arrays[x], word_arr_len = word_arr.length, check_new = (0, $i3Bki.create_object)();
        let found = !check;
        // process relevance in forward order (direction is
        // important for adding IDs during the last round)
        for(let y = 0; y < word_arr_len; y++){
            const arr = word_arr[y], arr_len = arr.length;
            if (arr_len) // loop through IDs
            for(let z = 0, check_idx, id; z < arr_len; z++){
                id = arr[z];
                if (check) {
                    if (check[id]) {
                        // check if in last round
                        if (!x) {
                            if (offset) offset--;
                            else {
                                result[size++] = id;
                                if (size === limit) // fast path "end reached"
                                return result;
                            }
                        }
                        if (x || suggest) check_new[id] = 1;
                        found = /* append: */ /* skip update: */ /* skip_update: */ !0;
                    }
                    if (suggest) {
                        check_idx = (check_suggest[id] || 0) + 1;
                        check_suggest[id] = check_idx;
                        // do not adding IDs which are already included in the result (saves one loop)
                        // the first intersection match has the check index 2, so shift by -2
                        if (check_idx < length) {
                            const tmp = suggest[check_idx - 2] || (suggest[check_idx - 2] = []);
                            tmp[tmp.length] = id;
                        }
                    }
                } else // pre-fill in first round
                check_new[id] = 1;
            }
        }
        if (suggest) // re-use the first pre-filled check for suggestions
        check || (check_suggest = check_new);
        else if (!found) return [];
        check = check_new;
    }
    if (suggest) // needs to iterate in reverse direction
    for(let x = suggest.length - 1, arr, len; 0 <= x; x--){
        arr = suggest[x];
        len = arr.length;
        for(let y = 0, id; y < len; y++){
            id = arr[y];
            if (!check[id]) {
                if (offset) offset--;
                else {
                    result[size++] = id;
                    if (size === limit) // fast path "end reached"
                    return result;
                }
                check[id] = 1;
            }
        }
    }
    return result;
}
function $4320bed38a12c3c0$export$b1044624651dae94(mandatory, arrays) {
    const check = (0, $i3Bki.create_object)(), union = (0, $i3Bki.create_object)(), result = [];
    for(let x = 0; x < mandatory.length; x++)check[mandatory[x]] = 1;
    for(let x = 0, arr; x < arrays.length; x++){
        arr = arrays[x];
        for(let y = 0, id; y < arr.length; y++){
            id = arr[y];
            if (check[id]) {
                if (!union[id]) {
                    union[id] = 1;
                    result[result.length] = id;
                }
            }
        }
    }
    return result;
}

});

parcelRegister("k9egy", function(module, exports) {

$parcel$export(module.exports, "default", () => $eaafb6d3e5bdec58$export$2e2bcd8739ae039);
$parcel$export(module.exports, "searchCache", () => $eaafb6d3e5bdec58$export$393c0f7a9d25469);
parcelRequire("kCqCN");

var $i3Bki = parcelRequire("i3Bki");
/**
 * @param {boolean|number=} limit
 * @constructor
 */ function $eaafb6d3e5bdec58$var$CacheClass(limit) {
    /** @private */ this.limit = !0 !== limit && limit;
    /** @private */ this.cache = (0, $i3Bki.create_object)();
    /** @private */ this.queue = [];
//this.clear();
}
var $eaafb6d3e5bdec58$export$2e2bcd8739ae039 = $eaafb6d3e5bdec58$var$CacheClass;
function $eaafb6d3e5bdec58$export$393c0f7a9d25469(query, limit, options) {
    if ((0, $i3Bki.is_object)(query)) query = query.query;
    let cache = this.cache.get(query);
    if (!cache) {
        cache = this.search(query, limit, options);
        this.cache.set(query, cache);
    }
    return cache;
}
// CacheClass.prototype.clear = function(){
//
//     /** @private */
//     this.cache = create_object();
//
//     /** @private */
//     this.queue = [];
// };
$eaafb6d3e5bdec58$var$CacheClass.prototype.set = function(key, value) {
    if (!this.cache[key]) {
        // it is just a shame that native function array.shift() performs so bad
        // const length = this.queue.length;
        //
        // this.queue[length] = key;
        //
        // if(length === this.limit){
        //
        //     delete this.cache[this.queue.shift()];
        // }
        // the same bad performance
        // this.queue.unshift(key);
        //
        // if(this.queue.length === this.limit){
        //
        //     this.queue.pop();
        // }
        // fast implementation variant
        // let length = this.queue.length;
        //
        // if(length === this.limit){
        //
        //     length--;
        //
        //     delete this.cache[this.queue[0]];
        //
        //     for(let x = 0; x < length; x++){
        //
        //         this.queue[x] = this.queue[x + 1];
        //     }
        // }
        //
        // this.queue[length] = key;
        // current fastest implementation variant
        // theoretically that should not perform better compared to the example above
        let length = this.queue.length;
        if (length === this.limit) delete this.cache[this.queue[length - 1]];
        else length++;
        for(let x = length - 1; 0 < x; x--)this.queue[x] = this.queue[x - 1];
        this.queue[0] = key;
    }
    this.cache[key] = value;
};
$eaafb6d3e5bdec58$var$CacheClass.prototype.get = function(key) {
    const cache = this.cache[key];
    if (this.limit && cache) {
        // probably the indexOf() method performs faster when matched content is on front (left-to-right)
        // using lastIndexOf() does not help, it performs almost slower
        const pos = this.queue.indexOf(key);
        // if(pos < this.queue.length - 1){
        //
        //     const tmp = this.queue[pos];
        //     this.queue[pos] = this.queue[pos + 1];
        //     this.queue[pos + 1] = tmp;
        // }
        if (pos) {
            const tmp = this.queue[pos - 1];
            this.queue[pos - 1] = this.queue[pos];
            this.queue[pos] = tmp;
        }
    }
    return cache;
};
$eaafb6d3e5bdec58$var$CacheClass.prototype.del = function(id) {
    for(let i = 0, item, key; i < this.queue.length; i++){
        key = this.queue[i];
        item = this.cache[key];
        if (item.includes(id)) {
            this.queue.splice(i--, 1);
            delete this.cache[key];
        }
    }
};

});

parcelRegister("bGlnC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8814338b07de752d$export$2e2bcd8739ae039);

var $i3Bki = parcelRequire("i3Bki");
/**
 * @enum {Object}
 * @const
 */ const $8814338b07de752d$var$preset = {
    memory: {
        charset: "latin:extra",
        //tokenize: "strict",
        resolution: 3,
        //threshold: 0,
        minlength: 4,
        fastupdate: /* normalize: */ /* collapse: */ /* normalize: */ /* collapse: */ /* normalize: */ /* collapse: */ /* normalize: */ /* collapse: */ /* collapse: */ !1
    },
    performance: {
        //charset: "latin",
        //tokenize: "strict",
        resolution: 3,
        minlength: 3,
        //fastupdate: true,
        optimize: !1,
        context: {
            depth: 2,
            resolution: 1
        }
    },
    match: {
        charset: "latin:extra",
        tokenize: "reverse"
    },
    score: {
        charset: "latin:advanced",
        //tokenize: "strict",
        resolution: 20,
        minlength: 3,
        context: {
            depth: 3,
            resolution: 9
        }
    },
    default: {
    }
};
function $8814338b07de752d$export$2e2bcd8739ae039(options) {
    if ((0, $i3Bki.is_string)(options)) options = $8814338b07de752d$var$preset[options];
    else {
        const preset = options.preset;
        if (preset) options = Object.assign({}, preset[preset], /** @type {Object} */ options);
    }
    return options;
}

});

parcelRegister("cuQ14", function(module, exports) {

$parcel$export(module.exports, "exportIndex", () => $9190a2b4bcf1fa00$export$66227b8d5ad2b105);
$parcel$export(module.exports, "importIndex", () => $9190a2b4bcf1fa00$export$c4d30ad25f71cbb5);
$parcel$export(module.exports, "exportDocument", () => $9190a2b4bcf1fa00$export$c839107fc6c8e852);
$parcel$export(module.exports, "importDocument", () => $9190a2b4bcf1fa00$export$c03643075c5562f3);
// TODO return promises instead of inner await
parcelRequire("kCqCN");

var $i3Bki = parcelRequire("i3Bki");
function $9190a2b4bcf1fa00$var$async(callback, self, field, key, index_doc, index, data, on_done) {
    setTimeout(function() {
        const res = callback(field ? field + "." + key : key, JSON.stringify(data));
        // await isn't supported by ES5
        if (res && res.then) res.then(function() {
            self.export(callback, self, field, index_doc, index + 1, on_done);
        });
        else self.export(callback, self, field, index_doc, index + 1, on_done);
    });
}
function $9190a2b4bcf1fa00$export$66227b8d5ad2b105(callback, self, field, index_doc, index, on_done) {
    let return_value = /* append: */ /* skip update: */ /* skip_update: */ /* skip post-processing: */ !0;
    if ("undefined" == typeof on_done) return_value = new Promise((resolve)=>{
        on_done = resolve;
    });
    let key, data;
    switch(index || (index = 0)){
        case 0:
            key = "reg";
            // fastupdate isn't supported by export
            if (this.fastupdate) {
                data = (0, $i3Bki.create_object)();
                for(let key in this.register)data[key] = 1;
            } else data = this.register;
            break;
        case 1:
            key = "cfg";
            data = {
                doc: 0,
                opt: this.optimize ? 1 : 0
            };
            break;
        case 2:
            key = "map";
            data = this.map;
            break;
        case 3:
            key = "ctx";
            data = this.ctx;
            break;
        default:
            if ("undefined" == typeof field && on_done) on_done();
            return;
    }
    $9190a2b4bcf1fa00$var$async(callback, self || this, field, key, index_doc, index, data, on_done);
    return return_value;
}
function $9190a2b4bcf1fa00$export$c4d30ad25f71cbb5(key, data) {
    if (!data) return;
    if ((0, $i3Bki.is_string)(data)) data = JSON.parse(data);
    switch(key){
        case "cfg":
            this.optimize = !!data.opt;
            break;
        case "reg":
            // fastupdate isn't supported by import
            this.fastupdate = /* normalize: */ /* collapse: */ /* normalize: */ /* collapse: */ /* normalize: */ /* collapse: */ /* normalize: */ /* collapse: */ /* collapse: */ !1;
            this.register = data;
            break;
        case "map":
            this.map = data;
            break;
        case "ctx":
            this.ctx = data;
            break;
    }
}
function $9190a2b4bcf1fa00$export$c839107fc6c8e852(callback, self, field, index_doc, index, on_done) {
    let return_value;
    if ("undefined" == typeof on_done) return_value = new Promise((resolve)=>{
        on_done = resolve;
    });
    index || (index = 0);
    index_doc || (index_doc = 0);
    if (index_doc < this.field.length) {
        const field = this.field[index_doc], idx = this.index[field];
        self = this;
        setTimeout(function() {
            if (!idx.export(callback, self, index ? field /*.replace(":", "-")*/  : "", index_doc, index++, on_done)) {
                index_doc++;
                index = 1;
                self.export(callback, self, field, index_doc, index, on_done);
            }
        });
    } else {
        let key, data;
        switch(index){
            case 1:
                key = "tag";
                data = this.tagindex;
                field = null;
                break;
            case 2:
                key = "store";
                data = this.store;
                field = null;
                break;
            // case 3:
            //
            //     key = "reg";
            //     data = this.register;
            //     break;
            default:
                on_done();
                return;
        }
        $9190a2b4bcf1fa00$var$async(callback, this, field, key, index_doc, index, data, on_done);
    }
    return return_value;
}
function $9190a2b4bcf1fa00$export$c03643075c5562f3(key, data) {
    if (!data) return;
    if ((0, $i3Bki.is_string)(data)) data = JSON.parse(data);
    switch(key){
        case "tag":
            this.tagindex = data;
            break;
        case "reg":
            // fastupdate isn't supported by import
            this.fastupdate = !1;
            this.register = data;
            for(let i = 0, index; i < this.field.length; i++){
                index = this.index[this.field[i]];
                index.register = data;
                index.fastupdate = !1;
            }
            break;
        case "store":
            this.store = data;
            break;
        default:
            key = key.split(".");
            const field = key[0];
            key = key[1];
            if (field && key) this.index[field].import(key, data);
    }
}

});




parcelRegister("9gXoD", function(module, exports) {


module.exports = (parcelRequire("bJvU2"))((parcelRequire("fGVKa")).resolve("2FXpT")).then(()=>parcelRequire("eLlur"));

});
parcelRegister("bJvU2", function(module, exports) {
"use strict";

var $gxcWE = parcelRequire("gxcWE");
module.exports = $gxcWE(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("gxcWE", function(module, exports) {
"use strict";
var $c099c50a02fcb7bf$var$cachedBundles = {};
var $c099c50a02fcb7bf$var$cachedPreloads = {};
var $c099c50a02fcb7bf$var$cachedPrefetches = {};
function $c099c50a02fcb7bf$var$getCache(type) {
    switch(type){
        case "preload":
            return $c099c50a02fcb7bf$var$cachedPreloads;
        case "prefetch":
            return $c099c50a02fcb7bf$var$cachedPrefetches;
        default:
            return $c099c50a02fcb7bf$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $c099c50a02fcb7bf$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $d87d1b8acfa3e0be$exports = {};


(parcelRequire("fGVKa")).register((parcelRequire("6aWQp")).getBundleURL("bmSBP"), JSON.parse('["bmSBP","index.js","2FXpT","../js.306c58f7.js"]'));

/**
  reframe.js - Reframe.js: responsive iframes for embedded content
  @version v4.0.2
  @link https://github.com/yowainwright/reframe.ts#readme
  @author Jeff Wainwright <yowainwright@gmail.com> (http://jeffry.in)
  @license MIT
**/ /**
 * REFRAME.TS 🖼
 * ---
 * @param target
 * @param cName
 * @summary defines the height/width ratio of the targeted <element>
 */ function $dd19d2e942a38898$export$2e2bcd8739ae039(target, cName) {
    var _a, _b;
    var frames = typeof target === "string" ? document.querySelectorAll(target) : target;
    var c = cName || "js-reframe";
    if (!("length" in frames)) frames = [
        frames
    ];
    for(var i = 0; i < frames.length; i += 1){
        var frame = frames[i];
        var hasClass = frame.className.split(" ").indexOf(c) !== -1;
        if (hasClass || frame.style.width.indexOf("%") > -1) return;
        // get height width attributes
        var height = frame.getAttribute("height") || frame.offsetHeight;
        var width = frame.getAttribute("width") || frame.offsetWidth;
        var heightNumber = typeof height === "string" ? parseInt(height) : height;
        var widthNumber = typeof width === "string" ? parseInt(width) : width;
        // general targeted <element> sizes
        var padding = heightNumber / widthNumber * 100;
        // created element <wrapper> of general reframed item
        // => set necessary styles of created element <wrapper>
        var div = document.createElement("div");
        div.className = c;
        var divStyles = div.style;
        divStyles.position = "relative";
        divStyles.width = "100%";
        divStyles.paddingTop = "".concat(padding, "%");
        // set necessary styles of targeted <element>
        var frameStyle = frame.style;
        frameStyle.position = "absolute";
        frameStyle.width = "100%";
        frameStyle.height = "100%";
        frameStyle.left = "0";
        frameStyle.top = "0";
        // reframe targeted <element>
        (_a = frame.parentNode) === null || _a === void 0 || _a.insertBefore(div, frame);
        (_b = frame.parentNode) === null || _b === void 0 || _b.removeChild(frame);
        div.appendChild(frame);
    }
}


/**!
 * FlexSearch.js
 * Author and Copyright: Thomas Wilkerling
 * Licence: Apache-2.0
 * Hosted by Nextapps GmbH
 * https://github.com/nextapps-de/flexsearch
 */ 
var $7Sysm = parcelRequire("7Sysm");
parcelRequire("kCqCN");

var $k9egy = parcelRequire("k9egy");

var $i3Bki = parcelRequire("i3Bki");

var $2Uxqa = parcelRequire("2Uxqa");

var $5LjRe = parcelRequire("5LjRe");

var $cuQ14 = parcelRequire("cuQ14");

var $7lXuI = parcelRequire("7lXuI");
/**
 * @constructor
 * @implements {DocumentInterface}
 * @param {Object=} options
 * @return {Document}
 */ function $38a534f4d4b6ad2f$var$Document(options) {
    if (!(this instanceof $38a534f4d4b6ad2f$var$Document)) return new $38a534f4d4b6ad2f$var$Document(options);
    const document = options.document || options.doc || options;
    let opt;
    this.tree = [];
    this.field = [];
    this.marker = [];
    this.register = (0, $i3Bki.create_object)();
    this.key = (opt = document.key || document.id) && $38a534f4d4b6ad2f$var$parse_tree(opt, this.marker) || "id";
    this.fastupdate = (0, $i3Bki.parse_option)(options.fastupdate, /* append: */ /* skip update: */ /* skip_update: */ !0);
    this.storetree = (opt = document.store) && !0 !== opt && [];
    this.store = opt && (0, $i3Bki.create_object)();
    // TODO case-insensitive tags
    this.tag = (opt = document.tag) && $38a534f4d4b6ad2f$var$parse_tree(opt, this.marker);
    this.tagindex = opt && (0, $i3Bki.create_object)();
    this.cache = (opt = options.cache) && new (0, $k9egy.default)(opt);
    // do not apply cache again for the indexes
    options.cache = !1;
    this.worker = options.worker;
    // this switch is used by recall of promise callbacks
    this.async = !1;
    /** @export */ this.index = $38a534f4d4b6ad2f$var$parse_descriptor.call(this, options, document);
}
var $38a534f4d4b6ad2f$export$2e2bcd8739ae039 = $38a534f4d4b6ad2f$var$Document;
/**
 * @this Document
 */ function $38a534f4d4b6ad2f$var$parse_descriptor(options, document) {
    const index = (0, $i3Bki.create_object)();
    let field = document.index || document.field || document;
    if ((0, $i3Bki.is_string)(field)) field = [
        field
    ];
    for(let i = 0, key, opt; i < field.length; i++){
        key = field[i];
        if (!(0, $i3Bki.is_string)(key)) {
            opt = key;
            key = key.field;
        }
        opt = (0, $i3Bki.is_object)(opt) ? Object.assign({}, options, opt) : options;
        if (this.worker) {
            index[key] = new (0, $7lXuI.default)(opt);
            if (!index[key].worker) this.worker = !1;
        }
        if (!this.worker) index[key] = new (0, $7Sysm.default)(opt, this.register);
        this.tree[i] = $38a534f4d4b6ad2f$var$parse_tree(key, this.marker);
        this.field[i] = key;
    }
    if (this.storetree) {
        let store = document.store;
        if ((0, $i3Bki.is_string)(store)) store = [
            store
        ];
        for(let i = 0; i < store.length; i++)this.storetree[i] = $38a534f4d4b6ad2f$var$parse_tree(store[i], this.marker);
    }
    return index;
}
function $38a534f4d4b6ad2f$var$parse_tree(key, marker) {
    const tree = key.split(":");
    let count = 0;
    for(let i = 0; i < tree.length; i++){
        key = tree[i];
        if (0 <= key.indexOf("[]")) {
            key = key.substring(0, key.length - 2);
            if (key) marker[count] = !0;
        }
        if (key) tree[count++] = key;
    }
    if (count < tree.length) tree.length = count;
    return 1 < count ? tree : tree[0];
}
// TODO support generic function created from string when tree depth > 1
function $38a534f4d4b6ad2f$var$parse_simple(obj, tree) {
    if ((0, $i3Bki.is_string)(tree)) obj = obj[tree];
    else for(let i = 0; obj && i < tree.length; i++)obj = obj[tree[i]];
    return obj;
}
// TODO support generic function created from string when tree depth > 1
function $38a534f4d4b6ad2f$var$store_value(obj, store, tree, pos, key) {
    obj = obj[key];
    // reached target field
    if (pos === tree.length - 1) // store target value
    store[key] = obj;
    else if (obj) {
        if ((0, $i3Bki.is_array)(obj)) {
            store = store[key] = Array(obj.length);
            for(let i = 0; i < obj.length; i++)// do not increase pos (an array is not a field)
            $38a534f4d4b6ad2f$var$store_value(obj, store, tree, pos, i);
        } else {
            store = store[key] || (store[key] = (0, $i3Bki.create_object)());
            key = tree[++pos];
            $38a534f4d4b6ad2f$var$store_value(obj, store, tree, pos, key);
        }
    }
}
function $38a534f4d4b6ad2f$var$add_index(obj, tree, marker, pos, index, id, key, _append) {
    obj = obj[key];
    if (obj) {
        // reached target field
        if (pos === tree.length - 1) {
            // handle target value
            if ((0, $i3Bki.is_array)(obj)) {
                // append array contents so each entry gets a new scoring context
                if (marker[pos]) {
                    for(let i = 0; i < obj.length; i++)index.add(id, obj[i], !0, !0);
                    return;
                }
                // or join array contents and use one scoring context
                obj = obj.join(" ");
            }
            index.add(id, obj, _append, !0);
        } else {
            if ((0, $i3Bki.is_array)(obj)) for(let i = 0; i < obj.length; i++)// do not increase index, an array is not a field
            $38a534f4d4b6ad2f$var$add_index(obj, tree, marker, pos, index, id, i, _append);
            else {
                key = tree[++pos];
                $38a534f4d4b6ad2f$var$add_index(obj, tree, marker, pos, index, id, key, _append);
            }
        }
    }
}
/**
 *
 * @param id
 * @param content
 * @param {boolean=} _append
 * @returns {Document|Promise}
 */ $38a534f4d4b6ad2f$var$Document.prototype.add = function(id, content, _append) {
    if ((0, $i3Bki.is_object)(id)) {
        content = id;
        id = $38a534f4d4b6ad2f$var$parse_simple(content, this.key);
    }
    if (content && (id || 0 === id)) {
        if (!_append && this.register[id]) return this.update(id, content);
        for(let i = 0, tree, field; i < this.field.length; i++){
            field = this.field[i];
            tree = this.tree[i];
            if ((0, $i3Bki.is_string)(tree)) tree = [
                tree
            ];
            $38a534f4d4b6ad2f$var$add_index(content, tree, this.marker, 0, this.index[field], id, tree[0], _append);
        }
        if (this.tag) {
            let tag = $38a534f4d4b6ad2f$var$parse_simple(content, this.tag), dupes = (0, $i3Bki.create_object)();
            if ((0, $i3Bki.is_string)(tag)) tag = [
                tag
            ];
            for(let i = 0, key, arr; i < tag.length; i++){
                key = tag[i];
                if (!dupes[key]) {
                    dupes[key] = 1;
                    arr = this.tagindex[key] || (this.tagindex[key] = []);
                    if (!_append || !arr.includes(id)) {
                        arr[arr.length] = id;
                        // add a reference to the register for fast updates
                        if (this.fastupdate) {
                            const tmp = this.register[id] || (this.register[id] = []);
                            tmp[tmp.length] = arr;
                        }
                    }
                }
            }
        }
        // TODO: how to handle store when appending contents?
        if (this.store && (!_append || !this.store[id])) {
            let store;
            if (this.storetree) {
                store = (0, $i3Bki.create_object)();
                for(let i = 0, tree; i < this.storetree.length; i++){
                    tree = this.storetree[i];
                    if ((0, $i3Bki.is_string)(tree)) store[tree] = content[tree];
                    else $38a534f4d4b6ad2f$var$store_value(content, store, tree, 0, tree[0]);
                }
            }
            this.store[id] = store || content;
        }
    }
    return this;
};
$38a534f4d4b6ad2f$var$Document.prototype.append = function(id, content) {
    return this.add(id, content, !0);
};
$38a534f4d4b6ad2f$var$Document.prototype.update = function(id, content) {
    return this.remove(id).add(id, content);
};
$38a534f4d4b6ad2f$var$Document.prototype.remove = function(id) {
    if ((0, $i3Bki.is_object)(id)) id = $38a534f4d4b6ad2f$var$parse_simple(id, this.key);
    if (this.register[id]) {
        for(let i = 0; i < this.field.length; i++){
            // workers does not share the register
            this.index[this.field[i]].remove(id, !this.worker);
            if (this.fastupdate) break;
        }
        if (this.tag) {
            // when fastupdate was enabled all ids are already removed
            if (!this.fastupdate) for(let key in this.tagindex){
                const tag = this.tagindex[key], pos = tag.indexOf(id);
                if (-1 !== pos) {
                    if (1 < tag.length) tag.splice(pos, 1);
                    else delete this.tagindex[key];
                }
            }
        }
        if (this.store) delete this.store[id];
        delete this.register[id];
    }
    return this;
};
/**
 * @param {!string|Object} query
 * @param {number|Object=} limit
 * @param {Object=} options
 * @param {Array<Array>=} _resolve For internal use only.
 * @returns {Promise|Array}
 */ $38a534f4d4b6ad2f$var$Document.prototype.search = function(query, limit, options, _resolve) {
    if (!options) {
        if (!limit && (0, $i3Bki.is_object)(query)) {
            options = /** @type {Object} */ query;
            query = "";
        } else if ((0, $i3Bki.is_object)(limit)) {
            options = /** @type {Object} */ limit;
            limit = 0;
        }
    }
    let result = [], result_field = [], pluck, enrich, field, tag, bool, offset, count = 0;
    if (options) {
        if ((0, $i3Bki.is_array)(options)) {
            field = options;
            options = null;
        } else {
            query = options.query || query;
            pluck = options.pluck;
            field = pluck || options.index || options.field /*|| (is_string(options) && [options])*/ ;
            tag = options.tag;
            enrich = this.store && options.enrich;
            bool = "and" === options.bool;
            limit = options.limit || limit || 100;
            offset = options.offset || 0;
            if (tag) {
                if ((0, $i3Bki.is_string)(tag)) tag = [
                    tag
                ];
                // when tags is used and no query was set,
                // then just return the tag indexes
                if (!query) {
                    for(let i = 0, res; i < tag.length; i++){
                        res = $38a534f4d4b6ad2f$var$get_tag.call(this, tag[i], limit, offset, enrich);
                        if (res) {
                            result[result.length] = res;
                            count++;
                        }
                    }
                    return count ? result : [];
                }
            }
            if ((0, $i3Bki.is_string)(field)) field = [
                field
            ];
        }
    }
    field || (field = this.field);
    bool = bool && (1 < field.length || tag && 1 < tag.length);
    const promises = !_resolve && (this.worker || this.async) && [];
    // TODO solve this in one loop below
    for(let i = 0, res, key, len; i < field.length; i++){
        let field_options;
        key = field[i];
        if (!(0, $i3Bki.is_string)(key)) {
            field_options = key;
            key = field_options.field;
            query = field_options.query || query;
            limit = field_options.limit || limit;
            enrich = field_options.enrich || enrich;
        }
        if (promises) {
            promises[i] = this.index[key].searchAsync(query, limit, field_options || options);
            continue;
        } else if (_resolve) res = _resolve[i];
        else // inherit options also when search? it is just for laziness, Object.assign() has a cost
        res = this.index[key].search(query, limit, field_options || options);
        len = res && res.length;
        if (tag && len) {
            const arr = [];
            let count = 0;
            if (bool) // prepare for intersection
            arr[0] = [
                res
            ];
            for(let y = 0, key, res; y < tag.length; y++){
                key = tag[y];
                res = this.tagindex[key];
                len = res && res.length;
                if (len) {
                    count++;
                    arr[arr.length] = bool ? [
                        res
                    ] : res;
                }
            }
            if (count) {
                if (bool) res = (0, $5LjRe.intersect)(arr, limit || 100, offset || 0);
                else res = (0, $5LjRe.intersect_union)(res, arr);
                len = res.length;
            }
        }
        if (len) {
            result_field[count] = key;
            result[count++] = res;
        } else if (bool) return [];
    }
    if (promises) {
        const self = this;
        // anyone knows a better workaround of optionally having async promises?
        // the promise.all() needs to be wrapped into additional promise,
        // otherwise the recursive callback wouldn't run before return
        return new Promise(function(resolve) {
            Promise.all(promises).then(function(result) {
                resolve(self.search(query, limit, options, result));
            });
        });
    }
    if (!count) // fast path "not found"
    return [];
    if (pluck && (!enrich || !this.store)) // fast path optimization
    return result[0];
    for(let i = 0, res; i < result_field.length; i++){
        res = result[i];
        if (res.length) {
            if (enrich) res = $38a534f4d4b6ad2f$var$apply_enrich.call(this, res);
        }
        if (pluck) return res;
        result[i] = {
            field: result_field[i],
            result: res
        };
    }
    return result;
};
/**
 * @this Document
 */ function $38a534f4d4b6ad2f$var$get_tag(key, limit, offset) {
    let res = this.tagindex[key], len = res && res.length - offset;
}
/**
 * @this Document
 */ function $38a534f4d4b6ad2f$var$apply_enrich(res) {
    const arr = Array(res.length);
    for(let x = 0, id; x < res.length; x++){
        id = res[x];
        arr[x] = {
            id: id,
            doc: this.store[id]
        };
    }
    return arr;
}
$38a534f4d4b6ad2f$var$Document.prototype.contain = function(id) {
    return !!this.register[id];
};
$38a534f4d4b6ad2f$var$Document.prototype.get = function(id) {
    return this.store[id];
};
$38a534f4d4b6ad2f$var$Document.prototype.set = function(id, data) {
    this.store[id] = data;
    return this;
};
$38a534f4d4b6ad2f$var$Document.prototype.searchCache = (0, $k9egy.searchCache);
$38a534f4d4b6ad2f$var$Document.prototype.export = (0, $cuQ14.exportDocument);
$38a534f4d4b6ad2f$var$Document.prototype.import = (0, $cuQ14.importDocument);
(0, $2Uxqa.default)($38a534f4d4b6ad2f$var$Document.prototype);


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $1dfb7e498c728800$export$a143d493d941bafc;
var $1dfb7e498c728800$export$e4cf37d7f6fb9e0a;
var $1dfb7e498c728800$export$f99ded8fe4b79145;
var $1dfb7e498c728800$export$599f31c3813fae4d;
"use strict";
var $101abc5743447827$export$a48f0734ac7c2329;
var $101abc5743447827$export$d622b2ad8d90c771;
var $101abc5743447827$export$6100ba28696e12de;
"use strict";
$101abc5743447827$export$a48f0734ac7c2329 = $101abc5743447827$var$byteLength;
$101abc5743447827$export$d622b2ad8d90c771 = $101abc5743447827$var$toByteArray;
$101abc5743447827$export$6100ba28696e12de = $101abc5743447827$var$fromByteArray;
var $101abc5743447827$var$lookup = [];
var $101abc5743447827$var$revLookup = [];
var $101abc5743447827$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $101abc5743447827$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $101abc5743447827$var$i = 0, $101abc5743447827$var$len = $101abc5743447827$var$code.length; $101abc5743447827$var$i < $101abc5743447827$var$len; ++$101abc5743447827$var$i){
    $101abc5743447827$var$lookup[$101abc5743447827$var$i] = $101abc5743447827$var$code[$101abc5743447827$var$i];
    $101abc5743447827$var$revLookup[$101abc5743447827$var$code.charCodeAt($101abc5743447827$var$i)] = $101abc5743447827$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$101abc5743447827$var$revLookup["-".charCodeAt(0)] = 62;
$101abc5743447827$var$revLookup["_".charCodeAt(0)] = 63;
function $101abc5743447827$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $101abc5743447827$var$byteLength(b64) {
    var lens = $101abc5743447827$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $101abc5743447827$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $101abc5743447827$var$toByteArray(b64) {
    var tmp;
    var lens = $101abc5743447827$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $101abc5743447827$var$Arr($101abc5743447827$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $101abc5743447827$var$revLookup[b64.charCodeAt(i)] << 18 | $101abc5743447827$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $101abc5743447827$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $101abc5743447827$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $101abc5743447827$var$revLookup[b64.charCodeAt(i)] << 2 | $101abc5743447827$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $101abc5743447827$var$revLookup[b64.charCodeAt(i)] << 10 | $101abc5743447827$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $101abc5743447827$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $101abc5743447827$var$tripletToBase64(num) {
    return $101abc5743447827$var$lookup[num >> 18 & 0x3F] + $101abc5743447827$var$lookup[num >> 12 & 0x3F] + $101abc5743447827$var$lookup[num >> 6 & 0x3F] + $101abc5743447827$var$lookup[num & 0x3F];
}
function $101abc5743447827$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($101abc5743447827$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $101abc5743447827$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($101abc5743447827$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($101abc5743447827$var$lookup[tmp >> 2] + $101abc5743447827$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($101abc5743447827$var$lookup[tmp >> 10] + $101abc5743447827$var$lookup[tmp >> 4 & 0x3F] + $101abc5743447827$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $4f5c04605df79d9b$export$aafa59e2e03f2942;
var $4f5c04605df79d9b$export$68d8715fc104d294;
$4f5c04605df79d9b$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$4f5c04605df79d9b$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $1dfb7e498c728800$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$1dfb7e498c728800$export$a143d493d941bafc = $1dfb7e498c728800$var$Buffer;
$1dfb7e498c728800$export$e4cf37d7f6fb9e0a = $1dfb7e498c728800$var$SlowBuffer;
$1dfb7e498c728800$export$f99ded8fe4b79145 = 50;
const $1dfb7e498c728800$var$K_MAX_LENGTH = 0x7fffffff;
$1dfb7e498c728800$export$599f31c3813fae4d = $1dfb7e498c728800$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $1dfb7e498c728800$var$Buffer.TYPED_ARRAY_SUPPORT = $1dfb7e498c728800$var$typedArraySupport();
if (!$1dfb7e498c728800$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $1dfb7e498c728800$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($1dfb7e498c728800$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$1dfb7e498c728800$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($1dfb7e498c728800$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$1dfb7e498c728800$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $1dfb7e498c728800$var$createBuffer(length) {
    if (length > $1dfb7e498c728800$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $1dfb7e498c728800$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $1dfb7e498c728800$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $1dfb7e498c728800$var$allocUnsafe(arg);
    }
    return $1dfb7e498c728800$var$from(arg, encodingOrOffset, length);
}
$1dfb7e498c728800$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $1dfb7e498c728800$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $1dfb7e498c728800$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $1dfb7e498c728800$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($1dfb7e498c728800$var$isInstance(value, ArrayBuffer) || value && $1dfb7e498c728800$var$isInstance(value.buffer, ArrayBuffer)) return $1dfb7e498c728800$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($1dfb7e498c728800$var$isInstance(value, SharedArrayBuffer) || value && $1dfb7e498c728800$var$isInstance(value.buffer, SharedArrayBuffer))) return $1dfb7e498c728800$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $1dfb7e498c728800$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $1dfb7e498c728800$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $1dfb7e498c728800$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $1dfb7e498c728800$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $1dfb7e498c728800$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($1dfb7e498c728800$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($1dfb7e498c728800$var$Buffer, Uint8Array);
function $1dfb7e498c728800$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $1dfb7e498c728800$var$alloc(size, fill, encoding) {
    $1dfb7e498c728800$var$assertSize(size);
    if (size <= 0) return $1dfb7e498c728800$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $1dfb7e498c728800$var$createBuffer(size).fill(fill, encoding) : $1dfb7e498c728800$var$createBuffer(size).fill(fill);
    return $1dfb7e498c728800$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $1dfb7e498c728800$var$Buffer.alloc = function(size, fill, encoding) {
    return $1dfb7e498c728800$var$alloc(size, fill, encoding);
};
function $1dfb7e498c728800$var$allocUnsafe(size) {
    $1dfb7e498c728800$var$assertSize(size);
    return $1dfb7e498c728800$var$createBuffer(size < 0 ? 0 : $1dfb7e498c728800$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $1dfb7e498c728800$var$Buffer.allocUnsafe = function(size) {
    return $1dfb7e498c728800$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $1dfb7e498c728800$var$Buffer.allocUnsafeSlow = function(size) {
    return $1dfb7e498c728800$var$allocUnsafe(size);
};
function $1dfb7e498c728800$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$1dfb7e498c728800$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $1dfb7e498c728800$var$byteLength(string, encoding) | 0;
    let buf = $1dfb7e498c728800$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $1dfb7e498c728800$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $1dfb7e498c728800$var$checked(array.length) | 0;
    const buf = $1dfb7e498c728800$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $1dfb7e498c728800$var$fromArrayView(arrayView) {
    if ($1dfb7e498c728800$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $1dfb7e498c728800$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $1dfb7e498c728800$var$fromArrayLike(arrayView);
}
function $1dfb7e498c728800$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $1dfb7e498c728800$var$Buffer.prototype);
    return buf;
}
function $1dfb7e498c728800$var$fromObject(obj) {
    if ($1dfb7e498c728800$var$Buffer.isBuffer(obj)) {
        const len = $1dfb7e498c728800$var$checked(obj.length) | 0;
        const buf = $1dfb7e498c728800$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $1dfb7e498c728800$var$numberIsNaN(obj.length)) return $1dfb7e498c728800$var$createBuffer(0);
        return $1dfb7e498c728800$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $1dfb7e498c728800$var$fromArrayLike(obj.data);
}
function $1dfb7e498c728800$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $1dfb7e498c728800$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $1dfb7e498c728800$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $1dfb7e498c728800$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $1dfb7e498c728800$var$Buffer.alloc(+length);
}
$1dfb7e498c728800$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $1dfb7e498c728800$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$1dfb7e498c728800$var$Buffer.compare = function compare(a, b) {
    if ($1dfb7e498c728800$var$isInstance(a, Uint8Array)) a = $1dfb7e498c728800$var$Buffer.from(a, a.offset, a.byteLength);
    if ($1dfb7e498c728800$var$isInstance(b, Uint8Array)) b = $1dfb7e498c728800$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$1dfb7e498c728800$var$Buffer.isBuffer(a) || !$1dfb7e498c728800$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$1dfb7e498c728800$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$1dfb7e498c728800$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $1dfb7e498c728800$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $1dfb7e498c728800$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($1dfb7e498c728800$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$1dfb7e498c728800$var$Buffer.isBuffer(buf)) buf = $1dfb7e498c728800$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$1dfb7e498c728800$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $1dfb7e498c728800$var$byteLength(string, encoding) {
    if ($1dfb7e498c728800$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $1dfb7e498c728800$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $1dfb7e498c728800$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $1dfb7e498c728800$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $1dfb7e498c728800$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$1dfb7e498c728800$var$Buffer.byteLength = $1dfb7e498c728800$var$byteLength;
function $1dfb7e498c728800$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $1dfb7e498c728800$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $1dfb7e498c728800$var$utf8Slice(this, start, end);
        case "ascii":
            return $1dfb7e498c728800$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $1dfb7e498c728800$var$latin1Slice(this, start, end);
        case "base64":
            return $1dfb7e498c728800$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $1dfb7e498c728800$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$1dfb7e498c728800$var$Buffer.prototype._isBuffer = true;
function $1dfb7e498c728800$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$1dfb7e498c728800$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$1dfb7e498c728800$var$swap(this, i, i + 1);
    return this;
};
$1dfb7e498c728800$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $1dfb7e498c728800$var$swap(this, i, i + 3);
        $1dfb7e498c728800$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$1dfb7e498c728800$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $1dfb7e498c728800$var$swap(this, i, i + 7);
        $1dfb7e498c728800$var$swap(this, i + 1, i + 6);
        $1dfb7e498c728800$var$swap(this, i + 2, i + 5);
        $1dfb7e498c728800$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$1dfb7e498c728800$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $1dfb7e498c728800$var$utf8Slice(this, 0, length);
    return $1dfb7e498c728800$var$slowToString.apply(this, arguments);
};
$1dfb7e498c728800$var$Buffer.prototype.toLocaleString = $1dfb7e498c728800$var$Buffer.prototype.toString;
$1dfb7e498c728800$var$Buffer.prototype.equals = function equals(b) {
    if (!$1dfb7e498c728800$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $1dfb7e498c728800$var$Buffer.compare(this, b) === 0;
};
$1dfb7e498c728800$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $1dfb7e498c728800$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($1dfb7e498c728800$var$customInspectSymbol) $1dfb7e498c728800$var$Buffer.prototype[$1dfb7e498c728800$var$customInspectSymbol] = $1dfb7e498c728800$var$Buffer.prototype.inspect;
$1dfb7e498c728800$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($1dfb7e498c728800$var$isInstance(target, Uint8Array)) target = $1dfb7e498c728800$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$1dfb7e498c728800$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $1dfb7e498c728800$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($1dfb7e498c728800$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $1dfb7e498c728800$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($1dfb7e498c728800$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $1dfb7e498c728800$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $1dfb7e498c728800$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $1dfb7e498c728800$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$1dfb7e498c728800$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$1dfb7e498c728800$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $1dfb7e498c728800$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$1dfb7e498c728800$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $1dfb7e498c728800$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $1dfb7e498c728800$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($1dfb7e498c728800$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $1dfb7e498c728800$var$utf8Write(buf, string, offset, length) {
    return $1dfb7e498c728800$var$blitBuffer($1dfb7e498c728800$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $1dfb7e498c728800$var$asciiWrite(buf, string, offset, length) {
    return $1dfb7e498c728800$var$blitBuffer($1dfb7e498c728800$var$asciiToBytes(string), buf, offset, length);
}
function $1dfb7e498c728800$var$base64Write(buf, string, offset, length) {
    return $1dfb7e498c728800$var$blitBuffer($1dfb7e498c728800$var$base64ToBytes(string), buf, offset, length);
}
function $1dfb7e498c728800$var$ucs2Write(buf, string, offset, length) {
    return $1dfb7e498c728800$var$blitBuffer($1dfb7e498c728800$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$1dfb7e498c728800$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $1dfb7e498c728800$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $1dfb7e498c728800$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $1dfb7e498c728800$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $1dfb7e498c728800$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $1dfb7e498c728800$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$1dfb7e498c728800$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $1dfb7e498c728800$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $101abc5743447827$export$6100ba28696e12de(buf);
    else return $101abc5743447827$export$6100ba28696e12de(buf.slice(start, end));
}
function $1dfb7e498c728800$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $1dfb7e498c728800$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $1dfb7e498c728800$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $1dfb7e498c728800$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $1dfb7e498c728800$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $1dfb7e498c728800$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $1dfb7e498c728800$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $1dfb7e498c728800$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $1dfb7e498c728800$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $1dfb7e498c728800$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $1dfb7e498c728800$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$1dfb7e498c728800$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $1dfb7e498c728800$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $1dfb7e498c728800$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$1dfb7e498c728800$var$Buffer.prototype.readUintLE = $1dfb7e498c728800$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$1dfb7e498c728800$var$Buffer.prototype.readUintBE = $1dfb7e498c728800$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$1dfb7e498c728800$var$Buffer.prototype.readUint8 = $1dfb7e498c728800$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$1dfb7e498c728800$var$Buffer.prototype.readUint16LE = $1dfb7e498c728800$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$1dfb7e498c728800$var$Buffer.prototype.readUint16BE = $1dfb7e498c728800$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$1dfb7e498c728800$var$Buffer.prototype.readUint32LE = $1dfb7e498c728800$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$1dfb7e498c728800$var$Buffer.prototype.readUint32BE = $1dfb7e498c728800$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$1dfb7e498c728800$var$Buffer.prototype.readBigUInt64LE = $1dfb7e498c728800$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $1dfb7e498c728800$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $1dfb7e498c728800$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$1dfb7e498c728800$var$Buffer.prototype.readBigUInt64BE = $1dfb7e498c728800$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $1dfb7e498c728800$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $1dfb7e498c728800$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$1dfb7e498c728800$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$1dfb7e498c728800$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$1dfb7e498c728800$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$1dfb7e498c728800$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$1dfb7e498c728800$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$1dfb7e498c728800$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$1dfb7e498c728800$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$1dfb7e498c728800$var$Buffer.prototype.readBigInt64LE = $1dfb7e498c728800$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $1dfb7e498c728800$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $1dfb7e498c728800$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$1dfb7e498c728800$var$Buffer.prototype.readBigInt64BE = $1dfb7e498c728800$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $1dfb7e498c728800$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $1dfb7e498c728800$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$1dfb7e498c728800$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkOffset(offset, 4, this.length);
    return $4f5c04605df79d9b$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$1dfb7e498c728800$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkOffset(offset, 4, this.length);
    return $4f5c04605df79d9b$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$1dfb7e498c728800$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkOffset(offset, 8, this.length);
    return $4f5c04605df79d9b$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$1dfb7e498c728800$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkOffset(offset, 8, this.length);
    return $4f5c04605df79d9b$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $1dfb7e498c728800$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$1dfb7e498c728800$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$1dfb7e498c728800$var$Buffer.prototype.writeUintLE = $1dfb7e498c728800$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $1dfb7e498c728800$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$1dfb7e498c728800$var$Buffer.prototype.writeUintBE = $1dfb7e498c728800$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $1dfb7e498c728800$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$1dfb7e498c728800$var$Buffer.prototype.writeUint8 = $1dfb7e498c728800$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$1dfb7e498c728800$var$Buffer.prototype.writeUint16LE = $1dfb7e498c728800$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$1dfb7e498c728800$var$Buffer.prototype.writeUint16BE = $1dfb7e498c728800$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$1dfb7e498c728800$var$Buffer.prototype.writeUint32LE = $1dfb7e498c728800$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$1dfb7e498c728800$var$Buffer.prototype.writeUint32BE = $1dfb7e498c728800$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $1dfb7e498c728800$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $1dfb7e498c728800$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $1dfb7e498c728800$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $1dfb7e498c728800$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$1dfb7e498c728800$var$Buffer.prototype.writeBigUInt64LE = $1dfb7e498c728800$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $1dfb7e498c728800$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$1dfb7e498c728800$var$Buffer.prototype.writeBigUInt64BE = $1dfb7e498c728800$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $1dfb7e498c728800$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$1dfb7e498c728800$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $1dfb7e498c728800$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$1dfb7e498c728800$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $1dfb7e498c728800$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$1dfb7e498c728800$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$1dfb7e498c728800$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$1dfb7e498c728800$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$1dfb7e498c728800$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$1dfb7e498c728800$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$1dfb7e498c728800$var$Buffer.prototype.writeBigInt64LE = $1dfb7e498c728800$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $1dfb7e498c728800$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$1dfb7e498c728800$var$Buffer.prototype.writeBigInt64BE = $1dfb7e498c728800$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $1dfb7e498c728800$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $1dfb7e498c728800$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $1dfb7e498c728800$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $4f5c04605df79d9b$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$1dfb7e498c728800$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $1dfb7e498c728800$var$writeFloat(this, value, offset, true, noAssert);
};
$1dfb7e498c728800$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $1dfb7e498c728800$var$writeFloat(this, value, offset, false, noAssert);
};
function $1dfb7e498c728800$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1dfb7e498c728800$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $4f5c04605df79d9b$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$1dfb7e498c728800$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $1dfb7e498c728800$var$writeDouble(this, value, offset, true, noAssert);
};
$1dfb7e498c728800$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $1dfb7e498c728800$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$1dfb7e498c728800$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$1dfb7e498c728800$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$1dfb7e498c728800$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$1dfb7e498c728800$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $1dfb7e498c728800$var$Buffer.isBuffer(val) ? val : $1dfb7e498c728800$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $1dfb7e498c728800$var$errors = {};
function $1dfb7e498c728800$var$E(sym, getMessage, Base) {
    $1dfb7e498c728800$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$1dfb7e498c728800$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$1dfb7e498c728800$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$1dfb7e498c728800$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $1dfb7e498c728800$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $1dfb7e498c728800$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $1dfb7e498c728800$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $1dfb7e498c728800$var$checkBounds(buf, offset, byteLength) {
    $1dfb7e498c728800$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $1dfb7e498c728800$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $1dfb7e498c728800$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $1dfb7e498c728800$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $1dfb7e498c728800$var$checkBounds(buf, offset, byteLength);
}
function $1dfb7e498c728800$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $1dfb7e498c728800$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $1dfb7e498c728800$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $1dfb7e498c728800$var$validateNumber(value, type);
        throw new $1dfb7e498c728800$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $1dfb7e498c728800$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $1dfb7e498c728800$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $1dfb7e498c728800$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $1dfb7e498c728800$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($1dfb7e498c728800$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $1dfb7e498c728800$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $1dfb7e498c728800$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $1dfb7e498c728800$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $1dfb7e498c728800$var$base64ToBytes(str) {
    return $101abc5743447827$export$d622b2ad8d90c771($1dfb7e498c728800$var$base64clean(str));
}
function $1dfb7e498c728800$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $1dfb7e498c728800$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $1dfb7e498c728800$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $1dfb7e498c728800$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $1dfb7e498c728800$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $1dfb7e498c728800$var$BufferBigIntNotDefined : fn;
}
function $1dfb7e498c728800$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $637cfc6595b0fb82$require$Buffer = $1dfb7e498c728800$export$a143d493d941bafc;
function $637cfc6595b0fb82$var$bind(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}
// utils is a library of generic helper functions non-specific to axios
const { toString: $637cfc6595b0fb82$var$toString } = Object.prototype;
const { getPrototypeOf: $637cfc6595b0fb82$var$getPrototypeOf } = Object;
const $637cfc6595b0fb82$var$kindOf = ((cache)=>(thing)=>{
        const str = $637cfc6595b0fb82$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $637cfc6595b0fb82$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$637cfc6595b0fb82$var$kindOf(thing) === type;
};
const $637cfc6595b0fb82$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $637cfc6595b0fb82$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $637cfc6595b0fb82$var$isUndefined = $637cfc6595b0fb82$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $637cfc6595b0fb82$var$isBuffer(val) {
    return val !== null && !$637cfc6595b0fb82$var$isUndefined(val) && val.constructor !== null && !$637cfc6595b0fb82$var$isUndefined(val.constructor) && $637cfc6595b0fb82$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $637cfc6595b0fb82$var$isArrayBuffer = $637cfc6595b0fb82$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $637cfc6595b0fb82$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $637cfc6595b0fb82$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $637cfc6595b0fb82$var$isString = $637cfc6595b0fb82$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $637cfc6595b0fb82$var$isFunction = $637cfc6595b0fb82$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $637cfc6595b0fb82$var$isNumber = $637cfc6595b0fb82$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $637cfc6595b0fb82$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $637cfc6595b0fb82$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $637cfc6595b0fb82$var$isPlainObject = (val)=>{
    if ($637cfc6595b0fb82$var$kindOf(val) !== "object") return false;
    const prototype = $637cfc6595b0fb82$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $637cfc6595b0fb82$var$isDate = $637cfc6595b0fb82$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $637cfc6595b0fb82$var$isFile = $637cfc6595b0fb82$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $637cfc6595b0fb82$var$isBlob = $637cfc6595b0fb82$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $637cfc6595b0fb82$var$isFileList = $637cfc6595b0fb82$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $637cfc6595b0fb82$var$isStream = (val)=>$637cfc6595b0fb82$var$isObject(val) && $637cfc6595b0fb82$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $637cfc6595b0fb82$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $637cfc6595b0fb82$var$isFunction(thing.append) && ((kind = $637cfc6595b0fb82$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $637cfc6595b0fb82$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $637cfc6595b0fb82$var$isURLSearchParams = $637cfc6595b0fb82$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $637cfc6595b0fb82$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $637cfc6595b0fb82$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($637cfc6595b0fb82$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $637cfc6595b0fb82$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $637cfc6595b0fb82$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $637cfc6595b0fb82$var$isContextDefined = (context)=>!$637cfc6595b0fb82$var$isUndefined(context) && context !== $637cfc6595b0fb82$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $637cfc6595b0fb82$var$merge() {
    const { caseless: caseless } = $637cfc6595b0fb82$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $637cfc6595b0fb82$var$findKey(result, key) || key;
        if ($637cfc6595b0fb82$var$isPlainObject(result[targetKey]) && $637cfc6595b0fb82$var$isPlainObject(val)) result[targetKey] = $637cfc6595b0fb82$var$merge(result[targetKey], val);
        else if ($637cfc6595b0fb82$var$isPlainObject(val)) result[targetKey] = $637cfc6595b0fb82$var$merge({}, val);
        else if ($637cfc6595b0fb82$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $637cfc6595b0fb82$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $637cfc6595b0fb82$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $637cfc6595b0fb82$var$forEach(b, (val, key)=>{
        if (thisArg && $637cfc6595b0fb82$var$isFunction(val)) a[key] = $637cfc6595b0fb82$var$bind(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $637cfc6595b0fb82$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $637cfc6595b0fb82$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $637cfc6595b0fb82$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $637cfc6595b0fb82$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $637cfc6595b0fb82$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $637cfc6595b0fb82$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($637cfc6595b0fb82$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$637cfc6595b0fb82$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $637cfc6595b0fb82$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $637cfc6595b0fb82$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $637cfc6595b0fb82$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $637cfc6595b0fb82$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $637cfc6595b0fb82$var$isHTMLForm = $637cfc6595b0fb82$var$kindOfTest("HTMLFormElement");
const $637cfc6595b0fb82$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $637cfc6595b0fb82$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $637cfc6595b0fb82$var$isRegExp = $637cfc6595b0fb82$var$kindOfTest("RegExp");
const $637cfc6595b0fb82$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $637cfc6595b0fb82$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $637cfc6595b0fb82$var$freezeMethods = (obj)=>{
    $637cfc6595b0fb82$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($637cfc6595b0fb82$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$637cfc6595b0fb82$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $637cfc6595b0fb82$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $637cfc6595b0fb82$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $637cfc6595b0fb82$var$noop = ()=>{};
const $637cfc6595b0fb82$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $637cfc6595b0fb82$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $637cfc6595b0fb82$var$DIGIT = "0123456789";
const $637cfc6595b0fb82$var$ALPHABET = {
    DIGIT: $637cfc6595b0fb82$var$DIGIT,
    ALPHA: $637cfc6595b0fb82$var$ALPHA,
    ALPHA_DIGIT: $637cfc6595b0fb82$var$ALPHA + $637cfc6595b0fb82$var$ALPHA.toUpperCase() + $637cfc6595b0fb82$var$DIGIT
};
const $637cfc6595b0fb82$var$generateString = (size = 16, alphabet = $637cfc6595b0fb82$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $637cfc6595b0fb82$var$isSpecCompliantForm(thing) {
    return !!(thing && $637cfc6595b0fb82$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $637cfc6595b0fb82$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($637cfc6595b0fb82$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $637cfc6595b0fb82$var$isArray(source) ? [] : {};
                $637cfc6595b0fb82$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$637cfc6595b0fb82$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $637cfc6595b0fb82$var$isAsyncFn = $637cfc6595b0fb82$var$kindOfTest("AsyncFunction");
const $637cfc6595b0fb82$var$isThenable = (thing)=>thing && ($637cfc6595b0fb82$var$isObject(thing) || $637cfc6595b0fb82$var$isFunction(thing)) && $637cfc6595b0fb82$var$isFunction(thing.then) && $637cfc6595b0fb82$var$isFunction(thing.catch);
var $637cfc6595b0fb82$var$utils$1 = {
    isArray: $637cfc6595b0fb82$var$isArray,
    isArrayBuffer: $637cfc6595b0fb82$var$isArrayBuffer,
    isBuffer: $637cfc6595b0fb82$var$isBuffer,
    isFormData: $637cfc6595b0fb82$var$isFormData,
    isArrayBufferView: $637cfc6595b0fb82$var$isArrayBufferView,
    isString: $637cfc6595b0fb82$var$isString,
    isNumber: $637cfc6595b0fb82$var$isNumber,
    isBoolean: $637cfc6595b0fb82$var$isBoolean,
    isObject: $637cfc6595b0fb82$var$isObject,
    isPlainObject: $637cfc6595b0fb82$var$isPlainObject,
    isUndefined: $637cfc6595b0fb82$var$isUndefined,
    isDate: $637cfc6595b0fb82$var$isDate,
    isFile: $637cfc6595b0fb82$var$isFile,
    isBlob: $637cfc6595b0fb82$var$isBlob,
    isRegExp: $637cfc6595b0fb82$var$isRegExp,
    isFunction: $637cfc6595b0fb82$var$isFunction,
    isStream: $637cfc6595b0fb82$var$isStream,
    isURLSearchParams: $637cfc6595b0fb82$var$isURLSearchParams,
    isTypedArray: $637cfc6595b0fb82$var$isTypedArray,
    isFileList: $637cfc6595b0fb82$var$isFileList,
    forEach: $637cfc6595b0fb82$var$forEach,
    merge: $637cfc6595b0fb82$var$merge,
    extend: $637cfc6595b0fb82$var$extend,
    trim: $637cfc6595b0fb82$var$trim,
    stripBOM: $637cfc6595b0fb82$var$stripBOM,
    inherits: $637cfc6595b0fb82$var$inherits,
    toFlatObject: $637cfc6595b0fb82$var$toFlatObject,
    kindOf: $637cfc6595b0fb82$var$kindOf,
    kindOfTest: $637cfc6595b0fb82$var$kindOfTest,
    endsWith: $637cfc6595b0fb82$var$endsWith,
    toArray: $637cfc6595b0fb82$var$toArray,
    forEachEntry: $637cfc6595b0fb82$var$forEachEntry,
    matchAll: $637cfc6595b0fb82$var$matchAll,
    isHTMLForm: $637cfc6595b0fb82$var$isHTMLForm,
    hasOwnProperty: $637cfc6595b0fb82$var$hasOwnProperty,
    hasOwnProp: $637cfc6595b0fb82$var$hasOwnProperty,
    reduceDescriptors: $637cfc6595b0fb82$var$reduceDescriptors,
    freezeMethods: $637cfc6595b0fb82$var$freezeMethods,
    toObjectSet: $637cfc6595b0fb82$var$toObjectSet,
    toCamelCase: $637cfc6595b0fb82$var$toCamelCase,
    noop: $637cfc6595b0fb82$var$noop,
    toFiniteNumber: $637cfc6595b0fb82$var$toFiniteNumber,
    findKey: $637cfc6595b0fb82$var$findKey,
    global: $637cfc6595b0fb82$var$_global,
    isContextDefined: $637cfc6595b0fb82$var$isContextDefined,
    ALPHABET: $637cfc6595b0fb82$var$ALPHABET,
    generateString: $637cfc6595b0fb82$var$generateString,
    isSpecCompliantForm: $637cfc6595b0fb82$var$isSpecCompliantForm,
    toJSONObject: $637cfc6595b0fb82$var$toJSONObject,
    isAsyncFn: $637cfc6595b0fb82$var$isAsyncFn,
    isThenable: $637cfc6595b0fb82$var$isThenable
};
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $637cfc6595b0fb82$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
$637cfc6595b0fb82$var$utils$1.inherits($637cfc6595b0fb82$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: $637cfc6595b0fb82$var$utils$1.toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $637cfc6595b0fb82$var$prototype$1 = $637cfc6595b0fb82$var$AxiosError.prototype;
const $637cfc6595b0fb82$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $637cfc6595b0fb82$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($637cfc6595b0fb82$var$AxiosError, $637cfc6595b0fb82$var$descriptors);
Object.defineProperty($637cfc6595b0fb82$var$prototype$1, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$637cfc6595b0fb82$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($637cfc6595b0fb82$var$prototype$1);
    $637cfc6595b0fb82$var$utils$1.toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $637cfc6595b0fb82$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
// eslint-disable-next-line strict
var $637cfc6595b0fb82$var$httpAdapter = null;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $637cfc6595b0fb82$var$isVisitable(thing) {
    return $637cfc6595b0fb82$var$utils$1.isPlainObject(thing) || $637cfc6595b0fb82$var$utils$1.isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $637cfc6595b0fb82$var$removeBrackets(key) {
    return $637cfc6595b0fb82$var$utils$1.endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $637cfc6595b0fb82$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $637cfc6595b0fb82$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $637cfc6595b0fb82$var$isFlatArray(arr) {
    return $637cfc6595b0fb82$var$utils$1.isArray(arr) && !arr.some($637cfc6595b0fb82$var$isVisitable);
}
const $637cfc6595b0fb82$var$predicates = $637cfc6595b0fb82$var$utils$1.toFlatObject($637cfc6595b0fb82$var$utils$1, {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $637cfc6595b0fb82$var$toFormData(obj, formData, options) {
    if (!$637cfc6595b0fb82$var$utils$1.isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new FormData();
    // eslint-disable-next-line no-param-reassign
    options = $637cfc6595b0fb82$var$utils$1.toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !$637cfc6595b0fb82$var$utils$1.isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && $637cfc6595b0fb82$var$utils$1.isSpecCompliantForm(formData);
    if (!$637cfc6595b0fb82$var$utils$1.isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ($637cfc6595b0fb82$var$utils$1.isDate(value)) return value.toISOString();
        if (!useBlob && $637cfc6595b0fb82$var$utils$1.isBlob(value)) throw new $637cfc6595b0fb82$var$AxiosError("Blob is not supported. Use a Buffer instead.");
        if ($637cfc6595b0fb82$var$utils$1.isArrayBuffer(value) || $637cfc6595b0fb82$var$utils$1.isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $637cfc6595b0fb82$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ($637cfc6595b0fb82$var$utils$1.endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ($637cfc6595b0fb82$var$utils$1.isArray(value) && $637cfc6595b0fb82$var$isFlatArray(value) || ($637cfc6595b0fb82$var$utils$1.isFileList(value) || $637cfc6595b0fb82$var$utils$1.endsWith(key, "[]")) && (arr = $637cfc6595b0fb82$var$utils$1.toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $637cfc6595b0fb82$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !($637cfc6595b0fb82$var$utils$1.isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $637cfc6595b0fb82$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($637cfc6595b0fb82$var$isVisitable(value)) return true;
        formData.append($637cfc6595b0fb82$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($637cfc6595b0fb82$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $637cfc6595b0fb82$var$isVisitable
    });
    function build(value, path) {
        if ($637cfc6595b0fb82$var$utils$1.isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        $637cfc6595b0fb82$var$utils$1.forEach(value, function each(el, key) {
            const result = !($637cfc6595b0fb82$var$utils$1.isUndefined(el) || el === null) && visitor.call(formData, el, $637cfc6595b0fb82$var$utils$1.isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!$637cfc6595b0fb82$var$utils$1.isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $637cfc6595b0fb82$var$encode$1(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $637cfc6595b0fb82$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && $637cfc6595b0fb82$var$toFormData(params, this, options);
}
const $637cfc6595b0fb82$var$prototype = $637cfc6595b0fb82$var$AxiosURLSearchParams.prototype;
$637cfc6595b0fb82$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$637cfc6595b0fb82$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $637cfc6595b0fb82$var$encode$1);
    } : $637cfc6595b0fb82$var$encode$1;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $637cfc6595b0fb82$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */ function $637cfc6595b0fb82$var$buildURL(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $637cfc6595b0fb82$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = $637cfc6595b0fb82$var$utils$1.isURLSearchParams(params) ? params.toString() : new $637cfc6595b0fb82$var$AxiosURLSearchParams(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}
class $637cfc6595b0fb82$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        $637cfc6595b0fb82$var$utils$1.forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $637cfc6595b0fb82$var$InterceptorManager$1 = $637cfc6595b0fb82$var$InterceptorManager;
var $637cfc6595b0fb82$var$transitionalDefaults = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};
var $637cfc6595b0fb82$var$URLSearchParams$1 = typeof URLSearchParams !== "undefined" ? URLSearchParams : $637cfc6595b0fb82$var$AxiosURLSearchParams;
var $637cfc6595b0fb82$var$FormData$1 = typeof FormData !== "undefined" ? FormData : null;
var $637cfc6595b0fb82$var$Blob$1 = typeof Blob !== "undefined" ? Blob : null;
var $637cfc6595b0fb82$var$platform$1 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $637cfc6595b0fb82$var$URLSearchParams$1,
        FormData: $637cfc6595b0fb82$var$FormData$1,
        Blob: $637cfc6595b0fb82$var$Blob$1
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};
const $637cfc6595b0fb82$var$hasBrowserEnv = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $637cfc6595b0fb82$var$hasStandardBrowserEnv = ((product)=>{
    return $637cfc6595b0fb82$var$hasBrowserEnv && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $637cfc6595b0fb82$var$hasStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
var $637cfc6595b0fb82$var$utils = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    hasBrowserEnv: $637cfc6595b0fb82$var$hasBrowserEnv,
    hasStandardBrowserWebWorkerEnv: $637cfc6595b0fb82$var$hasStandardBrowserWebWorkerEnv,
    hasStandardBrowserEnv: $637cfc6595b0fb82$var$hasStandardBrowserEnv
});
var $637cfc6595b0fb82$var$platform = {
    ...$637cfc6595b0fb82$var$utils,
    ...$637cfc6595b0fb82$var$platform$1
};
function $637cfc6595b0fb82$var$toURLEncodedForm(data, options) {
    return $637cfc6595b0fb82$var$toFormData(data, new $637cfc6595b0fb82$var$platform.classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ($637cfc6595b0fb82$var$platform.isNode && $637cfc6595b0fb82$var$utils$1.isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $637cfc6595b0fb82$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return $637cfc6595b0fb82$var$utils$1.matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $637cfc6595b0fb82$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $637cfc6595b0fb82$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && $637cfc6595b0fb82$var$utils$1.isArray(target) ? target.length : name;
        if (isLast) {
            if ($637cfc6595b0fb82$var$utils$1.hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !$637cfc6595b0fb82$var$utils$1.isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && $637cfc6595b0fb82$var$utils$1.isArray(target[name])) target[name] = $637cfc6595b0fb82$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ($637cfc6595b0fb82$var$utils$1.isFormData(formData) && $637cfc6595b0fb82$var$utils$1.isFunction(formData.entries)) {
        const obj = {};
        $637cfc6595b0fb82$var$utils$1.forEachEntry(formData, (name, value)=>{
            buildPath($637cfc6595b0fb82$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $637cfc6595b0fb82$var$stringifySafely(rawValue, parser, encoder) {
    if ($637cfc6595b0fb82$var$utils$1.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $637cfc6595b0fb82$var$utils$1.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $637cfc6595b0fb82$var$defaults = {
    transitional: $637cfc6595b0fb82$var$transitionalDefaults,
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = $637cfc6595b0fb82$var$utils$1.isObject(data);
            if (isObjectPayload && $637cfc6595b0fb82$var$utils$1.isHTMLForm(data)) data = new FormData(data);
            const isFormData = $637cfc6595b0fb82$var$utils$1.isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify($637cfc6595b0fb82$var$formDataToJSON(data)) : data;
            if ($637cfc6595b0fb82$var$utils$1.isArrayBuffer(data) || $637cfc6595b0fb82$var$utils$1.isBuffer(data) || $637cfc6595b0fb82$var$utils$1.isStream(data) || $637cfc6595b0fb82$var$utils$1.isFile(data) || $637cfc6595b0fb82$var$utils$1.isBlob(data)) return data;
            if ($637cfc6595b0fb82$var$utils$1.isArrayBufferView(data)) return data.buffer;
            if ($637cfc6595b0fb82$var$utils$1.isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return $637cfc6595b0fb82$var$toURLEncodedForm(data, this.formSerializer).toString();
                if ((isFileList = $637cfc6595b0fb82$var$utils$1.isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return $637cfc6595b0fb82$var$toFormData(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $637cfc6595b0fb82$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $637cfc6595b0fb82$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && $637cfc6595b0fb82$var$utils$1.isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw $637cfc6595b0fb82$var$AxiosError.from(e, $637cfc6595b0fb82$var$AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: $637cfc6595b0fb82$var$platform.classes.FormData,
        Blob: $637cfc6595b0fb82$var$platform.classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
$637cfc6595b0fb82$var$utils$1.forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $637cfc6595b0fb82$var$defaults.headers[method] = {};
});
var $637cfc6595b0fb82$var$defaults$1 = $637cfc6595b0fb82$var$defaults;
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $637cfc6595b0fb82$var$ignoreDuplicateOf = $637cfc6595b0fb82$var$utils$1.toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ var $637cfc6595b0fb82$var$parseHeaders = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $637cfc6595b0fb82$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};
const $637cfc6595b0fb82$var$$internals = Symbol("internals");
function $637cfc6595b0fb82$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $637cfc6595b0fb82$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return $637cfc6595b0fb82$var$utils$1.isArray(value) ? value.map($637cfc6595b0fb82$var$normalizeValue) : String(value);
}
function $637cfc6595b0fb82$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $637cfc6595b0fb82$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $637cfc6595b0fb82$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ($637cfc6595b0fb82$var$utils$1.isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!$637cfc6595b0fb82$var$utils$1.isString(value)) return;
    if ($637cfc6595b0fb82$var$utils$1.isString(filter)) return value.indexOf(filter) !== -1;
    if ($637cfc6595b0fb82$var$utils$1.isRegExp(filter)) return filter.test(value);
}
function $637cfc6595b0fb82$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $637cfc6595b0fb82$var$buildAccessors(obj, header) {
    const accessorName = $637cfc6595b0fb82$var$utils$1.toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $637cfc6595b0fb82$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self1 = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $637cfc6595b0fb82$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = $637cfc6595b0fb82$var$utils$1.findKey(self1, lHeader);
            if (!key || self1[key] === undefined || _rewrite === true || _rewrite === undefined && self1[key] !== false) self1[key || _header] = $637cfc6595b0fb82$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>$637cfc6595b0fb82$var$utils$1.forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ($637cfc6595b0fb82$var$utils$1.isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ($637cfc6595b0fb82$var$utils$1.isString(header) && (header = header.trim()) && !$637cfc6595b0fb82$var$isValidHeaderName(header)) setHeaders($637cfc6595b0fb82$var$parseHeaders(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $637cfc6595b0fb82$var$normalizeHeader(header);
        if (header) {
            const key = $637cfc6595b0fb82$var$utils$1.findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $637cfc6595b0fb82$var$parseTokens(value);
                if ($637cfc6595b0fb82$var$utils$1.isFunction(parser)) return parser.call(this, value, key);
                if ($637cfc6595b0fb82$var$utils$1.isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $637cfc6595b0fb82$var$normalizeHeader(header);
        if (header) {
            const key = $637cfc6595b0fb82$var$utils$1.findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $637cfc6595b0fb82$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self1 = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $637cfc6595b0fb82$var$normalizeHeader(_header);
            if (_header) {
                const key = $637cfc6595b0fb82$var$utils$1.findKey(self1, _header);
                if (key && (!matcher || $637cfc6595b0fb82$var$matchHeaderValue(self1, self1[key], key, matcher))) {
                    delete self1[key];
                    deleted = true;
                }
            }
        }
        if ($637cfc6595b0fb82$var$utils$1.isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $637cfc6595b0fb82$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self1 = this;
        const headers = {};
        $637cfc6595b0fb82$var$utils$1.forEach(this, (value, header)=>{
            const key = $637cfc6595b0fb82$var$utils$1.findKey(headers, header);
            if (key) {
                self1[key] = $637cfc6595b0fb82$var$normalizeValue(value);
                delete self1[header];
                return;
            }
            const normalized = format ? $637cfc6595b0fb82$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self1[header];
            self1[normalized] = $637cfc6595b0fb82$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        $637cfc6595b0fb82$var$utils$1.forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && $637cfc6595b0fb82$var$utils$1.isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$637cfc6595b0fb82$var$$internals] = this[$637cfc6595b0fb82$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $637cfc6595b0fb82$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $637cfc6595b0fb82$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        $637cfc6595b0fb82$var$utils$1.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$637cfc6595b0fb82$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
$637cfc6595b0fb82$var$utils$1.reduceDescriptors($637cfc6595b0fb82$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
$637cfc6595b0fb82$var$utils$1.freezeMethods($637cfc6595b0fb82$var$AxiosHeaders);
var $637cfc6595b0fb82$var$AxiosHeaders$1 = $637cfc6595b0fb82$var$AxiosHeaders;
/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */ function $637cfc6595b0fb82$var$transformData(fns, response) {
    const config = this || $637cfc6595b0fb82$var$defaults$1;
    const context = response || config;
    const headers = $637cfc6595b0fb82$var$AxiosHeaders$1.from(context.headers);
    let data = context.data;
    $637cfc6595b0fb82$var$utils$1.forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}
function $637cfc6595b0fb82$var$isCancel(value) {
    return !!(value && value.__CANCEL__);
}
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $637cfc6595b0fb82$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    $637cfc6595b0fb82$var$AxiosError.call(this, message == null ? "canceled" : message, $637cfc6595b0fb82$var$AxiosError.ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
$637cfc6595b0fb82$var$utils$1.inherits($637cfc6595b0fb82$var$CanceledError, $637cfc6595b0fb82$var$AxiosError, {
    __CANCEL__: true
});
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */ function $637cfc6595b0fb82$var$settle(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new $637cfc6595b0fb82$var$AxiosError("Request failed with status code " + response.status, [
        $637cfc6595b0fb82$var$AxiosError.ERR_BAD_REQUEST,
        $637cfc6595b0fb82$var$AxiosError.ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}
var $637cfc6595b0fb82$var$cookies = $637cfc6595b0fb82$var$platform.hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        $637cfc6595b0fb82$var$utils$1.isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        $637cfc6595b0fb82$var$utils$1.isString(path) && cookie.push("path=" + path);
        $637cfc6595b0fb82$var$utils$1.isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ function $637cfc6595b0fb82$var$isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */ function $637cfc6595b0fb82$var$combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */ function $637cfc6595b0fb82$var$buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$637cfc6595b0fb82$var$isAbsoluteURL(requestedURL)) return $637cfc6595b0fb82$var$combineURLs(baseURL, requestedURL);
    return requestedURL;
}
var $637cfc6595b0fb82$var$isURLSameOrigin = $637cfc6595b0fb82$var$platform.hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = $637cfc6595b0fb82$var$utils$1.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();
function $637cfc6595b0fb82$var$parseProtocol(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $637cfc6595b0fb82$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
function $637cfc6595b0fb82$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = $637cfc6595b0fb82$var$speedometer(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $637cfc6595b0fb82$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $637cfc6595b0fb82$var$xhrAdapter = $637cfc6595b0fb82$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = $637cfc6595b0fb82$var$AxiosHeaders$1.from(config.headers).normalize();
        let { responseType: responseType, withXSRFToken: withXSRFToken } = config;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ($637cfc6595b0fb82$var$utils$1.isFormData(requestData)) {
            if ($637cfc6595b0fb82$var$platform.hasStandardBrowserEnv || $637cfc6595b0fb82$var$platform.hasStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if ((contentType = requestHeaders.getContentType()) !== false) {
                // fix semicolon duplication issue for ReactNative FormData implementation
                const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
                requestHeaders.setContentType([
                    type || "multipart/form-data",
                    ...tokens
                ].join("; "));
            }
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = $637cfc6595b0fb82$var$buildFullPath(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $637cfc6595b0fb82$var$buildURL(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = $637cfc6595b0fb82$var$AxiosHeaders$1.from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $637cfc6595b0fb82$var$settle(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new $637cfc6595b0fb82$var$AxiosError("Request aborted", $637cfc6595b0fb82$var$AxiosError.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new $637cfc6595b0fb82$var$AxiosError("Network Error", $637cfc6595b0fb82$var$AxiosError.ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || $637cfc6595b0fb82$var$transitionalDefaults;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new $637cfc6595b0fb82$var$AxiosError(timeoutErrorMessage, transitional.clarifyTimeoutError ? $637cfc6595b0fb82$var$AxiosError.ETIMEDOUT : $637cfc6595b0fb82$var$AxiosError.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($637cfc6595b0fb82$var$platform.hasStandardBrowserEnv) {
            withXSRFToken && $637cfc6595b0fb82$var$utils$1.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
            if (withXSRFToken || withXSRFToken !== false && $637cfc6595b0fb82$var$isURLSameOrigin(fullPath)) {
                // Add xsrf header
                const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && $637cfc6595b0fb82$var$cookies.read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
            }
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) $637cfc6595b0fb82$var$utils$1.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$637cfc6595b0fb82$var$utils$1.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $637cfc6595b0fb82$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $637cfc6595b0fb82$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new $637cfc6595b0fb82$var$CanceledError(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = $637cfc6595b0fb82$var$parseProtocol(fullPath);
        if (protocol && $637cfc6595b0fb82$var$platform.protocols.indexOf(protocol) === -1) {
            reject(new $637cfc6595b0fb82$var$AxiosError("Unsupported protocol " + protocol + ":", $637cfc6595b0fb82$var$AxiosError.ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};
const $637cfc6595b0fb82$var$knownAdapters = {
    http: $637cfc6595b0fb82$var$httpAdapter,
    xhr: $637cfc6595b0fb82$var$xhrAdapter
};
$637cfc6595b0fb82$var$utils$1.forEach($637cfc6595b0fb82$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $637cfc6595b0fb82$var$renderReason = (reason)=>`- ${reason}`;
const $637cfc6595b0fb82$var$isResolvedHandle = (adapter)=>$637cfc6595b0fb82$var$utils$1.isFunction(adapter) || adapter === null || adapter === false;
var $637cfc6595b0fb82$var$adapters = {
    getAdapter: (adapters)=>{
        adapters = $637cfc6595b0fb82$var$utils$1.isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$637cfc6595b0fb82$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $637cfc6595b0fb82$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new $637cfc6595b0fb82$var$AxiosError(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($637cfc6595b0fb82$var$renderReason).join("\n") : " " + $637cfc6595b0fb82$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new $637cfc6595b0fb82$var$AxiosError(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $637cfc6595b0fb82$var$knownAdapters
};
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $637cfc6595b0fb82$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $637cfc6595b0fb82$var$CanceledError(null, config);
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */ function $637cfc6595b0fb82$var$dispatchRequest(config) {
    $637cfc6595b0fb82$var$throwIfCancellationRequested(config);
    config.headers = $637cfc6595b0fb82$var$AxiosHeaders$1.from(config.headers);
    // Transform request data
    config.data = $637cfc6595b0fb82$var$transformData.call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = $637cfc6595b0fb82$var$adapters.getAdapter(config.adapter || $637cfc6595b0fb82$var$defaults$1.adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $637cfc6595b0fb82$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $637cfc6595b0fb82$var$transformData.call(config, config.transformResponse, response);
        response.headers = $637cfc6595b0fb82$var$AxiosHeaders$1.from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$637cfc6595b0fb82$var$isCancel(reason)) {
            $637cfc6595b0fb82$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = $637cfc6595b0fb82$var$transformData.call(config, config.transformResponse, reason.response);
                reason.response.headers = $637cfc6595b0fb82$var$AxiosHeaders$1.from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}
const $637cfc6595b0fb82$var$headersToObject = (thing)=>thing instanceof $637cfc6595b0fb82$var$AxiosHeaders$1 ? {
        ...thing
    } : thing;
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */ function $637cfc6595b0fb82$var$mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ($637cfc6595b0fb82$var$utils$1.isPlainObject(target) && $637cfc6595b0fb82$var$utils$1.isPlainObject(source)) return $637cfc6595b0fb82$var$utils$1.merge.call({
            caseless: caseless
        }, target, source);
        else if ($637cfc6595b0fb82$var$utils$1.isPlainObject(source)) return $637cfc6595b0fb82$var$utils$1.merge({}, source);
        else if ($637cfc6595b0fb82$var$utils$1.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!$637cfc6595b0fb82$var$utils$1.isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!$637cfc6595b0fb82$var$utils$1.isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!$637cfc6595b0fb82$var$utils$1.isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!$637cfc6595b0fb82$var$utils$1.isUndefined(b)) return getMergedValue(undefined, b);
        else if (!$637cfc6595b0fb82$var$utils$1.isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($637cfc6595b0fb82$var$headersToObject(a), $637cfc6595b0fb82$var$headersToObject(b), true)
    };
    $637cfc6595b0fb82$var$utils$1.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        $637cfc6595b0fb82$var$utils$1.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}
const $637cfc6595b0fb82$var$VERSION = "1.6.8";
const $637cfc6595b0fb82$var$validators$1 = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $637cfc6595b0fb82$var$validators$1[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $637cfc6595b0fb82$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $637cfc6595b0fb82$var$validators$1.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + $637cfc6595b0fb82$var$VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new $637cfc6595b0fb82$var$AxiosError(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), $637cfc6595b0fb82$var$AxiosError.ERR_DEPRECATED);
        if (version && !$637cfc6595b0fb82$var$deprecatedWarnings[opt]) {
            $637cfc6595b0fb82$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $637cfc6595b0fb82$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new $637cfc6595b0fb82$var$AxiosError("options must be an object", $637cfc6595b0fb82$var$AxiosError.ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new $637cfc6595b0fb82$var$AxiosError("option " + opt + " must be " + result, $637cfc6595b0fb82$var$AxiosError.ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new $637cfc6595b0fb82$var$AxiosError("Unknown option " + opt, $637cfc6595b0fb82$var$AxiosError.ERR_BAD_OPTION);
    }
}
var $637cfc6595b0fb82$var$validator = {
    assertOptions: $637cfc6595b0fb82$var$assertOptions,
    validators: $637cfc6595b0fb82$var$validators$1
};
const $637cfc6595b0fb82$var$validators = $637cfc6595b0fb82$var$validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $637cfc6595b0fb82$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new $637cfc6595b0fb82$var$InterceptorManager$1(),
            response: new $637cfc6595b0fb82$var$InterceptorManager$1()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                if (!err.stack) err.stack = stack;
                else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = $637cfc6595b0fb82$var$mergeConfig(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) $637cfc6595b0fb82$var$validator.assertOptions(transitional, {
            silentJSONParsing: $637cfc6595b0fb82$var$validators.transitional($637cfc6595b0fb82$var$validators.boolean),
            forcedJSONParsing: $637cfc6595b0fb82$var$validators.transitional($637cfc6595b0fb82$var$validators.boolean),
            clarifyTimeoutError: $637cfc6595b0fb82$var$validators.transitional($637cfc6595b0fb82$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ($637cfc6595b0fb82$var$utils$1.isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else $637cfc6595b0fb82$var$validator.assertOptions(paramsSerializer, {
                encode: $637cfc6595b0fb82$var$validators.function,
                serialize: $637cfc6595b0fb82$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && $637cfc6595b0fb82$var$utils$1.merge(headers.common, headers[config.method]);
        headers && $637cfc6595b0fb82$var$utils$1.forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = $637cfc6595b0fb82$var$AxiosHeaders$1.concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                $637cfc6595b0fb82$var$dispatchRequest.bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = $637cfc6595b0fb82$var$dispatchRequest.call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = $637cfc6595b0fb82$var$mergeConfig(this.defaults, config);
        const fullPath = $637cfc6595b0fb82$var$buildFullPath(config.baseURL, config.url);
        return $637cfc6595b0fb82$var$buildURL(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
$637cfc6595b0fb82$var$utils$1.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $637cfc6595b0fb82$var$Axios.prototype[method] = function(url, config) {
        return this.request($637cfc6595b0fb82$var$mergeConfig(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$637cfc6595b0fb82$var$utils$1.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request($637cfc6595b0fb82$var$mergeConfig(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $637cfc6595b0fb82$var$Axios.prototype[method] = generateHTTPMethod();
    $637cfc6595b0fb82$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $637cfc6595b0fb82$var$Axios$1 = $637cfc6595b0fb82$var$Axios;
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $637cfc6595b0fb82$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new $637cfc6595b0fb82$var$CanceledError(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $637cfc6595b0fb82$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $637cfc6595b0fb82$var$CancelToken$1 = $637cfc6595b0fb82$var$CancelToken;
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */ function $637cfc6595b0fb82$var$spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ function $637cfc6595b0fb82$var$isAxiosError(payload) {
    return $637cfc6595b0fb82$var$utils$1.isObject(payload) && payload.isAxiosError === true;
}
const $637cfc6595b0fb82$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($637cfc6595b0fb82$var$HttpStatusCode).forEach(([key, value])=>{
    $637cfc6595b0fb82$var$HttpStatusCode[value] = key;
});
var $637cfc6595b0fb82$var$HttpStatusCode$1 = $637cfc6595b0fb82$var$HttpStatusCode;
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $637cfc6595b0fb82$var$createInstance(defaultConfig) {
    const context = new $637cfc6595b0fb82$var$Axios$1(defaultConfig);
    const instance = $637cfc6595b0fb82$var$bind($637cfc6595b0fb82$var$Axios$1.prototype.request, context);
    // Copy axios.prototype to instance
    $637cfc6595b0fb82$var$utils$1.extend(instance, $637cfc6595b0fb82$var$Axios$1.prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    $637cfc6595b0fb82$var$utils$1.extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $637cfc6595b0fb82$var$createInstance($637cfc6595b0fb82$var$mergeConfig(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $637cfc6595b0fb82$var$axios = $637cfc6595b0fb82$var$createInstance($637cfc6595b0fb82$var$defaults$1);
// Expose Axios class to allow class inheritance
$637cfc6595b0fb82$var$axios.Axios = $637cfc6595b0fb82$var$Axios$1;
// Expose Cancel & CancelToken
$637cfc6595b0fb82$var$axios.CanceledError = $637cfc6595b0fb82$var$CanceledError;
$637cfc6595b0fb82$var$axios.CancelToken = $637cfc6595b0fb82$var$CancelToken$1;
$637cfc6595b0fb82$var$axios.isCancel = $637cfc6595b0fb82$var$isCancel;
$637cfc6595b0fb82$var$axios.VERSION = $637cfc6595b0fb82$var$VERSION;
$637cfc6595b0fb82$var$axios.toFormData = $637cfc6595b0fb82$var$toFormData;
// Expose AxiosError class
$637cfc6595b0fb82$var$axios.AxiosError = $637cfc6595b0fb82$var$AxiosError;
// alias for CanceledError for backward compatibility
$637cfc6595b0fb82$var$axios.Cancel = $637cfc6595b0fb82$var$axios.CanceledError;
// Expose all/spread
$637cfc6595b0fb82$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$637cfc6595b0fb82$var$axios.spread = $637cfc6595b0fb82$var$spread;
// Expose isAxiosError
$637cfc6595b0fb82$var$axios.isAxiosError = $637cfc6595b0fb82$var$isAxiosError;
// Expose mergeConfig
$637cfc6595b0fb82$var$axios.mergeConfig = $637cfc6595b0fb82$var$mergeConfig;
$637cfc6595b0fb82$var$axios.AxiosHeaders = $637cfc6595b0fb82$var$AxiosHeaders$1;
$637cfc6595b0fb82$var$axios.formToJSON = (thing)=>$637cfc6595b0fb82$var$formDataToJSON($637cfc6595b0fb82$var$utils$1.isHTMLForm(thing) ? new FormData(thing) : thing);
$637cfc6595b0fb82$var$axios.getAdapter = $637cfc6595b0fb82$var$adapters.getAdapter;
$637cfc6595b0fb82$var$axios.HttpStatusCode = $637cfc6595b0fb82$var$HttpStatusCode$1;
$637cfc6595b0fb82$var$axios.default = $637cfc6595b0fb82$var$axios;
// this module should only have a default export
var $637cfc6595b0fb82$var$axios$1 = $637cfc6595b0fb82$var$axios;
var $637cfc6595b0fb82$var$name$1 = "@tryghost/content-api";
var $637cfc6595b0fb82$var$version = "1.11.21";
var $637cfc6595b0fb82$var$repository = "https://github.com/TryGhost/SDK/tree/main/packages/content-api";
var $637cfc6595b0fb82$var$author = "Ghost Foundation";
var $637cfc6595b0fb82$var$license = "MIT";
var $637cfc6595b0fb82$var$main = "cjs/content-api.js";
var $637cfc6595b0fb82$var$unpkg = "umd/content-api.min.js";
var $637cfc6595b0fb82$var$module = "es/content-api.js";
var $637cfc6595b0fb82$var$source = "lib/content-api.js";
var $637cfc6595b0fb82$var$files = [
    "LICENSE",
    "README.md",
    "cjs/",
    "lib/",
    "umd/",
    "es/"
];
var $637cfc6595b0fb82$var$scripts = {
    dev: 'echo "Implement me!"',
    pretest: "yarn build",
    test: "NODE_ENV=testing c8 --all --reporter text --reporter cobertura mocha './test/**/*.test.js'",
    build: "rollup -c",
    lint: "eslint . --ext .js --cache",
    prepare: "NODE_ENV=production yarn build",
    posttest: "yarn lint"
};
var $637cfc6595b0fb82$var$publishConfig = {
    access: "public"
};
var $637cfc6595b0fb82$var$devDependencies = {
    "@babel/core": "7.24.4",
    "@babel/polyfill": "7.12.1",
    "@babel/preset-env": "7.24.4",
    "@rollup/plugin-json": "6.1.0",
    c8: "9.1.0",
    "core-js": "3.37.0",
    "eslint-plugin-ghost": "3.4.0",
    mocha: "10.4.0",
    rollup: "2.79.1",
    "rollup-plugin-babel": "4.4.0",
    "rollup-plugin-commonjs": "10.1.0",
    "rollup-plugin-node-resolve": "5.2.0",
    "rollup-plugin-polyfill-node": "0.12.0",
    "rollup-plugin-replace": "2.2.0",
    "rollup-plugin-terser": "7.0.2",
    should: "13.2.3",
    sinon: "17.0.1"
};
var $637cfc6595b0fb82$var$dependencies = {
    axios: "^1.0.0"
};
var $637cfc6595b0fb82$var$gitHead = "048ccde4bd78d2dcd60e778d03eb8dc3227cece5";
var $637cfc6595b0fb82$var$packageInfo = {
    name: $637cfc6595b0fb82$var$name$1,
    version: $637cfc6595b0fb82$var$version,
    repository: $637cfc6595b0fb82$var$repository,
    author: $637cfc6595b0fb82$var$author,
    license: $637cfc6595b0fb82$var$license,
    main: $637cfc6595b0fb82$var$main,
    "umd:main": "umd/content-api.min.js",
    unpkg: $637cfc6595b0fb82$var$unpkg,
    module: $637cfc6595b0fb82$var$module,
    source: $637cfc6595b0fb82$var$source,
    files: $637cfc6595b0fb82$var$files,
    scripts: $637cfc6595b0fb82$var$scripts,
    publishConfig: $637cfc6595b0fb82$var$publishConfig,
    devDependencies: $637cfc6595b0fb82$var$devDependencies,
    dependencies: $637cfc6595b0fb82$var$dependencies,
    gitHead: $637cfc6595b0fb82$var$gitHead
};
// @NOTE: this value is dynamically replaced based on browser/node environment
const $637cfc6595b0fb82$var$USER_AGENT_DEFAULT = false;
const $637cfc6595b0fb82$var$packageVersion = $637cfc6595b0fb82$var$packageInfo.version;
const $637cfc6595b0fb82$var$defaultAcceptVersionHeader = "v5.0";
const $637cfc6595b0fb82$var$supportedVersions = [
    "v2",
    "v3",
    "v4",
    "v5",
    "canary"
];
const $637cfc6595b0fb82$var$name = "@tryghost/content-api";
/**
 * This method can go away in favor of only sending 'Accept-Version` headers
 * once the Ghost API removes a concept of version from it's URLS (with Ghost v5)
 *
 * @param {string} [version] version in `v{major}` format
 * @returns {string}
 */ const $637cfc6595b0fb82$var$resolveAPIPrefix = (version)=>{
    let prefix;
    // NOTE: the "version.match(/^v5\.\d+/)" expression should be changed to "version.match(/^v\d+\.\d+/)" once Ghost v5 is out
    if (version === "v5" || version === undefined || version.match(/^v5\.\d+/)) prefix = `/content/`;
    else if (version.match(/^v\d+\.\d+/)) {
        const versionPrefix = /^(v\d+)\.\d+/.exec(version)[1];
        prefix = `/${versionPrefix}/content/`;
    } else prefix = `/${version}/content/`;
    return prefix;
};
const $637cfc6595b0fb82$var$defaultMakeRequest = (_ref)=>{
    let { url: url, method: method, params: params, headers: headers } = _ref;
    return $637cfc6595b0fb82$var$axios$1[method](url, {
        params: params,
        paramsSerializer: (parameters)=>{
            return Object.keys(parameters).reduce((parts, k)=>{
                const val = encodeURIComponent([].concat(parameters[k]).join(","));
                return parts.concat(`${k}=${val}`);
            }, []).join("&");
        },
        headers: headers
    });
};
/**
 *
 * @param {Object} options
 * @param {String} options.url
 * @param {String} options.key
 * @param {String} [options.ghostPath]
 * @param {String|Boolean} options.version - a version string like v3, v4, v5 or boolean value identifying presence of Accept-Version header
 * @param {String|Boolean} [options.userAgent] - value controlling the 'User-Agent' header should be sent with a request
 * @param {Function} [options.makeRequest]
 * @param {String} [options.host] Deprecated
 */ function $637cfc6595b0fb82$export$2e2bcd8739ae039(_ref2) {
    let { url: url, key: key, host: host, version: version, userAgent: userAgent, ghostPath: ghostPath = "ghost", makeRequest: makeRequest = $637cfc6595b0fb82$var$defaultMakeRequest } = _ref2;
    /**
   * host parameter is deprecated
   * @deprecated use "url" instead
   */ if (host) {
        // eslint-disable-next-line
        console.warn(`${$637cfc6595b0fb82$var$name}: The 'host' parameter is deprecated, please use 'url' instead`);
        if (!url) url = host;
    }
    if (this instanceof $637cfc6595b0fb82$export$2e2bcd8739ae039) return $637cfc6595b0fb82$export$2e2bcd8739ae039({
        url: url,
        key: key,
        version: version,
        userAgent: userAgent,
        ghostPath: ghostPath,
        makeRequest: makeRequest
    });
    if (version === undefined) throw new Error(`${$637cfc6595b0fb82$var$name} Config Missing: 'version' is required. E.g. ${$637cfc6595b0fb82$var$supportedVersions.join(",")}`);
    let acceptVersionHeader;
    if (typeof version === "boolean") {
        if (version === true) acceptVersionHeader = $637cfc6595b0fb82$var$defaultAcceptVersionHeader;
        version = undefined;
    } else if (version && !$637cfc6595b0fb82$var$supportedVersions.includes(version) && !version.match(/^v\d+\.\d+/)) throw new Error(`${$637cfc6595b0fb82$var$name} Config Invalid: 'version' ${version} is not supported`);
    else {
        if (version === "canary") {
            // eslint-disable-next-line
            console.warn(`${$637cfc6595b0fb82$var$name}: The 'version' parameter has a deprecated format 'canary', please use 'v{major}.{minor}' format instead`);
            acceptVersionHeader = $637cfc6595b0fb82$var$defaultAcceptVersionHeader;
        } else if (version.match(/^v\d+$/)) {
            // eslint-disable-next-line
            console.warn(`${$637cfc6595b0fb82$var$name}: The 'version' parameter has a deprecated format 'v{major}', please use 'v{major}.{minor}' format instead`);
            acceptVersionHeader = `${version}.0`;
        } else acceptVersionHeader = version;
    }
    if (!url) throw new Error(`${$637cfc6595b0fb82$var$name} Config Missing: 'url' is required. E.g. 'https://site.com'`);
    if (!/https?:\/\//.test(url)) throw new Error(`${$637cfc6595b0fb82$var$name} Config Invalid: 'url' ${url} requires a protocol. E.g. 'https://site.com'`);
    if (url.endsWith("/")) throw new Error(`${$637cfc6595b0fb82$var$name} Config Invalid: 'url' ${url} must not have a trailing slash. E.g. 'https://site.com'`);
    if (ghostPath.endsWith("/") || ghostPath.startsWith("/")) throw new Error(`${$637cfc6595b0fb82$var$name} Config Invalid: 'ghostPath' ${ghostPath} must not have a leading or trailing slash. E.g. 'ghost'`);
    if (key && !/[0-9a-f]{26}/.test(key)) throw new Error(`${$637cfc6595b0fb82$var$name} Config Invalid: 'key' ${key} must have 26 hex characters`);
    if (userAgent === undefined) userAgent = $637cfc6595b0fb82$var$USER_AGENT_DEFAULT;
    const api = [
        "posts",
        "authors",
        "tags",
        "pages",
        "settings",
        "tiers",
        "newsletters",
        "offers"
    ].reduce((apiObject, resourceType)=>{
        function browse() {
            let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            let memberToken = arguments.length > 1 ? arguments[1] : undefined;
            return makeApiRequest(resourceType, options, null, memberToken);
        }
        function read(data) {
            let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let memberToken = arguments.length > 2 ? arguments[2] : undefined;
            if (!data || !data.id && !data.slug) return Promise.reject(new Error(`${$637cfc6595b0fb82$var$name} read requires an id or slug.`));
            const params = Object.assign({}, data, options);
            return makeApiRequest(resourceType, params, data.id || `slug/${data.slug}`, memberToken);
        }
        return Object.assign(apiObject, {
            [resourceType]: {
                read: read,
                browse: browse
            }
        });
    }, {});
    // Settings, tiers & newsletters only have browse methods, offers only has read
    delete api.settings.read;
    delete api.tiers.read;
    delete api.newsletters.read;
    delete api.offers.browse;
    return api;
    function makeApiRequest(resourceType, params, id) {
        let membersToken = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        if (!membersToken && !key) return Promise.reject(new Error(`${$637cfc6595b0fb82$var$name} Config Missing: 'key' is required.`));
        delete params.id;
        const headers = membersToken ? {
            Authorization: `GhostMembers ${membersToken}`
        } : {};
        if (userAgent) {
            if (typeof userAgent === "boolean") headers["User-Agent"] = `GhostContentSDK/${$637cfc6595b0fb82$var$packageVersion}`;
            else headers["User-Agent"] = userAgent;
        }
        if (acceptVersionHeader) headers["Accept-Version"] = acceptVersionHeader;
        params = Object.assign({
            key: key
        }, params);
        const apiUrl = `${url}/${ghostPath}/api${$637cfc6595b0fb82$var$resolveAPIPrefix(version)}${resourceType}/${id ? id + "/" : ""}`;
        return makeRequest({
            url: apiUrl,
            method: "get",
            params: params,
            headers: headers
        }).then((res)=>{
            if (!Array.isArray(res.data[resourceType])) return res.data[resourceType];
            if (res.data[resourceType].length === 1 && !res.data.meta) return res.data[resourceType][0];
            return Object.assign(res.data[resourceType], {
                meta: res.data.meta
            });
        }).catch((err)=>{
            if (err.response && err.response.data && err.response.data.errors) {
                const props = err.response.data.errors[0];
                const toThrow = new Error(props.message);
                const keys = Object.keys(props);
                toThrow.name = props.type;
                keys.forEach((k)=>{
                    toThrow[k] = props[k];
                });
                toThrow.response = err.response;
                // @TODO: remove in 2.0. We have enhanced the error handling, but we don't want to break existing implementations.
                toThrow.request = err.request;
                toThrow.config = err.config;
                throw toThrow;
            } else throw err;
        });
    }
}


const $1a626d68ca0b68a4$var$SEARCH_SCRIPT_SELECTOR = "script[data-sodo-search]";
const $1a626d68ca0b68a4$var$API_URL_ATTRIBUTE = "data-sodo-search";
const $1a626d68ca0b68a4$var$API_KEY_ATTRIBUTE = "data-key";
const $1a626d68ca0b68a4$var$POSTS_CACHE_KEY = "postsCache";
const $1a626d68ca0b68a4$var$AUTHORS_CACHE_KEY = "authorsCache";
const $1a626d68ca0b68a4$var$TAGS_CACHE_KEY = "tagsCache";
const $1a626d68ca0b68a4$var$CACHE_TIMESTAMP_SUFFIX = "_timestamp";
const $1a626d68ca0b68a4$var$MAX_CACHE_AGE = 900000; // 15 minutes in milliseconds
class $1a626d68ca0b68a4$export$59dbc9ea2b6073f6 {
    constructor(){
        this.search = (query)=>{
            const postsResult = this.postsIndex.search(query, {
                enrich: true
            });
            const authorsResult = this.authorsIndex.search(query, {
                enrich: true
            });
            const tagsResult = this.tagsIndex.search(query, {
                enrich: true
            });
            return {
                posts: this.normalizeSearchResult(postsResult),
                authors: this.normalizeSearchResult(authorsResult),
                tags: this.normalizeSearchResult(tagsResult)
            };
        };
        const { apiUrl: apiUrl, apiKey: apiKey } = this.apiInfo;
        this.api = new (0, $637cfc6595b0fb82$export$2e2bcd8739ae039)({
            url: apiUrl,
            key: apiKey,
            version: "v5.0"
        });
        const dir = document.documentElement.dir || "ltr";
        const rtl = dir === "rtl";
        const tokenize = rtl ? "reverse" : "forward";
        this.postsIndex = new (0, $38a534f4d4b6ad2f$export$2e2bcd8739ae039)({
            tokenize: tokenize,
            document: {
                id: "id",
                index: [
                    "title",
                    "excerpt"
                ],
                store: true
            },
            ...this.getEncodeOptions()
        });
        this.authorsIndex = new (0, $38a534f4d4b6ad2f$export$2e2bcd8739ae039)({
            tokenize: tokenize,
            document: {
                id: "id",
                index: [
                    "name"
                ],
                store: true
            },
            ...this.getEncodeOptions()
        });
        this.tagsIndex = new (0, $38a534f4d4b6ad2f$export$2e2bcd8739ae039)({
            tokenize: tokenize,
            document: {
                id: "id",
                index: [
                    "name"
                ],
                store: true
            },
            ...this.getEncodeOptions()
        });
        this.init();
    }
    get apiInfo() {
        const $script = document.querySelector($1a626d68ca0b68a4$var$SEARCH_SCRIPT_SELECTOR);
        const url = $script?.getAttribute($1a626d68ca0b68a4$var$API_URL_ATTRIBUTE);
        return {
            apiUrl: (url || window.location.origin)?.replace(/\/+$/, ""),
            apiKey: $script?.getAttribute($1a626d68ca0b68a4$var$API_KEY_ATTRIBUTE)
        };
    }
    async init() {
        const posts = await this.getCachedData($1a626d68ca0b68a4$var$POSTS_CACHE_KEY, ()=>this.api.posts.browse({
                limit: "10000",
                fields: "id,slug,title,excerpt,url,updated_at,visibility,feature_image",
                order: "updated_at DESC"
            }));
        this.updatePostIndex(posts.filter(({ id: id })=>id));
        const authors = await this.getCachedData($1a626d68ca0b68a4$var$AUTHORS_CACHE_KEY, ()=>this.api.authors.browse({
                limit: "10000",
                fields: "id,slug,name,url,profile_image",
                order: "updated_at DESC"
            }));
        this.updateAuthorsIndex(authors.filter(({ id: id })=>id));
        const tags = await this.getCachedData($1a626d68ca0b68a4$var$TAGS_CACHE_KEY, ()=>this.api.tags.browse({
                limit: "10000",
                fields: "id,slug,name,url",
                order: "updated_at DESC",
                filter: "visibility:public"
            }));
        this.updateTagsIndex(tags.filter(({ id: id })=>id));
    }
    async getCachedData(cacheKey, fetchFunction) {
        const cachedData = sessionStorage.getItem(cacheKey);
        const cachedTimestamp = sessionStorage.getItem(cacheKey + $1a626d68ca0b68a4$var$CACHE_TIMESTAMP_SUFFIX);
        const now = Date.now();
        if (cachedData && cachedTimestamp) {
            const cacheAge = now - parseInt(cachedTimestamp, 10);
            if (cacheAge < $1a626d68ca0b68a4$var$MAX_CACHE_AGE) return JSON.parse(cachedData);
        }
        const data = await fetchFunction();
        sessionStorage.setItem(cacheKey, JSON.stringify(data));
        sessionStorage.setItem(cacheKey + $1a626d68ca0b68a4$var$CACHE_TIMESTAMP_SUFFIX, now.toString());
        return data;
    }
    updatePostIndex(posts) {
        posts.forEach((post)=>{
            this.postsIndex.add(post);
        });
    }
    updateAuthorsIndex(authors) {
        authors.forEach((author)=>{
            this.authorsIndex.add(author);
        });
    }
    updateTagsIndex(tags) {
        tags.forEach((tag)=>{
            this.tagsIndex.add(tag);
        });
    }
    normalizeSearchResult(result) {
        const normalized = [];
        const usedIds = {};
        result.forEach((resultItem)=>{
            resultItem.result.forEach((doc)=>{
                if (!usedIds[doc.id]) {
                    normalized.push(doc.doc);
                    usedIds[doc.id] = true;
                }
            });
        });
        return normalized;
    }
    getEncodeOptions() {
        const regex = new RegExp(`[\u{4E00}-\u{9FFF}\u{3040}-\u{309F}\u{30A0}-\u{30FF}\u{AC00}-\u{D7A3}\u{3400}-\u{4DBF}\u{20000}-\u{2A6DF}\u{2A700}-\u{2B73F}\u{2B740}-\u{2B81F}\u{2B820}-\u{2CEAF}\u{2CEB0}-\u{2EBEF}\u{30000}-\u{3134F}\u{31350}-\u{323AF}\u{2EBF0}-\u{2EE5F}\u{F900}-\u{FAFF}\u{2F800}-\u{2FA1F}]|[0-9A-Za-z\u{430}-\u{44F}\u00C0-\u017F\u0400-\u04FF\u0600-\u06FF\u0980-\u09FF\u1E00-\u1EFF]+`, "mug");
        return {
            encode: (str)=>{
                return ("" + str).toLowerCase().match(regex) ?? [];
            }
        };
    }
}


/**
 * Throttle function that ensures a given function is not called more than once in a specified time period.
 * @param func The function to throttle
 * @param limit The time limit in milliseconds
 * @returns A throttled version of the function
 */ function $081acca11ab4d383$export$de363e709c412c8a(func, limit) {
    let inThrottle;
    return function(...args) {
        const context = this;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
function $081acca11ab4d383$export$61fc7d43ac8f84b0(func, wait) {
    let timeout;
    return function(...args) {
        const context = this;
        const later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}


const $d196fa97474c6e66$var$SEARCH_CONTENT_SELECTOR = "[data-theme-search-content]";
const $d196fa97474c6e66$var$HAS_SEARCH_RESULTS_ATTRIBUTE = "data-theme-has-search-results";
const $d196fa97474c6e66$var$QUERY_FIELD_SELECTOR = "input[data-theme-search-query]";
const $d196fa97474c6e66$var$RESET_BUTTON_SELECTOR = "input[data-theme-search-reset]";
const $d196fa97474c6e66$var$POSTS_RESULTS_SELECTOR = "[data-theme-search-posts]";
const $d196fa97474c6e66$var$AUTHORS_RESULTS_SELECTOR = "[data-theme-search-authors]";
const $d196fa97474c6e66$var$TAGS_RESULTS_SELECTOR = "[data-theme-search-tags]";
class $d196fa97474c6e66$export$c91a17ba0f571ea5 {
    constructor(searchManager){
        this.searchManager = searchManager;
        this.clearSearchResults = ()=>{
            const postsResults = document.querySelector($d196fa97474c6e66$var$POSTS_RESULTS_SELECTOR);
            if (postsResults) postsResults.innerHTML = "";
            const authorsResults = document.querySelector($d196fa97474c6e66$var$AUTHORS_RESULTS_SELECTOR);
            if (authorsResults) authorsResults.innerHTML = "";
            const tagsResults = document.querySelector($d196fa97474c6e66$var$TAGS_RESULTS_SELECTOR);
            if (tagsResults) tagsResults.innerHTML = "";
            document.querySelector($d196fa97474c6e66$var$SEARCH_CONTENT_SELECTOR)?.removeAttribute($d196fa97474c6e66$var$HAS_SEARCH_RESULTS_ATTRIBUTE);
        };
        this.handleSearch = (e)=>{
            const query = e.target.value;
            const { posts: posts, authors: authors, tags: tags } = this.searchManager.search(query);
            if (query.length > 2) document.querySelector($d196fa97474c6e66$var$SEARCH_CONTENT_SELECTOR)?.setAttribute($d196fa97474c6e66$var$HAS_SEARCH_RESULTS_ATTRIBUTE, "");
            else document.querySelector($d196fa97474c6e66$var$SEARCH_CONTENT_SELECTOR)?.removeAttribute($d196fa97474c6e66$var$HAS_SEARCH_RESULTS_ATTRIBUTE);
            this.render(posts, this.renderPost, $d196fa97474c6e66$var$POSTS_RESULTS_SELECTOR);
            this.render(authors, this.renderAuthor, $d196fa97474c6e66$var$AUTHORS_RESULTS_SELECTOR);
            this.render(tags, this.renderTag, $d196fa97474c6e66$var$TAGS_RESULTS_SELECTOR);
        };
        this.debouncedHandleSearch = (0, $081acca11ab4d383$export$61fc7d43ac8f84b0)(this.handleSearch, 300);
        this.render = (data, renderer, targetSelector)=>{
            const $target = document.querySelector(targetSelector);
            if (!$target) return;
            $target.innerHTML = data.map(renderer).join("");
        };
        this.renderPost = ({ title: title, feature_image: feature_image, feature_image_alt: feature_image_alt, url: url })=>{
            return `
      <a class="search__post" href="${url}">
        <img src="${feature_image}" alt="${feature_image_alt}" />
        <h2>${title}</h2>
      </a>
    `;
        };
        this.renderAuthor = ({ url: url, profile_image: profile_image, name: name })=>{
            return `
    <div class="avatar">
      <a href="${url}">
        <img src="${profile_image || ""}" alt="${name}">
      </a>
      <div class="avatar__info">
        <h4>
          ${name}
        </h4>
      </div>
    </div>
    `;
        };
        this.renderTag = ({ url: url, name: name })=>{
            return `
      <a href="${url}" class="tag" data-tag="${name}">${name}</a>
    `;
        };
        document.addEventListener("input", (e)=>{
            if (e.target.matches($d196fa97474c6e66$var$QUERY_FIELD_SELECTOR)) this.debouncedHandleSearch(e);
        });
        document.addEventListener("click", (e)=>{
            if (e.target.matches($d196fa97474c6e66$var$RESET_BUTTON_SELECTOR)) this.clearSearchResults();
        });
    }
}


function $e27bb98248bac4e5$export$62e4ec31312c380a() {
    const searchManager = new (0, $1a626d68ca0b68a4$export$59dbc9ea2b6073f6)();
    const searchUi = new (0, $d196fa97474c6e66$export$c91a17ba0f571ea5)(searchManager);
}


const $6a40b2965ad474f9$var$MODAL_ATTRIBUTE = "data-theme-modal";
const $6a40b2965ad474f9$var$TRIGGER_ATTRIBUTE = "data-theme-modal-trigger";
const $6a40b2965ad474f9$var$CLOSE_ATTRIBUTE = "data-theme-modal-close";
const $6a40b2965ad474f9$var$MODAL_OPEN_ATTRIBUTE = "data-theme-modal-open";
function $6a40b2965ad474f9$export$4b674c99747dd23b() {
    document.addEventListener("click", (event)=>{
        const target = event.target;
        const trigger = target.closest(`[${$6a40b2965ad474f9$var$TRIGGER_ATTRIBUTE}]`);
        const close = target.closest(`[${$6a40b2965ad474f9$var$CLOSE_ATTRIBUTE}]`);
        if (trigger) {
            event.preventDefault();
            $6a40b2965ad474f9$var$handleModalOpen(trigger.getAttribute($6a40b2965ad474f9$var$TRIGGER_ATTRIBUTE) || "");
        } else if (close) {
            event.preventDefault();
            $6a40b2965ad474f9$var$handleModalClose();
        }
    });
    // Close modal on escape key
    document.addEventListener("keydown", (event)=>{
        if (event.key === "Escape") $6a40b2965ad474f9$var$handleModalClose();
    });
}
function $6a40b2965ad474f9$var$handleModalOpen(name) {
    const modal = document.querySelector(`[${$6a40b2965ad474f9$var$MODAL_ATTRIBUTE}="${name}"]`);
    if (!modal) return;
    modal.setAttribute($6a40b2965ad474f9$var$MODAL_OPEN_ATTRIBUTE, "true");
    modal.getElementsByTagName("input")?.[0]?.focus();
}
function $6a40b2965ad474f9$var$handleModalClose() {
    const modal = document.querySelector(`[${$6a40b2965ad474f9$var$MODAL_OPEN_ATTRIBUTE}]`);
    if (!modal) return;
    modal.removeAttribute($6a40b2965ad474f9$var$MODAL_OPEN_ATTRIBUTE);
}



const $8c48e21f2c823446$var$MAIN_LIST_SELECTOR = ".navigation > ul";
const $8c48e21f2c823446$var$AUXILARY_LIST_SELECTOR = ".navigation__auxilary-container ul";
const $8c48e21f2c823446$var$getMainList = ()=>document.querySelector($8c48e21f2c823446$var$MAIN_LIST_SELECTOR);
const $8c48e21f2c823446$var$getAuxilaryList = ()=>document.querySelector($8c48e21f2c823446$var$AUXILARY_LIST_SELECTOR);
function $8c48e21f2c823446$var$isMainListOverflowing() {
    const mainList = $8c48e21f2c823446$var$getMainList();
    const firstItem = mainList.firstElementChild;
    return mainList.scrollHeight > firstItem.offsetHeight;
}
function $8c48e21f2c823446$var$toggleItemsVisibility() {
    const mainList = $8c48e21f2c823446$var$getMainList();
    const auxilaryList = $8c48e21f2c823446$var$getAuxilaryList();
    if (!mainList || !auxilaryList) return;
    const mainListItems = mainList.children;
    const auxilaryListItems = auxilaryList.children;
    for(let i = 0; i < mainListItems.length; i++){
        mainListItems[i].classList.remove("hidden");
        auxilaryListItems[i].classList.add("hidden");
    }
    let count = 0;
    for(let i = mainListItems.length - 1; i >= 0; i--)if ($8c48e21f2c823446$var$isMainListOverflowing()) {
        mainListItems[i].classList.add("hidden");
        auxilaryListItems[i].classList.remove("hidden");
        count++;
    }
}
function $8c48e21f2c823446$export$71732d635643fc60() {
    $8c48e21f2c823446$var$toggleItemsVisibility();
    const throttledToggleItemsVisibility = (0, $081acca11ab4d383$export$de363e709c412c8a)($8c48e21f2c823446$var$toggleItemsVisibility, 200);
    window.addEventListener("resize", throttledToggleItemsVisibility);
}


/*!
  * PhotoSwipe 5.4.4 - https://photoswipe.com
  * (c) 2024 Dmytro Semenov
  */ /** @typedef {import('../photoswipe.js').Point} Point */ /**
 * @template {keyof HTMLElementTagNameMap} T
 * @param {string} className
 * @param {T} tagName
 * @param {Node} [appendToEl]
 * @returns {HTMLElementTagNameMap[T]}
 */ function $1f75a04ded5eb2bf$var$createElement(className, tagName, appendToEl) {
    const el = document.createElement(tagName);
    if (className) el.className = className;
    if (appendToEl) appendToEl.appendChild(el);
    return el;
}
/**
 * @param {Point} p1
 * @param {Point} p2
 * @returns {Point}
 */ function $1f75a04ded5eb2bf$var$equalizePoints(p1, p2) {
    p1.x = p2.x;
    p1.y = p2.y;
    if (p2.id !== undefined) p1.id = p2.id;
    return p1;
}
/**
 * @param {Point} p
 */ function $1f75a04ded5eb2bf$var$roundPoint(p) {
    p.x = Math.round(p.x);
    p.y = Math.round(p.y);
}
/**
 * Returns distance between two points.
 *
 * @param {Point} p1
 * @param {Point} p2
 * @returns {number}
 */ function $1f75a04ded5eb2bf$var$getDistanceBetween(p1, p2) {
    const x = Math.abs(p1.x - p2.x);
    const y = Math.abs(p1.y - p2.y);
    return Math.sqrt(x * x + y * y);
}
/**
 * Whether X and Y positions of points are equal
 *
 * @param {Point} p1
 * @param {Point} p2
 * @returns {boolean}
 */ function $1f75a04ded5eb2bf$var$pointsEqual(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
/**
 * The float result between the min and max values.
 *
 * @param {number} val
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */ function $1f75a04ded5eb2bf$var$clamp(val, min, max) {
    return Math.min(Math.max(val, min), max);
}
/**
 * Get transform string
 *
 * @param {number} x
 * @param {number} [y]
 * @param {number} [scale]
 * @returns {string}
 */ function $1f75a04ded5eb2bf$var$toTransformString(x, y, scale) {
    let propValue = `translate3d(${x}px,${y || 0}px,0)`;
    if (scale !== undefined) propValue += ` scale3d(${scale},${scale},1)`;
    return propValue;
}
/**
 * Apply transform:translate(x, y) scale(scale) to element
 *
 * @param {HTMLElement} el
 * @param {number} x
 * @param {number} [y]
 * @param {number} [scale]
 */ function $1f75a04ded5eb2bf$var$setTransform(el, x, y, scale) {
    el.style.transform = $1f75a04ded5eb2bf$var$toTransformString(x, y, scale);
}
const $1f75a04ded5eb2bf$var$defaultCSSEasing = "cubic-bezier(.4,0,.22,1)";
/**
 * Apply CSS transition to element
 *
 * @param {HTMLElement} el
 * @param {string} [prop] CSS property to animate
 * @param {number} [duration] in ms
 * @param {string} [ease] CSS easing function
 */ function $1f75a04ded5eb2bf$var$setTransitionStyle(el, prop, duration, ease) {
    // inOut: 'cubic-bezier(.4, 0, .22, 1)', // for "toggle state" transitions
    // out: 'cubic-bezier(0, 0, .22, 1)', // for "show" transitions
    // in: 'cubic-bezier(.4, 0, 1, 1)'// for "hide" transitions
    el.style.transition = prop ? `${prop} ${duration}ms ${ease || $1f75a04ded5eb2bf$var$defaultCSSEasing}` : "none";
}
/**
 * Apply width and height CSS properties to element
 *
 * @param {HTMLElement} el
 * @param {string | number} w
 * @param {string | number} h
 */ function $1f75a04ded5eb2bf$var$setWidthHeight(el, w, h) {
    el.style.width = typeof w === "number" ? `${w}px` : w;
    el.style.height = typeof h === "number" ? `${h}px` : h;
}
/**
 * @param {HTMLElement} el
 */ function $1f75a04ded5eb2bf$var$removeTransitionStyle(el) {
    $1f75a04ded5eb2bf$var$setTransitionStyle(el);
}
/**
 * @param {HTMLImageElement} img
 * @returns {Promise<HTMLImageElement | void>}
 */ function $1f75a04ded5eb2bf$var$decodeImage(img) {
    if ("decode" in img) return img.decode().catch(()=>{});
    if (img.complete) return Promise.resolve(img);
    return new Promise((resolve, reject)=>{
        img.onload = ()=>resolve(img);
        img.onerror = reject;
    });
}
/** @typedef {LOAD_STATE[keyof LOAD_STATE]} LoadState */ /** @type {{ IDLE: 'idle'; LOADING: 'loading'; LOADED: 'loaded'; ERROR: 'error' }} */ const $1f75a04ded5eb2bf$var$LOAD_STATE = {
    IDLE: "idle",
    LOADING: "loading",
    LOADED: "loaded",
    ERROR: "error"
};
/**
 * Check if click or keydown event was dispatched
 * with a special key or via mouse wheel.
 *
 * @param {MouseEvent | KeyboardEvent} e
 * @returns {boolean}
 */ function $1f75a04ded5eb2bf$var$specialKeyUsed(e) {
    return "button" in e && e.button === 1 || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey;
}
/**
 * Parse `gallery` or `children` options.
 *
 * @param {import('../photoswipe.js').ElementProvider} [option]
 * @param {string} [legacySelector]
 * @param {HTMLElement | Document} [parent]
 * @returns HTMLElement[]
 */ function $1f75a04ded5eb2bf$var$getElementsFromOption(option, legacySelector, parent = document) {
    /** @type {HTMLElement[]} */ let elements = [];
    if (option instanceof Element) elements = [
        option
    ];
    else if (option instanceof NodeList || Array.isArray(option)) elements = Array.from(option);
    else {
        const selector = typeof option === "string" ? option : legacySelector;
        if (selector) elements = Array.from(parent.querySelectorAll(selector));
    }
    return elements;
}
/**
 * Check if browser is Safari
 *
 * @returns {boolean}
 */ function $1f75a04ded5eb2bf$var$isSafari() {
    return !!(navigator.vendor && navigator.vendor.match(/apple/i));
}
// Detect passive event listener support
let $1f75a04ded5eb2bf$var$supportsPassive = false;
/* eslint-disable */ try {
    /* @ts-ignore */ window.addEventListener("test", null, Object.defineProperty({}, "passive", {
        get: ()=>{
            $1f75a04ded5eb2bf$var$supportsPassive = true;
        }
    }));
} catch (e) {}
/* eslint-enable */ /**
 * @typedef {Object} PoolItem
 * @prop {HTMLElement | Window | Document | undefined | null} target
 * @prop {string} type
 * @prop {EventListenerOrEventListenerObject} listener
 * @prop {boolean} [passive]
 */ class $1f75a04ded5eb2bf$var$DOMEvents {
    constructor(){
        /**
     * @type {PoolItem[]}
     * @private
     */ this._pool = [];
    }
    /**
   * Adds event listeners
   *
   * @param {PoolItem['target']} target
   * @param {PoolItem['type']} type Can be multiple, separated by space.
   * @param {PoolItem['listener']} listener
   * @param {PoolItem['passive']} [passive]
   */ add(target, type, listener, passive) {
        this._toggleListener(target, type, listener, passive);
    }
    /**
   * Removes event listeners
   *
   * @param {PoolItem['target']} target
   * @param {PoolItem['type']} type
   * @param {PoolItem['listener']} listener
   * @param {PoolItem['passive']} [passive]
   */ remove(target, type, listener, passive) {
        this._toggleListener(target, type, listener, passive, true);
    }
    /**
   * Removes all bound events
   */ removeAll() {
        this._pool.forEach((poolItem)=>{
            this._toggleListener(poolItem.target, poolItem.type, poolItem.listener, poolItem.passive, true, true);
        });
        this._pool = [];
    }
    /**
   * Adds or removes event
   *
   * @private
   * @param {PoolItem['target']} target
   * @param {PoolItem['type']} type
   * @param {PoolItem['listener']} listener
   * @param {PoolItem['passive']} [passive]
   * @param {boolean} [unbind] Whether the event should be added or removed
   * @param {boolean} [skipPool] Whether events pool should be skipped
   */ _toggleListener(target, type, listener, passive, unbind, skipPool) {
        if (!target) return;
        const methodName = unbind ? "removeEventListener" : "addEventListener";
        const types = type.split(" ");
        types.forEach((eType)=>{
            if (eType) {
                // Events pool is used to easily unbind all events when PhotoSwipe is closed,
                // so developer doesn't need to do this manually
                if (!skipPool) {
                    if (unbind) // Remove from the events pool
                    this._pool = this._pool.filter((poolItem)=>{
                        return poolItem.type !== eType || poolItem.listener !== listener || poolItem.target !== target;
                    });
                    else // Add to the events pool
                    this._pool.push({
                        target: target,
                        type: eType,
                        listener: listener,
                        passive: passive
                    });
                } // most PhotoSwipe events call preventDefault,
                // and we do not need browser to scroll the page
                const eventOptions = $1f75a04ded5eb2bf$var$supportsPassive ? {
                    passive: passive || false
                } : false;
                target[methodName](eType, listener, eventOptions);
            }
        });
    }
}
/** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */ /** @typedef {import('../core/base.js').default} PhotoSwipeBase */ /** @typedef {import('../photoswipe.js').Point} Point */ /** @typedef {import('../slide/slide.js').SlideData} SlideData */ /**
 * @param {PhotoSwipeOptions} options
 * @param {PhotoSwipeBase} pswp
 * @returns {Point}
 */ function $1f75a04ded5eb2bf$var$getViewportSize(options, pswp) {
    if (options.getViewportSizeFn) {
        const newViewportSize = options.getViewportSizeFn(options, pswp);
        if (newViewportSize) return newViewportSize;
    }
    return {
        x: document.documentElement.clientWidth,
        // TODO: height on mobile is very incosistent due to toolbar
        // find a way to improve this
        //
        // document.documentElement.clientHeight - doesn't seem to work well
        y: window.innerHeight
    };
}
/**
 * Parses padding option.
 * Supported formats:
 *
 * // Object
 * padding: {
 *  top: 0,
 *  bottom: 0,
 *  left: 0,
 *  right: 0
 * }
 *
 * // A function that returns the object
 * paddingFn: (viewportSize, itemData, index) => {
 *  return {
 *    top: 0,
 *    bottom: 0,
 *    left: 0,
 *    right: 0
 *  };
 * }
 *
 * // Legacy variant
 * paddingLeft: 0,
 * paddingRight: 0,
 * paddingTop: 0,
 * paddingBottom: 0,
 *
 * @param {'left' | 'top' | 'bottom' | 'right'} prop
 * @param {PhotoSwipeOptions} options PhotoSwipe options
 * @param {Point} viewportSize PhotoSwipe viewport size, for example: { x:800, y:600 }
 * @param {SlideData} itemData Data about the slide
 * @param {number} index Slide index
 * @returns {number}
 */ function $1f75a04ded5eb2bf$var$parsePaddingOption(prop, options, viewportSize, itemData, index) {
    let paddingValue = 0;
    if (options.paddingFn) paddingValue = options.paddingFn(viewportSize, itemData, index)[prop];
    else if (options.padding) paddingValue = options.padding[prop];
    else {
        const legacyPropName = "padding" + prop[0].toUpperCase() + prop.slice(1); // @ts-expect-error
        if (options[legacyPropName]) // @ts-expect-error
        paddingValue = options[legacyPropName];
    }
    return Number(paddingValue) || 0;
}
/**
 * @param {PhotoSwipeOptions} options
 * @param {Point} viewportSize
 * @param {SlideData} itemData
 * @param {number} index
 * @returns {Point}
 */ function $1f75a04ded5eb2bf$var$getPanAreaSize(options, viewportSize, itemData, index) {
    return {
        x: viewportSize.x - $1f75a04ded5eb2bf$var$parsePaddingOption("left", options, viewportSize, itemData, index) - $1f75a04ded5eb2bf$var$parsePaddingOption("right", options, viewportSize, itemData, index),
        y: viewportSize.y - $1f75a04ded5eb2bf$var$parsePaddingOption("top", options, viewportSize, itemData, index) - $1f75a04ded5eb2bf$var$parsePaddingOption("bottom", options, viewportSize, itemData, index)
    };
}
/** @typedef {import('./slide.js').default} Slide */ /** @typedef {Record<Axis, number>} Point */ /** @typedef {'x' | 'y'} Axis */ /**
 * Calculates minimum, maximum and initial (center) bounds of a slide
 */ class $1f75a04ded5eb2bf$var$PanBounds {
    /**
   * @param {Slide} slide
   */ constructor(slide){
        this.slide = slide;
        this.currZoomLevel = 1;
        this.center = /** @type {Point} */ {
            x: 0,
            y: 0
        };
        this.max = /** @type {Point} */ {
            x: 0,
            y: 0
        };
        this.min = /** @type {Point} */ {
            x: 0,
            y: 0
        };
    }
    /**
   * _getItemBounds
   *
   * @param {number} currZoomLevel
   */ update(currZoomLevel) {
        this.currZoomLevel = currZoomLevel;
        if (!this.slide.width) this.reset();
        else {
            this._updateAxis("x");
            this._updateAxis("y");
            this.slide.pswp.dispatch("calcBounds", {
                slide: this.slide
            });
        }
    }
    /**
   * _calculateItemBoundsForAxis
   *
   * @param {Axis} axis
   */ _updateAxis(axis) {
        const { pswp: pswp } = this.slide;
        const elSize = this.slide[axis === "x" ? "width" : "height"] * this.currZoomLevel;
        const paddingProp = axis === "x" ? "left" : "top";
        const padding = $1f75a04ded5eb2bf$var$parsePaddingOption(paddingProp, pswp.options, pswp.viewportSize, this.slide.data, this.slide.index);
        const panAreaSize = this.slide.panAreaSize[axis]; // Default position of element.
        // By default, it is center of viewport:
        this.center[axis] = Math.round((panAreaSize - elSize) / 2) + padding; // maximum pan position
        this.max[axis] = elSize > panAreaSize ? Math.round(panAreaSize - elSize) + padding : this.center[axis]; // minimum pan position
        this.min[axis] = elSize > panAreaSize ? padding : this.center[axis];
    }
    reset() {
        this.center.x = 0;
        this.center.y = 0;
        this.max.x = 0;
        this.max.y = 0;
        this.min.x = 0;
        this.min.y = 0;
    }
    /**
   * Correct pan position if it's beyond the bounds
   *
   * @param {Axis} axis x or y
   * @param {number} panOffset
   * @returns {number}
   */ correctPan(axis, panOffset) {
        // checkPanBounds
        return $1f75a04ded5eb2bf$var$clamp(panOffset, this.max[axis], this.min[axis]);
    }
}
const $1f75a04ded5eb2bf$var$MAX_IMAGE_WIDTH = 4000;
/** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */ /** @typedef {import('../photoswipe.js').Point} Point */ /** @typedef {import('../slide/slide.js').SlideData} SlideData */ /** @typedef {'fit' | 'fill' | number | ((zoomLevelObject: ZoomLevel) => number)} ZoomLevelOption */ /**
 * Calculates zoom levels for specific slide.
 * Depends on viewport size and image size.
 */ class $1f75a04ded5eb2bf$var$ZoomLevel {
    /**
   * @param {PhotoSwipeOptions} options PhotoSwipe options
   * @param {SlideData} itemData Slide data
   * @param {number} index Slide index
   * @param {PhotoSwipe} [pswp] PhotoSwipe instance, can be undefined if not initialized yet
   */ constructor(options, itemData, index, pswp){
        this.pswp = pswp;
        this.options = options;
        this.itemData = itemData;
        this.index = index;
        /** @type { Point | null } */ this.panAreaSize = null;
        /** @type { Point | null } */ this.elementSize = null;
        this.fit = 1;
        this.fill = 1;
        this.vFill = 1;
        this.initial = 1;
        this.secondary = 1;
        this.max = 1;
        this.min = 1;
    }
    /**
   * Calculate initial, secondary and maximum zoom level for the specified slide.
   *
   * It should be called when either image or viewport size changes.
   *
   * @param {number} maxWidth
   * @param {number} maxHeight
   * @param {Point} panAreaSize
   */ update(maxWidth, maxHeight, panAreaSize) {
        /** @type {Point} */ const elementSize = {
            x: maxWidth,
            y: maxHeight
        };
        this.elementSize = elementSize;
        this.panAreaSize = panAreaSize;
        const hRatio = panAreaSize.x / elementSize.x;
        const vRatio = panAreaSize.y / elementSize.y;
        this.fit = Math.min(1, hRatio < vRatio ? hRatio : vRatio);
        this.fill = Math.min(1, hRatio > vRatio ? hRatio : vRatio); // zoom.vFill defines zoom level of the image
        // when it has 100% of viewport vertical space (height)
        this.vFill = Math.min(1, vRatio);
        this.initial = this._getInitial();
        this.secondary = this._getSecondary();
        this.max = Math.max(this.initial, this.secondary, this._getMax());
        this.min = Math.min(this.fit, this.initial, this.secondary);
        if (this.pswp) this.pswp.dispatch("zoomLevelsUpdate", {
            zoomLevels: this,
            slideData: this.itemData
        });
    }
    /**
   * Parses user-defined zoom option.
   *
   * @private
   * @param {'initial' | 'secondary' | 'max'} optionPrefix Zoom level option prefix (initial, secondary, max)
   * @returns { number | undefined }
   */ _parseZoomLevelOption(optionPrefix) {
        const optionName = /** @type {'initialZoomLevel' | 'secondaryZoomLevel' | 'maxZoomLevel'} */ optionPrefix + "ZoomLevel";
        const optionValue = this.options[optionName];
        if (!optionValue) return;
        if (typeof optionValue === "function") return optionValue(this);
        if (optionValue === "fill") return this.fill;
        if (optionValue === "fit") return this.fit;
        return Number(optionValue);
    }
    /**
   * Get zoom level to which image will be zoomed after double-tap gesture,
   * or when user clicks on zoom icon,
   * or mouse-click on image itself.
   * If you return 1 image will be zoomed to its original size.
   *
   * @private
   * @return {number}
   */ _getSecondary() {
        let currZoomLevel = this._parseZoomLevelOption("secondary");
        if (currZoomLevel) return currZoomLevel;
         // 3x of "fit" state, but not larger than original
        currZoomLevel = Math.min(1, this.fit * 3);
        if (this.elementSize && currZoomLevel * this.elementSize.x > $1f75a04ded5eb2bf$var$MAX_IMAGE_WIDTH) currZoomLevel = $1f75a04ded5eb2bf$var$MAX_IMAGE_WIDTH / this.elementSize.x;
        return currZoomLevel;
    }
    /**
   * Get initial image zoom level.
   *
   * @private
   * @return {number}
   */ _getInitial() {
        return this._parseZoomLevelOption("initial") || this.fit;
    }
    /**
   * Maximum zoom level when user zooms
   * via zoom/pinch gesture,
   * via cmd/ctrl-wheel or via trackpad.
   *
   * @private
   * @return {number}
   */ _getMax() {
        // max zoom level is x4 from "fit state",
        // used for zoom gesture and ctrl/trackpad zoom
        return this._parseZoomLevelOption("max") || Math.max(1, this.fit * 4);
    }
}
/** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /**
 * Renders and allows to control a single slide
 */ class $1f75a04ded5eb2bf$var$Slide {
    /**
   * @param {SlideData} data
   * @param {number} index
   * @param {PhotoSwipe} pswp
   */ constructor(data, index, pswp){
        this.data = data;
        this.index = index;
        this.pswp = pswp;
        this.isActive = index === pswp.currIndex;
        this.currentResolution = 0;
        /** @type {Point} */ this.panAreaSize = {
            x: 0,
            y: 0
        };
        /** @type {Point} */ this.pan = {
            x: 0,
            y: 0
        };
        this.isFirstSlide = this.isActive && !pswp.opener.isOpen;
        this.zoomLevels = new $1f75a04ded5eb2bf$var$ZoomLevel(pswp.options, data, index, pswp);
        this.pswp.dispatch("gettingData", {
            slide: this,
            data: this.data,
            index: index
        });
        this.content = this.pswp.contentLoader.getContentBySlide(this);
        this.container = $1f75a04ded5eb2bf$var$createElement("pswp__zoom-wrap", "div");
        /** @type {HTMLElement | null} */ this.holderElement = null;
        this.currZoomLevel = 1;
        /** @type {number} */ this.width = this.content.width;
        /** @type {number} */ this.height = this.content.height;
        this.heavyAppended = false;
        this.bounds = new $1f75a04ded5eb2bf$var$PanBounds(this);
        this.prevDisplayedWidth = -1;
        this.prevDisplayedHeight = -1;
        this.pswp.dispatch("slideInit", {
            slide: this
        });
    }
    /**
   * If this slide is active/current/visible
   *
   * @param {boolean} isActive
   */ setIsActive(isActive) {
        if (isActive && !this.isActive) // slide just became active
        this.activate();
        else if (!isActive && this.isActive) // slide just became non-active
        this.deactivate();
    }
    /**
   * Appends slide content to DOM
   *
   * @param {HTMLElement} holderElement
   */ append(holderElement) {
        this.holderElement = holderElement;
        this.container.style.transformOrigin = "0 0"; // Slide appended to DOM
        if (!this.data) return;
        this.calculateSize();
        this.load();
        this.updateContentSize();
        this.appendHeavy();
        this.holderElement.appendChild(this.container);
        this.zoomAndPanToInitial();
        this.pswp.dispatch("firstZoomPan", {
            slide: this
        });
        this.applyCurrentZoomPan();
        this.pswp.dispatch("afterSetContent", {
            slide: this
        });
        if (this.isActive) this.activate();
    }
    load() {
        this.content.load(false);
        this.pswp.dispatch("slideLoad", {
            slide: this
        });
    }
    /**
   * Append "heavy" DOM elements
   *
   * This may depend on a type of slide,
   * but generally these are large images.
   */ appendHeavy() {
        const { pswp: pswp } = this;
        const appendHeavyNearby = true; // todo
        // Avoid appending heavy elements during animations
        if (this.heavyAppended || !pswp.opener.isOpen || pswp.mainScroll.isShifted() || !this.isActive && !appendHeavyNearby) return;
        if (this.pswp.dispatch("appendHeavy", {
            slide: this
        }).defaultPrevented) return;
        this.heavyAppended = true;
        this.content.append();
        this.pswp.dispatch("appendHeavyContent", {
            slide: this
        });
    }
    /**
   * Triggered when this slide is active (selected).
   *
   * If it's part of opening/closing transition -
   * activate() will trigger after the transition is ended.
   */ activate() {
        this.isActive = true;
        this.appendHeavy();
        this.content.activate();
        this.pswp.dispatch("slideActivate", {
            slide: this
        });
    }
    /**
   * Triggered when this slide becomes inactive.
   *
   * Slide can become inactive only after it was active.
   */ deactivate() {
        this.isActive = false;
        this.content.deactivate();
        if (this.currZoomLevel !== this.zoomLevels.initial) // allow filtering
        this.calculateSize();
         // reset zoom level
        this.currentResolution = 0;
        this.zoomAndPanToInitial();
        this.applyCurrentZoomPan();
        this.updateContentSize();
        this.pswp.dispatch("slideDeactivate", {
            slide: this
        });
    }
    /**
   * The slide should destroy itself, it will never be used again.
   * (unbind all events and destroy internal components)
   */ destroy() {
        this.content.hasSlide = false;
        this.content.remove();
        this.container.remove();
        this.pswp.dispatch("slideDestroy", {
            slide: this
        });
    }
    resize() {
        if (this.currZoomLevel === this.zoomLevels.initial || !this.isActive) {
            // Keep initial zoom level if it was before the resize,
            // as well as when this slide is not active
            // Reset position and scale to original state
            this.calculateSize();
            this.currentResolution = 0;
            this.zoomAndPanToInitial();
            this.applyCurrentZoomPan();
            this.updateContentSize();
        } else {
            // readjust pan position if it's beyond the bounds
            this.calculateSize();
            this.bounds.update(this.currZoomLevel);
            this.panTo(this.pan.x, this.pan.y);
        }
    }
    /**
   * Apply size to current slide content,
   * based on the current resolution and scale.
   *
   * @param {boolean} [force] if size should be updated even if dimensions weren't changed
   */ updateContentSize(force) {
        // Use initial zoom level
        // if resolution is not defined (user didn't zoom yet)
        const scaleMultiplier = this.currentResolution || this.zoomLevels.initial;
        if (!scaleMultiplier) return;
        const width = Math.round(this.width * scaleMultiplier) || this.pswp.viewportSize.x;
        const height = Math.round(this.height * scaleMultiplier) || this.pswp.viewportSize.y;
        if (!this.sizeChanged(width, height) && !force) return;
        this.content.setDisplayedSize(width, height);
    }
    /**
   * @param {number} width
   * @param {number} height
   */ sizeChanged(width, height) {
        if (width !== this.prevDisplayedWidth || height !== this.prevDisplayedHeight) {
            this.prevDisplayedWidth = width;
            this.prevDisplayedHeight = height;
            return true;
        }
        return false;
    }
    /** @returns {HTMLImageElement | HTMLDivElement | null | undefined} */ getPlaceholderElement() {
        var _this$content$placeho;
        return (_this$content$placeho = this.content.placeholder) === null || _this$content$placeho === void 0 ? void 0 : _this$content$placeho.element;
    }
    /**
   * Zoom current slide image to...
   *
   * @param {number} destZoomLevel Destination zoom level.
   * @param {Point} [centerPoint]
   * Transform origin center point, or false if viewport center should be used.
   * @param {number | false} [transitionDuration] Transition duration, may be set to 0.
   * @param {boolean} [ignoreBounds] Minimum and maximum zoom levels will be ignored.
   */ zoomTo(destZoomLevel, centerPoint, transitionDuration, ignoreBounds) {
        const { pswp: pswp } = this;
        if (!this.isZoomable() || pswp.mainScroll.isShifted()) return;
        pswp.dispatch("beforeZoomTo", {
            destZoomLevel: destZoomLevel,
            centerPoint: centerPoint,
            transitionDuration: transitionDuration
        }); // stop all pan and zoom transitions
        pswp.animations.stopAllPan(); // if (!centerPoint) {
        //   centerPoint = pswp.getViewportCenterPoint();
        // }
        const prevZoomLevel = this.currZoomLevel;
        if (!ignoreBounds) destZoomLevel = $1f75a04ded5eb2bf$var$clamp(destZoomLevel, this.zoomLevels.min, this.zoomLevels.max);
         // if (transitionDuration === undefined) {
        //   transitionDuration = this.pswp.options.zoomAnimationDuration;
        // }
        this.setZoomLevel(destZoomLevel);
        this.pan.x = this.calculateZoomToPanOffset("x", centerPoint, prevZoomLevel);
        this.pan.y = this.calculateZoomToPanOffset("y", centerPoint, prevZoomLevel);
        $1f75a04ded5eb2bf$var$roundPoint(this.pan);
        const finishTransition = ()=>{
            this._setResolution(destZoomLevel);
            this.applyCurrentZoomPan();
        };
        if (!transitionDuration) finishTransition();
        else pswp.animations.startTransition({
            isPan: true,
            name: "zoomTo",
            target: this.container,
            transform: this.getCurrentTransform(),
            onComplete: finishTransition,
            duration: transitionDuration,
            easing: pswp.options.easing
        });
    }
    /**
   * @param {Point} [centerPoint]
   */ toggleZoom(centerPoint) {
        this.zoomTo(this.currZoomLevel === this.zoomLevels.initial ? this.zoomLevels.secondary : this.zoomLevels.initial, centerPoint, this.pswp.options.zoomAnimationDuration);
    }
    /**
   * Updates zoom level property and recalculates new pan bounds,
   * unlike zoomTo it does not apply transform (use applyCurrentZoomPan)
   *
   * @param {number} currZoomLevel
   */ setZoomLevel(currZoomLevel) {
        this.currZoomLevel = currZoomLevel;
        this.bounds.update(this.currZoomLevel);
    }
    /**
   * Get pan position after zoom at a given `point`.
   *
   * Always call setZoomLevel(newZoomLevel) beforehand to recalculate
   * pan bounds according to the new zoom level.
   *
   * @param {'x' | 'y'} axis
   * @param {Point} [point]
   * point based on which zoom is performed, usually refers to the current mouse position,
   * if false - viewport center will be used.
   * @param {number} [prevZoomLevel] Zoom level before new zoom was applied.
   * @returns {number}
   */ calculateZoomToPanOffset(axis, point, prevZoomLevel) {
        const totalPanDistance = this.bounds.max[axis] - this.bounds.min[axis];
        if (totalPanDistance === 0) return this.bounds.center[axis];
        if (!point) point = this.pswp.getViewportCenterPoint();
        if (!prevZoomLevel) prevZoomLevel = this.zoomLevels.initial;
        const zoomFactor = this.currZoomLevel / prevZoomLevel;
        return this.bounds.correctPan(axis, (this.pan[axis] - point[axis]) * zoomFactor + point[axis]);
    }
    /**
   * Apply pan and keep it within bounds.
   *
   * @param {number} panX
   * @param {number} panY
   */ panTo(panX, panY) {
        this.pan.x = this.bounds.correctPan("x", panX);
        this.pan.y = this.bounds.correctPan("y", panY);
        this.applyCurrentZoomPan();
    }
    /**
   * If the slide in the current state can be panned by the user
   * @returns {boolean}
   */ isPannable() {
        return Boolean(this.width) && this.currZoomLevel > this.zoomLevels.fit;
    }
    /**
   * If the slide can be zoomed
   * @returns {boolean}
   */ isZoomable() {
        return Boolean(this.width) && this.content.isZoomable();
    }
    /**
   * Apply transform and scale based on
   * the current pan position (this.pan) and zoom level (this.currZoomLevel)
   */ applyCurrentZoomPan() {
        this._applyZoomTransform(this.pan.x, this.pan.y, this.currZoomLevel);
        if (this === this.pswp.currSlide) this.pswp.dispatch("zoomPanUpdate", {
            slide: this
        });
    }
    zoomAndPanToInitial() {
        this.currZoomLevel = this.zoomLevels.initial; // pan according to the zoom level
        this.bounds.update(this.currZoomLevel);
        $1f75a04ded5eb2bf$var$equalizePoints(this.pan, this.bounds.center);
        this.pswp.dispatch("initialZoomPan", {
            slide: this
        });
    }
    /**
   * Set translate and scale based on current resolution
   *
   * @param {number} x
   * @param {number} y
   * @param {number} zoom
   * @private
   */ _applyZoomTransform(x, y, zoom) {
        zoom /= this.currentResolution || this.zoomLevels.initial;
        $1f75a04ded5eb2bf$var$setTransform(this.container, x, y, zoom);
    }
    calculateSize() {
        const { pswp: pswp } = this;
        $1f75a04ded5eb2bf$var$equalizePoints(this.panAreaSize, $1f75a04ded5eb2bf$var$getPanAreaSize(pswp.options, pswp.viewportSize, this.data, this.index));
        this.zoomLevels.update(this.width, this.height, this.panAreaSize);
        pswp.dispatch("calcSlideSize", {
            slide: this
        });
    }
    /** @returns {string} */ getCurrentTransform() {
        const scale = this.currZoomLevel / (this.currentResolution || this.zoomLevels.initial);
        return $1f75a04ded5eb2bf$var$toTransformString(this.pan.x, this.pan.y, scale);
    }
    /**
   * Set resolution and re-render the image.
   *
   * For example, if the real image size is 2000x1500,
   * and resolution is 0.5 - it will be rendered as 1000x750.
   *
   * Image with zoom level 2 and resolution 0.5 is
   * the same as image with zoom level 1 and resolution 1.
   *
   * Used to optimize animations and make
   * sure that browser renders image in the highest quality.
   * Also used by responsive images to load the correct one.
   *
   * @param {number} newResolution
   */ _setResolution(newResolution) {
        if (newResolution === this.currentResolution) return;
        this.currentResolution = newResolution;
        this.updateContentSize();
        this.pswp.dispatch("resolutionChanged");
    }
}
/** @typedef {import('../photoswipe.js').Point} Point */ /** @typedef {import('./gestures.js').default} Gestures */ const $1f75a04ded5eb2bf$var$PAN_END_FRICTION = 0.35;
const $1f75a04ded5eb2bf$var$VERTICAL_DRAG_FRICTION = 0.6; // 1 corresponds to the third of viewport height
const $1f75a04ded5eb2bf$var$MIN_RATIO_TO_CLOSE = 0.4; // Minimum speed required to navigate
// to next or previous slide
const $1f75a04ded5eb2bf$var$MIN_NEXT_SLIDE_SPEED = 0.5;
/**
 * @param {number} initialVelocity
 * @param {number} decelerationRate
 * @returns {number}
 */ function $1f75a04ded5eb2bf$var$project(initialVelocity, decelerationRate) {
    return initialVelocity * decelerationRate / (1 - decelerationRate);
}
/**
 * Handles single pointer dragging
 */ class $1f75a04ded5eb2bf$var$DragHandler {
    /**
   * @param {Gestures} gestures
   */ constructor(gestures){
        this.gestures = gestures;
        this.pswp = gestures.pswp;
        /** @type {Point} */ this.startPan = {
            x: 0,
            y: 0
        };
    }
    start() {
        if (this.pswp.currSlide) $1f75a04ded5eb2bf$var$equalizePoints(this.startPan, this.pswp.currSlide.pan);
        this.pswp.animations.stopAll();
    }
    change() {
        const { p1: p1, prevP1: prevP1, dragAxis: dragAxis } = this.gestures;
        const { currSlide: currSlide } = this.pswp;
        if (dragAxis === "y" && this.pswp.options.closeOnVerticalDrag && currSlide && currSlide.currZoomLevel <= currSlide.zoomLevels.fit && !this.gestures.isMultitouch) {
            // Handle vertical drag to close
            const panY = currSlide.pan.y + (p1.y - prevP1.y);
            if (!this.pswp.dispatch("verticalDrag", {
                panY: panY
            }).defaultPrevented) {
                this._setPanWithFriction("y", panY, $1f75a04ded5eb2bf$var$VERTICAL_DRAG_FRICTION);
                const bgOpacity = 1 - Math.abs(this._getVerticalDragRatio(currSlide.pan.y));
                this.pswp.applyBgOpacity(bgOpacity);
                currSlide.applyCurrentZoomPan();
            }
        } else {
            const mainScrollChanged = this._panOrMoveMainScroll("x");
            if (!mainScrollChanged) {
                this._panOrMoveMainScroll("y");
                if (currSlide) {
                    $1f75a04ded5eb2bf$var$roundPoint(currSlide.pan);
                    currSlide.applyCurrentZoomPan();
                }
            }
        }
    }
    end() {
        const { velocity: velocity } = this.gestures;
        const { mainScroll: mainScroll, currSlide: currSlide } = this.pswp;
        let indexDiff = 0;
        this.pswp.animations.stopAll(); // Handle main scroll if it's shifted
        if (mainScroll.isShifted()) {
            // Position of the main scroll relative to the viewport
            const mainScrollShiftDiff = mainScroll.x - mainScroll.getCurrSlideX(); // Ratio between 0 and 1:
            // 0 - slide is not visible at all,
            // 0.5 - half of the slide is visible
            // 1 - slide is fully visible
            const currentSlideVisibilityRatio = mainScrollShiftDiff / this.pswp.viewportSize.x; // Go next slide.
            //
            // - if velocity and its direction is matched,
            //   and we see at least tiny part of the next slide
            //
            // - or if we see less than 50% of the current slide
            //   and velocity is close to 0
            //
            if (velocity.x < -$1f75a04ded5eb2bf$var$MIN_NEXT_SLIDE_SPEED && currentSlideVisibilityRatio < 0 || velocity.x < 0.1 && currentSlideVisibilityRatio < -0.5) {
                // Go to next slide
                indexDiff = 1;
                velocity.x = Math.min(velocity.x, 0);
            } else if (velocity.x > $1f75a04ded5eb2bf$var$MIN_NEXT_SLIDE_SPEED && currentSlideVisibilityRatio > 0 || velocity.x > -0.1 && currentSlideVisibilityRatio > 0.5) {
                // Go to prev slide
                indexDiff = -1;
                velocity.x = Math.max(velocity.x, 0);
            }
            mainScroll.moveIndexBy(indexDiff, true, velocity.x);
        } // Restore zoom level
        if (currSlide && currSlide.currZoomLevel > currSlide.zoomLevels.max || this.gestures.isMultitouch) this.gestures.zoomLevels.correctZoomPan(true);
        else {
            // we run two animations instead of one,
            // as each axis has own pan boundaries and thus different spring function
            // (correctZoomPan does not have this functionality,
            //  it animates all properties with single timing function)
            this._finishPanGestureForAxis("x");
            this._finishPanGestureForAxis("y");
        }
    }
    /**
   * @private
   * @param {'x' | 'y'} axis
   */ _finishPanGestureForAxis(axis) {
        const { velocity: velocity } = this.gestures;
        const { currSlide: currSlide } = this.pswp;
        if (!currSlide) return;
        const { pan: pan, bounds: bounds } = currSlide;
        const panPos = pan[axis];
        const restoreBgOpacity = this.pswp.bgOpacity < 1 && axis === "y"; // 0.995 means - scroll view loses 0.5% of its velocity per millisecond
        // Increasing this number will reduce travel distance
        const decelerationRate = 0.995; // 0.99
        // Pan position if there is no bounds
        const projectedPosition = panPos + $1f75a04ded5eb2bf$var$project(velocity[axis], decelerationRate);
        if (restoreBgOpacity) {
            const vDragRatio = this._getVerticalDragRatio(panPos);
            const projectedVDragRatio = this._getVerticalDragRatio(projectedPosition); // If we are above and moving upwards,
            // or if we are below and moving downwards
            if (vDragRatio < 0 && projectedVDragRatio < -$1f75a04ded5eb2bf$var$MIN_RATIO_TO_CLOSE || vDragRatio > 0 && projectedVDragRatio > $1f75a04ded5eb2bf$var$MIN_RATIO_TO_CLOSE) {
                this.pswp.close();
                return;
            }
        } // Pan position with corrected bounds
        const correctedPanPosition = bounds.correctPan(axis, projectedPosition); // Exit if pan position should not be changed
        // or if speed it too low
        if (panPos === correctedPanPosition) return;
         // Overshoot if the final position is out of pan bounds
        const dampingRatio = correctedPanPosition === projectedPosition ? 1 : 0.82;
        const initialBgOpacity = this.pswp.bgOpacity;
        const totalPanDist = correctedPanPosition - panPos;
        this.pswp.animations.startSpring({
            name: "panGesture" + axis,
            isPan: true,
            start: panPos,
            end: correctedPanPosition,
            velocity: velocity[axis],
            dampingRatio: dampingRatio,
            onUpdate: (pos)=>{
                // Animate opacity of background relative to Y pan position of an image
                if (restoreBgOpacity && this.pswp.bgOpacity < 1) {
                    // 0 - start of animation, 1 - end of animation
                    const animationProgressRatio = 1 - (correctedPanPosition - pos) / totalPanDist; // We clamp opacity to keep it between 0 and 1.
                    // As progress ratio can be larger than 1 due to overshoot,
                    // and we do not want to bounce opacity.
                    this.pswp.applyBgOpacity($1f75a04ded5eb2bf$var$clamp(initialBgOpacity + (1 - initialBgOpacity) * animationProgressRatio, 0, 1));
                }
                pan[axis] = Math.floor(pos);
                currSlide.applyCurrentZoomPan();
            }
        });
    }
    /**
   * Update position of the main scroll,
   * or/and update pan position of the current slide.
   *
   * Should return true if it changes (or can change) main scroll.
   *
   * @private
   * @param {'x' | 'y'} axis
   * @returns {boolean}
   */ _panOrMoveMainScroll(axis) {
        const { p1: p1, dragAxis: dragAxis, prevP1: prevP1, isMultitouch: isMultitouch } = this.gestures;
        const { currSlide: currSlide, mainScroll: mainScroll } = this.pswp;
        const delta = p1[axis] - prevP1[axis];
        const newMainScrollX = mainScroll.x + delta;
        if (!delta || !currSlide) return false;
         // Always move main scroll if image can not be panned
        if (axis === "x" && !currSlide.isPannable() && !isMultitouch) {
            mainScroll.moveTo(newMainScrollX, true);
            return true; // changed main scroll
        }
        const { bounds: bounds } = currSlide;
        const newPan = currSlide.pan[axis] + delta;
        if (this.pswp.options.allowPanToNext && dragAxis === "x" && axis === "x" && !isMultitouch) {
            const currSlideMainScrollX = mainScroll.getCurrSlideX(); // Position of the main scroll relative to the viewport
            const mainScrollShiftDiff = mainScroll.x - currSlideMainScrollX;
            const isLeftToRight = delta > 0;
            const isRightToLeft = !isLeftToRight;
            if (newPan > bounds.min[axis] && isLeftToRight) {
                // Panning from left to right, beyond the left edge
                // Wether the image was at minimum pan position (or less)
                // when this drag gesture started.
                // Minimum pan position refers to the left edge of the image.
                const wasAtMinPanPosition = bounds.min[axis] <= this.startPan[axis];
                if (wasAtMinPanPosition) {
                    mainScroll.moveTo(newMainScrollX, true);
                    return true;
                } else this._setPanWithFriction(axis, newPan); //currSlide.pan[axis] = newPan;
            } else if (newPan < bounds.max[axis] && isRightToLeft) {
                // Paning from right to left, beyond the right edge
                // Maximum pan position refers to the right edge of the image.
                const wasAtMaxPanPosition = this.startPan[axis] <= bounds.max[axis];
                if (wasAtMaxPanPosition) {
                    mainScroll.moveTo(newMainScrollX, true);
                    return true;
                } else this._setPanWithFriction(axis, newPan); //currSlide.pan[axis] = newPan;
            } else // If main scroll is shifted
            if (mainScrollShiftDiff !== 0) {
                // If main scroll is shifted right
                if (mainScrollShiftDiff > 0) {
                    mainScroll.moveTo(Math.max(newMainScrollX, currSlideMainScrollX), true);
                    return true;
                } else if (mainScrollShiftDiff < 0) {
                    // Main scroll is shifted left (Position is less than 0 comparing to the viewport 0)
                    mainScroll.moveTo(Math.min(newMainScrollX, currSlideMainScrollX), true);
                    return true;
                }
            } else // We are within pan bounds, so just pan
            this._setPanWithFriction(axis, newPan);
        } else {
            if (axis === "y") // Do not pan vertically if main scroll is shifted o
            {
                if (!mainScroll.isShifted() && bounds.min.y !== bounds.max.y) this._setPanWithFriction(axis, newPan);
            } else this._setPanWithFriction(axis, newPan);
        }
        return false;
    }
    // If we move below the ratio is positive
    /**
   * Relation between pan Y position and third of viewport height.
   *
   * When we are at initial position (center bounds) - the ratio is 0,
   * if position is shifted upwards - the ratio is negative,
   * if position is shifted downwards - the ratio is positive.
   *
   * @private
   * @param {number} panY The current pan Y position.
   * @returns {number}
   */ _getVerticalDragRatio(panY) {
        var _this$pswp$currSlide$, _this$pswp$currSlide;
        return (panY - ((_this$pswp$currSlide$ = (_this$pswp$currSlide = this.pswp.currSlide) === null || _this$pswp$currSlide === void 0 ? void 0 : _this$pswp$currSlide.bounds.center.y) !== null && _this$pswp$currSlide$ !== void 0 ? _this$pswp$currSlide$ : 0)) / (this.pswp.viewportSize.y / 3);
    }
    /**
   * Set pan position of the current slide.
   * Apply friction if the position is beyond the pan bounds,
   * or if custom friction is defined.
   *
   * @private
   * @param {'x' | 'y'} axis
   * @param {number} potentialPan
   * @param {number} [customFriction] (0.1 - 1)
   */ _setPanWithFriction(axis, potentialPan, customFriction) {
        const { currSlide: currSlide } = this.pswp;
        if (!currSlide) return;
        const { pan: pan, bounds: bounds } = currSlide;
        const correctedPan = bounds.correctPan(axis, potentialPan); // If we are out of pan bounds
        if (correctedPan !== potentialPan || customFriction) {
            const delta = Math.round(potentialPan - pan[axis]);
            pan[axis] += delta * (customFriction || $1f75a04ded5eb2bf$var$PAN_END_FRICTION);
        } else pan[axis] = potentialPan;
    }
}
/** @typedef {import('../photoswipe.js').Point} Point */ /** @typedef {import('./gestures.js').default} Gestures */ const $1f75a04ded5eb2bf$var$UPPER_ZOOM_FRICTION = 0.05;
const $1f75a04ded5eb2bf$var$LOWER_ZOOM_FRICTION = 0.15;
/**
 * Get center point between two points
 *
 * @param {Point} p
 * @param {Point} p1
 * @param {Point} p2
 * @returns {Point}
 */ function $1f75a04ded5eb2bf$var$getZoomPointsCenter(p, p1, p2) {
    p.x = (p1.x + p2.x) / 2;
    p.y = (p1.y + p2.y) / 2;
    return p;
}
class $1f75a04ded5eb2bf$var$ZoomHandler {
    /**
   * @param {Gestures} gestures
   */ constructor(gestures){
        this.gestures = gestures;
        /**
     * @private
     * @type {Point}
     */ this._startPan = {
            x: 0,
            y: 0
        };
        /**
     * @private
     * @type {Point}
     */ this._startZoomPoint = {
            x: 0,
            y: 0
        };
        /**
     * @private
     * @type {Point}
     */ this._zoomPoint = {
            x: 0,
            y: 0
        };
        /** @private */ this._wasOverFitZoomLevel = false;
        /** @private */ this._startZoomLevel = 1;
    }
    start() {
        const { currSlide: currSlide } = this.gestures.pswp;
        if (currSlide) {
            this._startZoomLevel = currSlide.currZoomLevel;
            $1f75a04ded5eb2bf$var$equalizePoints(this._startPan, currSlide.pan);
        }
        this.gestures.pswp.animations.stopAllPan();
        this._wasOverFitZoomLevel = false;
    }
    change() {
        const { p1: p1, startP1: startP1, p2: p2, startP2: startP2, pswp: pswp } = this.gestures;
        const { currSlide: currSlide } = pswp;
        if (!currSlide) return;
        const minZoomLevel = currSlide.zoomLevels.min;
        const maxZoomLevel = currSlide.zoomLevels.max;
        if (!currSlide.isZoomable() || pswp.mainScroll.isShifted()) return;
        $1f75a04ded5eb2bf$var$getZoomPointsCenter(this._startZoomPoint, startP1, startP2);
        $1f75a04ded5eb2bf$var$getZoomPointsCenter(this._zoomPoint, p1, p2);
        let currZoomLevel = 1 / $1f75a04ded5eb2bf$var$getDistanceBetween(startP1, startP2) * $1f75a04ded5eb2bf$var$getDistanceBetween(p1, p2) * this._startZoomLevel; // slightly over the zoom.fit
        if (currZoomLevel > currSlide.zoomLevels.initial + currSlide.zoomLevels.initial / 15) this._wasOverFitZoomLevel = true;
        if (currZoomLevel < minZoomLevel) {
            if (pswp.options.pinchToClose && !this._wasOverFitZoomLevel && this._startZoomLevel <= currSlide.zoomLevels.initial) {
                // fade out background if zooming out
                const bgOpacity = 1 - (minZoomLevel - currZoomLevel) / (minZoomLevel / 1.2);
                if (!pswp.dispatch("pinchClose", {
                    bgOpacity: bgOpacity
                }).defaultPrevented) pswp.applyBgOpacity(bgOpacity);
            } else // Apply the friction if zoom level is below the min
            currZoomLevel = minZoomLevel - (minZoomLevel - currZoomLevel) * $1f75a04ded5eb2bf$var$LOWER_ZOOM_FRICTION;
        } else if (currZoomLevel > maxZoomLevel) // Apply the friction if zoom level is above the max
        currZoomLevel = maxZoomLevel + (currZoomLevel - maxZoomLevel) * $1f75a04ded5eb2bf$var$UPPER_ZOOM_FRICTION;
        currSlide.pan.x = this._calculatePanForZoomLevel("x", currZoomLevel);
        currSlide.pan.y = this._calculatePanForZoomLevel("y", currZoomLevel);
        currSlide.setZoomLevel(currZoomLevel);
        currSlide.applyCurrentZoomPan();
    }
    end() {
        const { pswp: pswp } = this.gestures;
        const { currSlide: currSlide } = pswp;
        if ((!currSlide || currSlide.currZoomLevel < currSlide.zoomLevels.initial) && !this._wasOverFitZoomLevel && pswp.options.pinchToClose) pswp.close();
        else this.correctZoomPan();
    }
    /**
   * @private
   * @param {'x' | 'y'} axis
   * @param {number} currZoomLevel
   * @returns {number}
   */ _calculatePanForZoomLevel(axis, currZoomLevel) {
        const zoomFactor = currZoomLevel / this._startZoomLevel;
        return this._zoomPoint[axis] - (this._startZoomPoint[axis] - this._startPan[axis]) * zoomFactor;
    }
    /**
   * Correct currZoomLevel and pan if they are
   * beyond minimum or maximum values.
   * With animation.
   *
   * @param {boolean} [ignoreGesture]
   * Wether gesture coordinates should be ignored when calculating destination pan position.
   */ correctZoomPan(ignoreGesture) {
        const { pswp: pswp } = this.gestures;
        const { currSlide: currSlide } = pswp;
        if (!(currSlide !== null && currSlide !== void 0 && currSlide.isZoomable())) return;
        if (this._zoomPoint.x === 0) ignoreGesture = true;
        const prevZoomLevel = currSlide.currZoomLevel;
        /** @type {number} */ let destinationZoomLevel;
        let currZoomLevelNeedsChange = true;
        if (prevZoomLevel < currSlide.zoomLevels.initial) destinationZoomLevel = currSlide.zoomLevels.initial; // zoom to min
        else if (prevZoomLevel > currSlide.zoomLevels.max) destinationZoomLevel = currSlide.zoomLevels.max; // zoom to max
        else {
            currZoomLevelNeedsChange = false;
            destinationZoomLevel = prevZoomLevel;
        }
        const initialBgOpacity = pswp.bgOpacity;
        const restoreBgOpacity = pswp.bgOpacity < 1;
        const initialPan = $1f75a04ded5eb2bf$var$equalizePoints({
            x: 0,
            y: 0
        }, currSlide.pan);
        let destinationPan = $1f75a04ded5eb2bf$var$equalizePoints({
            x: 0,
            y: 0
        }, initialPan);
        if (ignoreGesture) {
            this._zoomPoint.x = 0;
            this._zoomPoint.y = 0;
            this._startZoomPoint.x = 0;
            this._startZoomPoint.y = 0;
            this._startZoomLevel = prevZoomLevel;
            $1f75a04ded5eb2bf$var$equalizePoints(this._startPan, initialPan);
        }
        if (currZoomLevelNeedsChange) destinationPan = {
            x: this._calculatePanForZoomLevel("x", destinationZoomLevel),
            y: this._calculatePanForZoomLevel("y", destinationZoomLevel)
        };
         // set zoom level, so pan bounds are updated according to it
        currSlide.setZoomLevel(destinationZoomLevel);
        destinationPan = {
            x: currSlide.bounds.correctPan("x", destinationPan.x),
            y: currSlide.bounds.correctPan("y", destinationPan.y)
        }; // return zoom level and its bounds to initial
        currSlide.setZoomLevel(prevZoomLevel);
        const panNeedsChange = !$1f75a04ded5eb2bf$var$pointsEqual(destinationPan, initialPan);
        if (!panNeedsChange && !currZoomLevelNeedsChange && !restoreBgOpacity) {
            // update resolution after gesture
            currSlide._setResolution(destinationZoomLevel);
            currSlide.applyCurrentZoomPan(); // nothing to animate
            return;
        }
        pswp.animations.stopAllPan();
        pswp.animations.startSpring({
            isPan: true,
            start: 0,
            end: 1000,
            velocity: 0,
            dampingRatio: 1,
            naturalFrequency: 40,
            onUpdate: (now)=>{
                now /= 1000; // 0 - start, 1 - end
                if (panNeedsChange || currZoomLevelNeedsChange) {
                    if (panNeedsChange) {
                        currSlide.pan.x = initialPan.x + (destinationPan.x - initialPan.x) * now;
                        currSlide.pan.y = initialPan.y + (destinationPan.y - initialPan.y) * now;
                    }
                    if (currZoomLevelNeedsChange) {
                        const newZoomLevel = prevZoomLevel + (destinationZoomLevel - prevZoomLevel) * now;
                        currSlide.setZoomLevel(newZoomLevel);
                    }
                    currSlide.applyCurrentZoomPan();
                } // Restore background opacity
                if (restoreBgOpacity && pswp.bgOpacity < 1) // We clamp opacity to keep it between 0 and 1.
                // As progress ratio can be larger than 1 due to overshoot,
                // and we do not want to bounce opacity.
                pswp.applyBgOpacity($1f75a04ded5eb2bf$var$clamp(initialBgOpacity + (1 - initialBgOpacity) * now, 0, 1));
            },
            onComplete: ()=>{
                // update resolution after transition ends
                currSlide._setResolution(destinationZoomLevel);
                currSlide.applyCurrentZoomPan();
            }
        });
    }
}
/**
 * @template {string} T
 * @template {string} P
 * @typedef {import('../types.js').AddPostfix<T, P>} AddPostfix<T, P>
 */ /** @typedef {import('./gestures.js').default} Gestures */ /** @typedef {import('../photoswipe.js').Point} Point */ /** @typedef {'imageClick' | 'bgClick' | 'tap' | 'doubleTap'} Actions */ /**
 * Whether the tap was performed on the main slide
 * (rather than controls or caption).
 *
 * @param {PointerEvent} event
 * @returns {boolean}
 */ function $1f75a04ded5eb2bf$var$didTapOnMainContent(event) {
    return !!/** @type {HTMLElement} */ event.target.closest(".pswp__container");
}
/**
 * Tap, double-tap handler.
 */ class $1f75a04ded5eb2bf$var$TapHandler {
    /**
   * @param {Gestures} gestures
   */ constructor(gestures){
        this.gestures = gestures;
    }
    /**
   * @param {Point} point
   * @param {PointerEvent} originalEvent
   */ click(point, originalEvent) {
        const targetClassList = /** @type {HTMLElement} */ originalEvent.target.classList;
        const isImageClick = targetClassList.contains("pswp__img");
        const isBackgroundClick = targetClassList.contains("pswp__item") || targetClassList.contains("pswp__zoom-wrap");
        if (isImageClick) this._doClickOrTapAction("imageClick", point, originalEvent);
        else if (isBackgroundClick) this._doClickOrTapAction("bgClick", point, originalEvent);
    }
    /**
   * @param {Point} point
   * @param {PointerEvent} originalEvent
   */ tap(point, originalEvent) {
        if ($1f75a04ded5eb2bf$var$didTapOnMainContent(originalEvent)) this._doClickOrTapAction("tap", point, originalEvent);
    }
    /**
   * @param {Point} point
   * @param {PointerEvent} originalEvent
   */ doubleTap(point, originalEvent) {
        if ($1f75a04ded5eb2bf$var$didTapOnMainContent(originalEvent)) this._doClickOrTapAction("doubleTap", point, originalEvent);
    }
    /**
   * @private
   * @param {Actions} actionName
   * @param {Point} point
   * @param {PointerEvent} originalEvent
   */ _doClickOrTapAction(actionName, point, originalEvent) {
        var _this$gestures$pswp$e;
        const { pswp: pswp } = this.gestures;
        const { currSlide: currSlide } = pswp;
        const actionFullName = /** @type {AddPostfix<Actions, 'Action'>} */ actionName + "Action";
        const optionValue = pswp.options[actionFullName];
        if (pswp.dispatch(actionFullName, {
            point: point,
            originalEvent: originalEvent
        }).defaultPrevented) return;
        if (typeof optionValue === "function") {
            optionValue.call(pswp, point, originalEvent);
            return;
        }
        switch(optionValue){
            case "close":
            case "next":
                pswp[optionValue]();
                break;
            case "zoom":
                currSlide === null || currSlide === void 0 || currSlide.toggleZoom(point);
                break;
            case "zoom-or-close":
                // by default click zooms current image,
                // if it can not be zoomed - gallery will be closed
                if (currSlide !== null && currSlide !== void 0 && currSlide.isZoomable() && currSlide.zoomLevels.secondary !== currSlide.zoomLevels.initial) currSlide.toggleZoom(point);
                else if (pswp.options.clickToCloseNonZoomable) pswp.close();
                break;
            case "toggle-controls":
                (_this$gestures$pswp$e = this.gestures.pswp.element) === null || _this$gestures$pswp$e === void 0 || _this$gestures$pswp$e.classList.toggle("pswp--ui-visible"); // if (_controlsVisible) {
                break;
        }
    }
}
/** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /** @typedef {import('../photoswipe.js').Point} Point */ // How far should user should drag
// until we can determine that the gesture is swipe and its direction
const $1f75a04ded5eb2bf$var$AXIS_SWIPE_HYSTERISIS = 10; //const PAN_END_FRICTION = 0.35;
const $1f75a04ded5eb2bf$var$DOUBLE_TAP_DELAY = 300; // ms
const $1f75a04ded5eb2bf$var$MIN_TAP_DISTANCE = 25; // px
/**
 * Gestures class bind touch, pointer or mouse events
 * and emits drag to drag-handler and zoom events zoom-handler.
 *
 * Drag and zoom events are emited in requestAnimationFrame,
 * and only when one of pointers was actually changed.
 */ class $1f75a04ded5eb2bf$var$Gestures {
    /**
   * @param {PhotoSwipe} pswp
   */ constructor(pswp){
        this.pswp = pswp;
        /** @type {'x' | 'y' | null} */ this.dragAxis = null; // point objects are defined once and reused
        // PhotoSwipe keeps track only of two pointers, others are ignored
        /** @type {Point} */ this.p1 = {
            x: 0,
            y: 0
        }; // the first pressed pointer
        /** @type {Point} */ this.p2 = {
            x: 0,
            y: 0
        }; // the second pressed pointer
        /** @type {Point} */ this.prevP1 = {
            x: 0,
            y: 0
        };
        /** @type {Point} */ this.prevP2 = {
            x: 0,
            y: 0
        };
        /** @type {Point} */ this.startP1 = {
            x: 0,
            y: 0
        };
        /** @type {Point} */ this.startP2 = {
            x: 0,
            y: 0
        };
        /** @type {Point} */ this.velocity = {
            x: 0,
            y: 0
        };
        /** @type {Point}
     * @private
     */ this._lastStartP1 = {
            x: 0,
            y: 0
        };
        /** @type {Point}
     * @private
     */ this._intervalP1 = {
            x: 0,
            y: 0
        };
        /** @private */ this._numActivePoints = 0;
        /** @type {Point[]}
     * @private
     */ this._ongoingPointers = [];
        /** @private */ this._touchEventEnabled = "ontouchstart" in window;
        /** @private */ this._pointerEventEnabled = !!window.PointerEvent;
        this.supportsTouch = this._touchEventEnabled || this._pointerEventEnabled && navigator.maxTouchPoints > 1;
        /** @private */ this._numActivePoints = 0;
        /** @private */ this._intervalTime = 0;
        /** @private */ this._velocityCalculated = false;
        this.isMultitouch = false;
        this.isDragging = false;
        this.isZooming = false;
        /** @type {number | null} */ this.raf = null;
        /** @type {NodeJS.Timeout | null}
     * @private
     */ this._tapTimer = null;
        if (!this.supportsTouch) // disable pan to next slide for non-touch devices
        pswp.options.allowPanToNext = false;
        this.drag = new $1f75a04ded5eb2bf$var$DragHandler(this);
        this.zoomLevels = new $1f75a04ded5eb2bf$var$ZoomHandler(this);
        this.tapHandler = new $1f75a04ded5eb2bf$var$TapHandler(this);
        pswp.on("bindEvents", ()=>{
            pswp.events.add(pswp.scrollWrap, "click", /** @type EventListener */ this._onClick.bind(this));
            if (this._pointerEventEnabled) this._bindEvents("pointer", "down", "up", "cancel");
            else if (this._touchEventEnabled) {
                this._bindEvents("touch", "start", "end", "cancel"); // In previous versions we also bound mouse event here,
                // in case device supports both touch and mouse events,
                // but newer versions of browsers now support PointerEvent.
                // on iOS10 if you bind touchmove/end after touchstart,
                // and you don't preventDefault touchstart (which PhotoSwipe does),
                // preventDefault will have no effect on touchmove and touchend.
                // Unless you bind it previously.
                if (pswp.scrollWrap) {
                    pswp.scrollWrap.ontouchmove = ()=>{};
                    pswp.scrollWrap.ontouchend = ()=>{};
                }
            } else this._bindEvents("mouse", "down", "up");
        });
    }
    /**
   * @private
   * @param {'mouse' | 'touch' | 'pointer'} pref
   * @param {'down' | 'start'} down
   * @param {'up' | 'end'} up
   * @param {'cancel'} [cancel]
   */ _bindEvents(pref, down, up, cancel) {
        const { pswp: pswp } = this;
        const { events: events } = pswp;
        const cancelEvent = cancel ? pref + cancel : "";
        events.add(pswp.scrollWrap, pref + down, /** @type EventListener */ this.onPointerDown.bind(this));
        events.add(window, pref + "move", /** @type EventListener */ this.onPointerMove.bind(this));
        events.add(window, pref + up, /** @type EventListener */ this.onPointerUp.bind(this));
        if (cancelEvent) events.add(pswp.scrollWrap, cancelEvent, /** @type EventListener */ this.onPointerUp.bind(this));
    }
    /**
   * @param {PointerEvent} e
   */ onPointerDown(e) {
        // We do not call preventDefault for touch events
        // to allow browser to show native dialog on longpress
        // (the one that allows to save image or open it in new tab).
        //
        // Desktop Safari allows to drag images when preventDefault isn't called on mousedown,
        // even though preventDefault IS called on mousemove. That's why we preventDefault mousedown.
        const isMousePointer = e.type === "mousedown" || e.pointerType === "mouse"; // Allow dragging only via left mouse button.
        // http://www.quirksmode.org/js/events_properties.html
        // https://developer.mozilla.org/en-US/docs/Web/API/event.button
        if (isMousePointer && e.button > 0) return;
        const { pswp: pswp } = this; // if PhotoSwipe is opening or closing
        if (!pswp.opener.isOpen) {
            e.preventDefault();
            return;
        }
        if (pswp.dispatch("pointerDown", {
            originalEvent: e
        }).defaultPrevented) return;
        if (isMousePointer) {
            pswp.mouseDetected(); // preventDefault mouse event to prevent
            // browser image drag feature
            this._preventPointerEventBehaviour(e, "down");
        }
        pswp.animations.stopAll();
        this._updatePoints(e, "down");
        if (this._numActivePoints === 1) {
            this.dragAxis = null; // we need to store initial point to determine the main axis,
            // drag is activated only after the axis is determined
            $1f75a04ded5eb2bf$var$equalizePoints(this.startP1, this.p1);
        }
        if (this._numActivePoints > 1) {
            // Tap or double tap should not trigger if more than one pointer
            this._clearTapTimer();
            this.isMultitouch = true;
        } else this.isMultitouch = false;
    }
    /**
   * @param {PointerEvent} e
   */ onPointerMove(e) {
        this._preventPointerEventBehaviour(e, "move");
        if (!this._numActivePoints) return;
        this._updatePoints(e, "move");
        if (this.pswp.dispatch("pointerMove", {
            originalEvent: e
        }).defaultPrevented) return;
        if (this._numActivePoints === 1 && !this.isDragging) {
            if (!this.dragAxis) this._calculateDragDirection();
             // Drag axis was detected, emit drag.start
            if (this.dragAxis && !this.isDragging) {
                if (this.isZooming) {
                    this.isZooming = false;
                    this.zoomLevels.end();
                }
                this.isDragging = true;
                this._clearTapTimer(); // Tap can not trigger after drag
                // Adjust starting point
                this._updateStartPoints();
                this._intervalTime = Date.now(); //this._startTime = this._intervalTime;
                this._velocityCalculated = false;
                $1f75a04ded5eb2bf$var$equalizePoints(this._intervalP1, this.p1);
                this.velocity.x = 0;
                this.velocity.y = 0;
                this.drag.start();
                this._rafStopLoop();
                this._rafRenderLoop();
            }
        } else if (this._numActivePoints > 1 && !this.isZooming) {
            this._finishDrag();
            this.isZooming = true; // Adjust starting points
            this._updateStartPoints();
            this.zoomLevels.start();
            this._rafStopLoop();
            this._rafRenderLoop();
        }
    }
    /**
   * @private
   */ _finishDrag() {
        if (this.isDragging) {
            this.isDragging = false; // Try to calculate velocity,
            // if it wasn't calculated yet in drag.change
            if (!this._velocityCalculated) this._updateVelocity(true);
            this.drag.end();
            this.dragAxis = null;
        }
    }
    /**
   * @param {PointerEvent} e
   */ onPointerUp(e) {
        if (!this._numActivePoints) return;
        this._updatePoints(e, "up");
        if (this.pswp.dispatch("pointerUp", {
            originalEvent: e
        }).defaultPrevented) return;
        if (this._numActivePoints === 0) {
            this._rafStopLoop();
            if (this.isDragging) this._finishDrag();
            else if (!this.isZooming && !this.isMultitouch) //this.zoomLevels.correctZoomPan();
            this._finishTap(e);
        }
        if (this._numActivePoints < 2 && this.isZooming) {
            this.isZooming = false;
            this.zoomLevels.end();
            if (this._numActivePoints === 1) {
                // Since we have 1 point left, we need to reinitiate drag
                this.dragAxis = null;
                this._updateStartPoints();
            }
        }
    }
    /**
   * @private
   */ _rafRenderLoop() {
        if (this.isDragging || this.isZooming) {
            this._updateVelocity();
            if (this.isDragging) // make sure that pointer moved since the last update
            {
                if (!$1f75a04ded5eb2bf$var$pointsEqual(this.p1, this.prevP1)) this.drag.change();
            } else if (!$1f75a04ded5eb2bf$var$pointsEqual(this.p1, this.prevP1) || !$1f75a04ded5eb2bf$var$pointsEqual(this.p2, this.prevP2)) this.zoomLevels.change();
            this._updatePrevPoints();
            this.raf = requestAnimationFrame(this._rafRenderLoop.bind(this));
        }
    }
    /**
   * Update velocity at 50ms interval
   *
   * @private
   * @param {boolean} [force]
   */ _updateVelocity(force) {
        const time = Date.now();
        const duration = time - this._intervalTime;
        if (duration < 50 && !force) return;
        this.velocity.x = this._getVelocity("x", duration);
        this.velocity.y = this._getVelocity("y", duration);
        this._intervalTime = time;
        $1f75a04ded5eb2bf$var$equalizePoints(this._intervalP1, this.p1);
        this._velocityCalculated = true;
    }
    /**
   * @private
   * @param {PointerEvent} e
   */ _finishTap(e) {
        const { mainScroll: mainScroll } = this.pswp; // Do not trigger tap events if main scroll is shifted
        if (mainScroll.isShifted()) {
            // restore main scroll position
            // (usually happens if stopped in the middle of animation)
            mainScroll.moveIndexBy(0, true);
            return;
        } // Do not trigger tap for touchcancel or pointercancel
        if (e.type.indexOf("cancel") > 0) return;
         // Trigger click instead of tap for mouse events
        if (e.type === "mouseup" || e.pointerType === "mouse") {
            this.tapHandler.click(this.startP1, e);
            return;
        } // Disable delay if there is no doubleTapAction
        const tapDelay = this.pswp.options.doubleTapAction ? $1f75a04ded5eb2bf$var$DOUBLE_TAP_DELAY : 0; // If tapTimer is defined - we tapped recently,
        // check if the current tap is close to the previous one,
        // if yes - trigger double tap
        if (this._tapTimer) {
            this._clearTapTimer(); // Check if two taps were more or less on the same place
            if ($1f75a04ded5eb2bf$var$getDistanceBetween(this._lastStartP1, this.startP1) < $1f75a04ded5eb2bf$var$MIN_TAP_DISTANCE) this.tapHandler.doubleTap(this.startP1, e);
        } else {
            $1f75a04ded5eb2bf$var$equalizePoints(this._lastStartP1, this.startP1);
            this._tapTimer = setTimeout(()=>{
                this.tapHandler.tap(this.startP1, e);
                this._clearTapTimer();
            }, tapDelay);
        }
    }
    /**
   * @private
   */ _clearTapTimer() {
        if (this._tapTimer) {
            clearTimeout(this._tapTimer);
            this._tapTimer = null;
        }
    }
    /**
   * Get velocity for axis
   *
   * @private
   * @param {'x' | 'y'} axis
   * @param {number} duration
   * @returns {number}
   */ _getVelocity(axis, duration) {
        // displacement is like distance, but can be negative.
        const displacement = this.p1[axis] - this._intervalP1[axis];
        if (Math.abs(displacement) > 1 && duration > 5) return displacement / duration;
        return 0;
    }
    /**
   * @private
   */ _rafStopLoop() {
        if (this.raf) {
            cancelAnimationFrame(this.raf);
            this.raf = null;
        }
    }
    /**
   * @private
   * @param {PointerEvent} e
   * @param {'up' | 'down' | 'move'} pointerType Normalized pointer type
   */ _preventPointerEventBehaviour(e, pointerType) {
        const preventPointerEvent = this.pswp.applyFilters("preventPointerEvent", true, e, pointerType);
        if (preventPointerEvent) e.preventDefault();
    }
    /**
   * Parses and normalizes points from the touch, mouse or pointer event.
   * Updates p1 and p2.
   *
   * @private
   * @param {PointerEvent | TouchEvent} e
   * @param {'up' | 'down' | 'move'} pointerType Normalized pointer type
   */ _updatePoints(e, pointerType) {
        if (this._pointerEventEnabled) {
            const pointerEvent = /** @type {PointerEvent} */ e; // Try to find the current pointer in ongoing pointers by its ID
            const pointerIndex = this._ongoingPointers.findIndex((ongoingPointer)=>{
                return ongoingPointer.id === pointerEvent.pointerId;
            });
            if (pointerType === "up" && pointerIndex > -1) // release the pointer - remove it from ongoing
            this._ongoingPointers.splice(pointerIndex, 1);
            else if (pointerType === "down" && pointerIndex === -1) // add new pointer
            this._ongoingPointers.push(this._convertEventPosToPoint(pointerEvent, {
                x: 0,
                y: 0
            }));
            else if (pointerIndex > -1) // update existing pointer
            this._convertEventPosToPoint(pointerEvent, this._ongoingPointers[pointerIndex]);
            this._numActivePoints = this._ongoingPointers.length; // update points that PhotoSwipe uses
            // to calculate position and scale
            if (this._numActivePoints > 0) $1f75a04ded5eb2bf$var$equalizePoints(this.p1, this._ongoingPointers[0]);
            if (this._numActivePoints > 1) $1f75a04ded5eb2bf$var$equalizePoints(this.p2, this._ongoingPointers[1]);
        } else {
            const touchEvent = /** @type {TouchEvent} */ e;
            this._numActivePoints = 0;
            if (touchEvent.type.indexOf("touch") > -1) // Touch Event
            // https://developer.mozilla.org/en-US/docs/Web/API/TouchEvent
            {
                if (touchEvent.touches && touchEvent.touches.length > 0) {
                    this._convertEventPosToPoint(touchEvent.touches[0], this.p1);
                    this._numActivePoints++;
                    if (touchEvent.touches.length > 1) {
                        this._convertEventPosToPoint(touchEvent.touches[1], this.p2);
                        this._numActivePoints++;
                    }
                }
            } else {
                // Mouse Event
                this._convertEventPosToPoint(/** @type {PointerEvent} */ e, this.p1);
                if (pointerType === "up") // clear all points on mouseup
                this._numActivePoints = 0;
                else this._numActivePoints++;
            }
        }
    }
    /** update points that were used during previous rAF tick
   * @private
   */ _updatePrevPoints() {
        $1f75a04ded5eb2bf$var$equalizePoints(this.prevP1, this.p1);
        $1f75a04ded5eb2bf$var$equalizePoints(this.prevP2, this.p2);
    }
    /** update points at the start of gesture
   * @private
   */ _updateStartPoints() {
        $1f75a04ded5eb2bf$var$equalizePoints(this.startP1, this.p1);
        $1f75a04ded5eb2bf$var$equalizePoints(this.startP2, this.p2);
        this._updatePrevPoints();
    }
    /** @private */ _calculateDragDirection() {
        if (this.pswp.mainScroll.isShifted()) // if main scroll position is shifted – direction is always horizontal
        this.dragAxis = "x";
        else {
            // calculate delta of the last touchmove tick
            const diff = Math.abs(this.p1.x - this.startP1.x) - Math.abs(this.p1.y - this.startP1.y);
            if (diff !== 0) {
                // check if pointer was shifted horizontally or vertically
                const axisToCheck = diff > 0 ? "x" : "y";
                if (Math.abs(this.p1[axisToCheck] - this.startP1[axisToCheck]) >= $1f75a04ded5eb2bf$var$AXIS_SWIPE_HYSTERISIS) this.dragAxis = axisToCheck;
            }
        }
    }
    /**
   * Converts touch, pointer or mouse event
   * to PhotoSwipe point.
   *
   * @private
   * @param {Touch | PointerEvent} e
   * @param {Point} p
   * @returns {Point}
   */ _convertEventPosToPoint(e, p) {
        p.x = e.pageX - this.pswp.offset.x;
        p.y = e.pageY - this.pswp.offset.y;
        if ("pointerId" in e) p.id = e.pointerId;
        else if (e.identifier !== undefined) p.id = e.identifier;
        return p;
    }
    /**
   * @private
   * @param {PointerEvent} e
   */ _onClick(e) {
        // Do not allow click event to pass through after drag
        if (this.pswp.mainScroll.isShifted()) {
            e.preventDefault();
            e.stopPropagation();
        }
    }
}
/** @typedef {import('./photoswipe.js').default} PhotoSwipe */ /** @typedef {import('./slide/slide.js').default} Slide */ /** @typedef {{ el: HTMLDivElement; slide?: Slide }} ItemHolder */ const $1f75a04ded5eb2bf$var$MAIN_SCROLL_END_FRICTION = 0.35; // const MIN_SWIPE_TRANSITION_DURATION = 250;
// const MAX_SWIPE_TRABSITION_DURATION = 500;
// const DEFAULT_SWIPE_TRANSITION_DURATION = 333;
/**
 * Handles movement of the main scrolling container
 * (for example, it repositions when user swipes left or right).
 *
 * Also stores its state.
 */ class $1f75a04ded5eb2bf$var$MainScroll {
    /**
   * @param {PhotoSwipe} pswp
   */ constructor(pswp){
        this.pswp = pswp;
        this.x = 0;
        this.slideWidth = 0;
        /** @private */ this._currPositionIndex = 0;
        /** @private */ this._prevPositionIndex = 0;
        /** @private */ this._containerShiftIndex = -1;
        /** @type {ItemHolder[]} */ this.itemHolders = [];
    }
    /**
   * Position the scroller and slide containers
   * according to viewport size.
   *
   * @param {boolean} [resizeSlides] Whether slides content should resized
   */ resize(resizeSlides) {
        const { pswp: pswp } = this;
        const newSlideWidth = Math.round(pswp.viewportSize.x + pswp.viewportSize.x * pswp.options.spacing); // Mobile browsers might trigger a resize event during a gesture.
        // (due to toolbar appearing or hiding).
        // Avoid re-adjusting main scroll position if width wasn't changed
        const slideWidthChanged = newSlideWidth !== this.slideWidth;
        if (slideWidthChanged) {
            this.slideWidth = newSlideWidth;
            this.moveTo(this.getCurrSlideX());
        }
        this.itemHolders.forEach((itemHolder, index)=>{
            if (slideWidthChanged) $1f75a04ded5eb2bf$var$setTransform(itemHolder.el, (index + this._containerShiftIndex) * this.slideWidth);
            if (resizeSlides && itemHolder.slide) itemHolder.slide.resize();
        });
    }
    /**
   * Reset X position of the main scroller to zero
   */ resetPosition() {
        // Position on the main scroller (offset)
        // it is independent from slide index
        this._currPositionIndex = 0;
        this._prevPositionIndex = 0; // This will force recalculation of size on next resize()
        this.slideWidth = 0; // _containerShiftIndex*viewportSize will give you amount of transform of the current slide
        this._containerShiftIndex = -1;
    }
    /**
   * Create and append array of three items
   * that hold data about slides in DOM
   */ appendHolders() {
        this.itemHolders = []; // append our three slide holders -
        // previous, current, and next
        for(let i = 0; i < 3; i++){
            const el = $1f75a04ded5eb2bf$var$createElement("pswp__item", "div", this.pswp.container);
            el.setAttribute("role", "group");
            el.setAttribute("aria-roledescription", "slide");
            el.setAttribute("aria-hidden", "true"); // hide nearby item holders until initial zoom animation finishes (to avoid extra Paints)
            el.style.display = i === 1 ? "block" : "none";
            this.itemHolders.push({
                el: el //index: -1
            });
        }
    }
    /**
   * Whether the main scroll can be horizontally swiped to the next or previous slide.
   * @returns {boolean}
   */ canBeSwiped() {
        return this.pswp.getNumItems() > 1;
    }
    /**
   * Move main scroll by X amount of slides.
   * For example:
   *   `-1` will move to the previous slide,
   *    `0` will reset the scroll position of the current slide,
   *    `3` will move three slides forward
   *
   * If loop option is enabled - index will be automatically looped too,
   * (for example `-1` will move to the last slide of the gallery).
   *
   * @param {number} diff
   * @param {boolean} [animate]
   * @param {number} [velocityX]
   * @returns {boolean} whether index was changed or not
   */ moveIndexBy(diff, animate, velocityX) {
        const { pswp: pswp } = this;
        let newIndex = pswp.potentialIndex + diff;
        const numSlides = pswp.getNumItems();
        if (pswp.canLoop()) {
            newIndex = pswp.getLoopedIndex(newIndex);
            const distance = (diff + numSlides) % numSlides;
            if (distance <= numSlides / 2) // go forward
            diff = distance;
            else // go backwards
            diff = distance - numSlides;
        } else {
            if (newIndex < 0) newIndex = 0;
            else if (newIndex >= numSlides) newIndex = numSlides - 1;
            diff = newIndex - pswp.potentialIndex;
        }
        pswp.potentialIndex = newIndex;
        this._currPositionIndex -= diff;
        pswp.animations.stopMainScroll();
        const destinationX = this.getCurrSlideX();
        if (!animate) {
            this.moveTo(destinationX);
            this.updateCurrItem();
        } else {
            pswp.animations.startSpring({
                isMainScroll: true,
                start: this.x,
                end: destinationX,
                velocity: velocityX || 0,
                naturalFrequency: 30,
                dampingRatio: 1,
                //0.7,
                onUpdate: (x)=>{
                    this.moveTo(x);
                },
                onComplete: ()=>{
                    this.updateCurrItem();
                    pswp.appendHeavy();
                }
            });
            let currDiff = pswp.potentialIndex - pswp.currIndex;
            if (pswp.canLoop()) {
                const currDistance = (currDiff + numSlides) % numSlides;
                if (currDistance <= numSlides / 2) // go forward
                currDiff = currDistance;
                else // go backwards
                currDiff = currDistance - numSlides;
            } // Force-append new slides during transition
            // if difference between slides is more than 1
            if (Math.abs(currDiff) > 1) this.updateCurrItem();
        }
        return Boolean(diff);
    }
    /**
   * X position of the main scroll for the current slide
   * (ignores position during dragging)
   * @returns {number}
   */ getCurrSlideX() {
        return this.slideWidth * this._currPositionIndex;
    }
    /**
   * Whether scroll position is shifted.
   * For example, it will return true if the scroll is being dragged or animated.
   * @returns {boolean}
   */ isShifted() {
        return this.x !== this.getCurrSlideX();
    }
    /**
   * Update slides X positions and set their content
   */ updateCurrItem() {
        var _this$itemHolders$;
        const { pswp: pswp } = this;
        const positionDifference = this._prevPositionIndex - this._currPositionIndex;
        if (!positionDifference) return;
        this._prevPositionIndex = this._currPositionIndex;
        pswp.currIndex = pswp.potentialIndex;
        let diffAbs = Math.abs(positionDifference);
        /** @type {ItemHolder | undefined} */ let tempHolder;
        if (diffAbs >= 3) {
            this._containerShiftIndex += positionDifference + (positionDifference > 0 ? -3 : 3);
            diffAbs = 3; // If slides are changed by 3 screens or more - clean up previous slides
            this.itemHolders.forEach((itemHolder)=>{
                var _itemHolder$slide;
                (_itemHolder$slide = itemHolder.slide) === null || _itemHolder$slide === void 0 || _itemHolder$slide.destroy();
                itemHolder.slide = undefined;
            });
        }
        for(let i = 0; i < diffAbs; i++)if (positionDifference > 0) {
            tempHolder = this.itemHolders.shift();
            if (tempHolder) {
                this.itemHolders[2] = tempHolder; // move first to last
                this._containerShiftIndex++;
                $1f75a04ded5eb2bf$var$setTransform(tempHolder.el, (this._containerShiftIndex + 2) * this.slideWidth);
                pswp.setContent(tempHolder, pswp.currIndex - diffAbs + i + 2);
            }
        } else {
            tempHolder = this.itemHolders.pop();
            if (tempHolder) {
                this.itemHolders.unshift(tempHolder); // move last to first
                this._containerShiftIndex--;
                $1f75a04ded5eb2bf$var$setTransform(tempHolder.el, this._containerShiftIndex * this.slideWidth);
                pswp.setContent(tempHolder, pswp.currIndex + diffAbs - i - 2);
            }
        }
         // Reset transfrom every 50ish navigations in one direction.
        //
        // Otherwise transform will keep growing indefinitely,
        // which might cause issues as browsers have a maximum transform limit.
        // I wasn't able to reach it, but just to be safe.
        // This should not cause noticable lag.
        if (Math.abs(this._containerShiftIndex) > 50 && !this.isShifted()) {
            this.resetPosition();
            this.resize();
        } // Pan transition might be running (and consntantly updating pan position)
        pswp.animations.stopAllPan();
        this.itemHolders.forEach((itemHolder, i)=>{
            if (itemHolder.slide) // Slide in the 2nd holder is always active
            itemHolder.slide.setIsActive(i === 1);
        });
        pswp.currSlide = (_this$itemHolders$ = this.itemHolders[1]) === null || _this$itemHolders$ === void 0 ? void 0 : _this$itemHolders$.slide;
        pswp.contentLoader.updateLazy(positionDifference);
        if (pswp.currSlide) pswp.currSlide.applyCurrentZoomPan();
        pswp.dispatch("change");
    }
    /**
   * Move the X position of the main scroll container
   *
   * @param {number} x
   * @param {boolean} [dragging]
   */ moveTo(x, dragging) {
        if (!this.pswp.canLoop() && dragging) {
            // Apply friction
            let newSlideIndexOffset = (this.slideWidth * this._currPositionIndex - x) / this.slideWidth;
            newSlideIndexOffset += this.pswp.currIndex;
            const delta = Math.round(x - this.x);
            if (newSlideIndexOffset < 0 && delta > 0 || newSlideIndexOffset >= this.pswp.getNumItems() - 1 && delta < 0) x = this.x + delta * $1f75a04ded5eb2bf$var$MAIN_SCROLL_END_FRICTION;
        }
        this.x = x;
        if (this.pswp.container) $1f75a04ded5eb2bf$var$setTransform(this.pswp.container, x);
        this.pswp.dispatch("moveMainScroll", {
            x: x,
            dragging: dragging !== null && dragging !== void 0 ? dragging : false
        });
    }
}
/** @typedef {import('./photoswipe.js').default} PhotoSwipe */ /**
 * @template T
 * @typedef {import('./types.js').Methods<T>} Methods<T>
 */ const $1f75a04ded5eb2bf$var$KeyboardKeyCodesMap = {
    Escape: 27,
    z: 90,
    ArrowLeft: 37,
    ArrowUp: 38,
    ArrowRight: 39,
    ArrowDown: 40,
    Tab: 9
};
/**
 * @template {keyof KeyboardKeyCodesMap} T
 * @param {T} key
 * @param {boolean} isKeySupported
 * @returns {T | number | undefined}
 */ const $1f75a04ded5eb2bf$var$getKeyboardEventKey = (key, isKeySupported)=>{
    return isKeySupported ? key : $1f75a04ded5eb2bf$var$KeyboardKeyCodesMap[key];
};
/**
 * - Manages keyboard shortcuts.
 * - Helps trap focus within photoswipe.
 */ class $1f75a04ded5eb2bf$var$Keyboard {
    /**
   * @param {PhotoSwipe} pswp
   */ constructor(pswp){
        this.pswp = pswp;
        /** @private */ this._wasFocused = false;
        pswp.on("bindEvents", ()=>{
            if (pswp.options.trapFocus) {
                // Dialog was likely opened by keyboard if initial point is not defined
                if (!pswp.options.initialPointerPos) // focus causes layout,
                // which causes lag during the animation,
                // that's why we delay it until the opener transition ends
                this._focusRoot();
                pswp.events.add(document, "focusin", /** @type EventListener */ this._onFocusIn.bind(this));
            }
            pswp.events.add(document, "keydown", /** @type EventListener */ this._onKeyDown.bind(this));
        });
        const lastActiveElement = /** @type {HTMLElement} */ document.activeElement;
        pswp.on("destroy", ()=>{
            if (pswp.options.returnFocus && lastActiveElement && this._wasFocused) lastActiveElement.focus();
        });
    }
    /** @private */ _focusRoot() {
        if (!this._wasFocused && this.pswp.element) {
            this.pswp.element.focus();
            this._wasFocused = true;
        }
    }
    /**
   * @private
   * @param {KeyboardEvent} e
   */ _onKeyDown(e) {
        const { pswp: pswp } = this;
        if (pswp.dispatch("keydown", {
            originalEvent: e
        }).defaultPrevented) return;
        if ($1f75a04ded5eb2bf$var$specialKeyUsed(e)) // don't do anything if special key pressed
        // to prevent from overriding default browser actions
        // for example, in Chrome on Mac cmd+arrow-left returns to previous page
        return;
        /** @type {Methods<PhotoSwipe> | undefined} */ let keydownAction;
        /** @type {'x' | 'y' | undefined} */ let axis;
        let isForward = false;
        const isKeySupported = "key" in e;
        switch(isKeySupported ? e.key : e.keyCode){
            case $1f75a04ded5eb2bf$var$getKeyboardEventKey("Escape", isKeySupported):
                if (pswp.options.escKey) keydownAction = "close";
                break;
            case $1f75a04ded5eb2bf$var$getKeyboardEventKey("z", isKeySupported):
                keydownAction = "toggleZoom";
                break;
            case $1f75a04ded5eb2bf$var$getKeyboardEventKey("ArrowLeft", isKeySupported):
                axis = "x";
                break;
            case $1f75a04ded5eb2bf$var$getKeyboardEventKey("ArrowUp", isKeySupported):
                axis = "y";
                break;
            case $1f75a04ded5eb2bf$var$getKeyboardEventKey("ArrowRight", isKeySupported):
                axis = "x";
                isForward = true;
                break;
            case $1f75a04ded5eb2bf$var$getKeyboardEventKey("ArrowDown", isKeySupported):
                isForward = true;
                axis = "y";
                break;
            case $1f75a04ded5eb2bf$var$getKeyboardEventKey("Tab", isKeySupported):
                this._focusRoot();
                break;
        } // if left/right/top/bottom key
        if (axis) {
            // prevent page scroll
            e.preventDefault();
            const { currSlide: currSlide } = pswp;
            if (pswp.options.arrowKeys && axis === "x" && pswp.getNumItems() > 1) keydownAction = isForward ? "next" : "prev";
            else if (currSlide && currSlide.currZoomLevel > currSlide.zoomLevels.fit) {
                // up/down arrow keys pan the image vertically
                // left/right arrow keys pan horizontally.
                // Unless there is only one image,
                // or arrowKeys option is disabled
                currSlide.pan[axis] += isForward ? -80 : 80;
                currSlide.panTo(currSlide.pan.x, currSlide.pan.y);
            }
        }
        if (keydownAction) {
            e.preventDefault(); // @ts-ignore
            pswp[keydownAction]();
        }
    }
    /**
   * Trap focus inside photoswipe
   *
   * @private
   * @param {FocusEvent} e
   */ _onFocusIn(e) {
        const { template: template } = this.pswp;
        if (template && document !== e.target && template !== e.target && !template.contains(/** @type {Node} */ e.target)) // focus root element
        template.focus();
    }
}
const $1f75a04ded5eb2bf$var$DEFAULT_EASING = "cubic-bezier(.4,0,.22,1)";
/** @typedef {import('./animations.js').SharedAnimationProps} SharedAnimationProps */ /** @typedef {Object} DefaultCssAnimationProps
 *
 * @prop {HTMLElement} target
 * @prop {number} [duration]
 * @prop {string} [easing]
 * @prop {string} [transform]
 * @prop {string} [opacity]
 * */ /** @typedef {SharedAnimationProps & DefaultCssAnimationProps} CssAnimationProps */ /**
 * Runs CSS transition.
 */ class $1f75a04ded5eb2bf$var$CSSAnimation {
    /**
   * onComplete can be unpredictable, be careful about current state
   *
   * @param {CssAnimationProps} props
   */ constructor(props){
        var _props$prop;
        this.props = props;
        const { target: target, onComplete: onComplete, transform: transform, onFinish: onFinish = ()=>{}, duration: duration = 333, easing: easing = $1f75a04ded5eb2bf$var$DEFAULT_EASING } = props;
        this.onFinish = onFinish; // support only transform and opacity
        const prop = transform ? "transform" : "opacity";
        const propValue = (_props$prop = props[prop]) !== null && _props$prop !== void 0 ? _props$prop : "";
        /** @private */ this._target = target;
        /** @private */ this._onComplete = onComplete;
        /** @private */ this._finished = false;
        /** @private */ this._onTransitionEnd = this._onTransitionEnd.bind(this); // Using timeout hack to make sure that animation
        // starts even if the animated property was changed recently,
        // otherwise transitionend might not fire or transition won't start.
        // https://drafts.csswg.org/css-transitions/#starting
        //
        // ¯\_(ツ)_/¯
        /** @private */ this._helperTimeout = setTimeout(()=>{
            $1f75a04ded5eb2bf$var$setTransitionStyle(target, prop, duration, easing);
            this._helperTimeout = setTimeout(()=>{
                target.addEventListener("transitionend", this._onTransitionEnd, false);
                target.addEventListener("transitioncancel", this._onTransitionEnd, false); // Safari occasionally does not emit transitionend event
                // if element property was modified during the transition,
                // which may be caused by resize or third party component,
                // using timeout as a safety fallback
                this._helperTimeout = setTimeout(()=>{
                    this._finalizeAnimation();
                }, duration + 500);
                target.style[prop] = propValue;
            }, 30); // Do not reduce this number
        }, 0);
    }
    /**
   * @private
   * @param {TransitionEvent} e
   */ _onTransitionEnd(e) {
        if (e.target === this._target) this._finalizeAnimation();
    }
    /**
   * @private
   */ _finalizeAnimation() {
        if (!this._finished) {
            this._finished = true;
            this.onFinish();
            if (this._onComplete) this._onComplete();
        }
    }
    destroy() {
        if (this._helperTimeout) clearTimeout(this._helperTimeout);
        $1f75a04ded5eb2bf$var$removeTransitionStyle(this._target);
        this._target.removeEventListener("transitionend", this._onTransitionEnd, false);
        this._target.removeEventListener("transitioncancel", this._onTransitionEnd, false);
        if (!this._finished) this._finalizeAnimation();
    }
}
const $1f75a04ded5eb2bf$var$DEFAULT_NATURAL_FREQUENCY = 12;
const $1f75a04ded5eb2bf$var$DEFAULT_DAMPING_RATIO = 0.75;
/**
 * Spring easing helper
 */ class $1f75a04ded5eb2bf$var$SpringEaser {
    /**
   * @param {number} initialVelocity Initial velocity, px per ms.
   *
   * @param {number} [dampingRatio]
   * Determines how bouncy animation will be.
   * From 0 to 1, 0 - always overshoot, 1 - do not overshoot.
   * "overshoot" refers to part of animation that
   * goes beyond the final value.
   *
   * @param {number} [naturalFrequency]
   * Determines how fast animation will slow down.
   * The higher value - the stiffer the transition will be,
   * and the faster it will slow down.
   * Recommended value from 10 to 50
   */ constructor(initialVelocity, dampingRatio, naturalFrequency){
        this.velocity = initialVelocity * 1000; // convert to "pixels per second"
        // https://en.wikipedia.org/wiki/Damping_ratio
        this._dampingRatio = dampingRatio || $1f75a04ded5eb2bf$var$DEFAULT_DAMPING_RATIO; // https://en.wikipedia.org/wiki/Natural_frequency
        this._naturalFrequency = naturalFrequency || $1f75a04ded5eb2bf$var$DEFAULT_NATURAL_FREQUENCY;
        this._dampedFrequency = this._naturalFrequency;
        if (this._dampingRatio < 1) this._dampedFrequency *= Math.sqrt(1 - this._dampingRatio * this._dampingRatio);
    }
    /**
   * @param {number} deltaPosition Difference between current and end position of the animation
   * @param {number} deltaTime Frame duration in milliseconds
   *
   * @returns {number} Displacement, relative to the end position.
   */ easeFrame(deltaPosition, deltaTime) {
        // Inspired by Apple Webkit and Android spring function implementation
        // https://en.wikipedia.org/wiki/Oscillation
        // https://en.wikipedia.org/wiki/Damping_ratio
        // we ignore mass (assume that it's 1kg)
        let displacement = 0;
        let coeff;
        deltaTime /= 1000;
        const naturalDumpingPow = Math.E ** (-this._dampingRatio * this._naturalFrequency * deltaTime);
        if (this._dampingRatio === 1) {
            coeff = this.velocity + this._naturalFrequency * deltaPosition;
            displacement = (deltaPosition + coeff * deltaTime) * naturalDumpingPow;
            this.velocity = displacement * -this._naturalFrequency + coeff * naturalDumpingPow;
        } else if (this._dampingRatio < 1) {
            coeff = 1 / this._dampedFrequency * (this._dampingRatio * this._naturalFrequency * deltaPosition + this.velocity);
            const dumpedFCos = Math.cos(this._dampedFrequency * deltaTime);
            const dumpedFSin = Math.sin(this._dampedFrequency * deltaTime);
            displacement = naturalDumpingPow * (deltaPosition * dumpedFCos + coeff * dumpedFSin);
            this.velocity = displacement * -this._naturalFrequency * this._dampingRatio + naturalDumpingPow * (-this._dampedFrequency * deltaPosition * dumpedFSin + this._dampedFrequency * coeff * dumpedFCos);
        } // Overdamped (>1) damping ratio is not supported
        return displacement;
    }
}
/** @typedef {import('./animations.js').SharedAnimationProps} SharedAnimationProps */ /**
 * @typedef {Object} DefaultSpringAnimationProps
 *
 * @prop {number} start
 * @prop {number} end
 * @prop {number} velocity
 * @prop {number} [dampingRatio]
 * @prop {number} [naturalFrequency]
 * @prop {(end: number) => void} onUpdate
 */ /** @typedef {SharedAnimationProps & DefaultSpringAnimationProps} SpringAnimationProps */ class $1f75a04ded5eb2bf$var$SpringAnimation {
    /**
   * @param {SpringAnimationProps} props
   */ constructor(props){
        this.props = props;
        this._raf = 0;
        const { start: start, end: end, velocity: velocity, onUpdate: onUpdate, onComplete: onComplete, onFinish: onFinish = ()=>{}, dampingRatio: dampingRatio, naturalFrequency: naturalFrequency } = props;
        this.onFinish = onFinish;
        const easer = new $1f75a04ded5eb2bf$var$SpringEaser(velocity, dampingRatio, naturalFrequency);
        let prevTime = Date.now();
        let deltaPosition = start - end;
        const animationLoop = ()=>{
            if (this._raf) {
                deltaPosition = easer.easeFrame(deltaPosition, Date.now() - prevTime); // Stop the animation if velocity is low and position is close to end
                if (Math.abs(deltaPosition) < 1 && Math.abs(easer.velocity) < 50) {
                    // Finalize the animation
                    onUpdate(end);
                    if (onComplete) onComplete();
                    this.onFinish();
                } else {
                    prevTime = Date.now();
                    onUpdate(deltaPosition + end);
                    this._raf = requestAnimationFrame(animationLoop);
                }
            }
        };
        this._raf = requestAnimationFrame(animationLoop);
    }
    destroy() {
        if (this._raf >= 0) cancelAnimationFrame(this._raf);
        this._raf = 0;
    }
}
/** @typedef {import('./css-animation.js').CssAnimationProps} CssAnimationProps */ /** @typedef {import('./spring-animation.js').SpringAnimationProps} SpringAnimationProps */ /** @typedef {Object} SharedAnimationProps
 * @prop {string} [name]
 * @prop {boolean} [isPan]
 * @prop {boolean} [isMainScroll]
 * @prop {VoidFunction} [onComplete]
 * @prop {VoidFunction} [onFinish]
 */ /** @typedef {SpringAnimation | CSSAnimation} Animation */ /** @typedef {SpringAnimationProps | CssAnimationProps} AnimationProps */ /**
 * Manages animations
 */ class $1f75a04ded5eb2bf$var$Animations {
    constructor(){
        /** @type {Animation[]} */ this.activeAnimations = [];
    }
    /**
   * @param {SpringAnimationProps} props
   */ startSpring(props) {
        this._start(props, true);
    }
    /**
   * @param {CssAnimationProps} props
   */ startTransition(props) {
        this._start(props);
    }
    /**
   * @private
   * @param {AnimationProps} props
   * @param {boolean} [isSpring]
   * @returns {Animation}
   */ _start(props, isSpring) {
        const animation = isSpring ? new $1f75a04ded5eb2bf$var$SpringAnimation(/** @type SpringAnimationProps */ props) : new $1f75a04ded5eb2bf$var$CSSAnimation(/** @type CssAnimationProps */ props);
        this.activeAnimations.push(animation);
        animation.onFinish = ()=>this.stop(animation);
        return animation;
    }
    /**
   * @param {Animation} animation
   */ stop(animation) {
        animation.destroy();
        const index = this.activeAnimations.indexOf(animation);
        if (index > -1) this.activeAnimations.splice(index, 1);
    }
    stopAll() {
        // _stopAllAnimations
        this.activeAnimations.forEach((animation)=>{
            animation.destroy();
        });
        this.activeAnimations = [];
    }
    /**
   * Stop all pan or zoom transitions
   */ stopAllPan() {
        this.activeAnimations = this.activeAnimations.filter((animation)=>{
            if (animation.props.isPan) {
                animation.destroy();
                return false;
            }
            return true;
        });
    }
    stopMainScroll() {
        this.activeAnimations = this.activeAnimations.filter((animation)=>{
            if (animation.props.isMainScroll) {
                animation.destroy();
                return false;
            }
            return true;
        });
    }
    /**
   * Returns true if main scroll transition is running
   */ // isMainScrollRunning() {
    //   return this.activeAnimations.some((animation) => {
    //     return animation.props.isMainScroll;
    //   });
    // }
    /**
   * Returns true if any pan or zoom transition is running
   */ isPanRunning() {
        return this.activeAnimations.some((animation)=>{
            return animation.props.isPan;
        });
    }
}
/** @typedef {import('./photoswipe.js').default} PhotoSwipe */ /**
 * Handles scroll wheel.
 * Can pan and zoom current slide image.
 */ class $1f75a04ded5eb2bf$var$ScrollWheel {
    /**
   * @param {PhotoSwipe} pswp
   */ constructor(pswp){
        this.pswp = pswp;
        pswp.events.add(pswp.element, "wheel", /** @type EventListener */ this._onWheel.bind(this));
    }
    /**
   * @private
   * @param {WheelEvent} e
   */ _onWheel(e) {
        e.preventDefault();
        const { currSlide: currSlide } = this.pswp;
        let { deltaX: deltaX, deltaY: deltaY } = e;
        if (!currSlide) return;
        if (this.pswp.dispatch("wheel", {
            originalEvent: e
        }).defaultPrevented) return;
        if (e.ctrlKey || this.pswp.options.wheelToZoom) // zoom
        {
            if (currSlide.isZoomable()) {
                let zoomFactor = -deltaY;
                if (e.deltaMode === 1) zoomFactor *= 0.05;
                else zoomFactor *= e.deltaMode ? 1 : 0.002;
                zoomFactor = 2 ** zoomFactor;
                const destZoomLevel = currSlide.currZoomLevel * zoomFactor;
                currSlide.zoomTo(destZoomLevel, {
                    x: e.clientX,
                    y: e.clientY
                });
            }
        } else // pan
        if (currSlide.isPannable()) {
            if (e.deltaMode === 1) {
                // 18 - average line height
                deltaX *= 18;
                deltaY *= 18;
            }
            currSlide.panTo(currSlide.pan.x - deltaX, currSlide.pan.y - deltaY);
        }
    }
}
/** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /**
 * @template T
 * @typedef {import('../types.js').Methods<T>} Methods<T>
 */ /**
 * @typedef {Object} UIElementMarkupProps
 * @prop {boolean} [isCustomSVG]
 * @prop {string} inner
 * @prop {string} [outlineID]
 * @prop {number | string} [size]
 */ /**
 * @typedef {Object} UIElementData
 * @prop {DefaultUIElements | string} [name]
 * @prop {string} [className]
 * @prop {UIElementMarkup} [html]
 * @prop {boolean} [isButton]
 * @prop {keyof HTMLElementTagNameMap} [tagName]
 * @prop {string} [title]
 * @prop {string} [ariaLabel]
 * @prop {(element: HTMLElement, pswp: PhotoSwipe) => void} [onInit]
 * @prop {Methods<PhotoSwipe> | ((e: MouseEvent, element: HTMLElement, pswp: PhotoSwipe) => void)} [onClick]
 * @prop {'bar' | 'wrapper' | 'root'} [appendTo]
 * @prop {number} [order]
 */ /** @typedef {'arrowPrev' | 'arrowNext' | 'close' | 'zoom' | 'counter'} DefaultUIElements */ /** @typedef {string | UIElementMarkupProps} UIElementMarkup */ /**
 * @param {UIElementMarkup} [htmlData]
 * @returns {string}
 */ function $1f75a04ded5eb2bf$var$addElementHTML(htmlData) {
    if (typeof htmlData === "string") // Allow developers to provide full svg,
    // For example:
    // <svg viewBox="0 0 32 32" width="32" height="32" aria-hidden="true" class="pswp__icn">
    //   <path d="..." />
    //   <circle ... />
    // </svg>
    // Can also be any HTML string.
    return htmlData;
    if (!htmlData || !htmlData.isCustomSVG) return "";
    const svgData = htmlData;
    let out = '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 %d %d" width="%d" height="%d">'; // replace all %d with size
    out = out.split("%d").join(/** @type {string} */ svgData.size || 32); // Icons may contain outline/shadow,
    // to make it we "clone" base icon shape and add border to it.
    // Icon itself and border are styled via CSS.
    //
    // Property shadowID defines ID of element that should be cloned.
    if (svgData.outlineID) out += '<use class="pswp__icn-shadow" xlink:href="#' + svgData.outlineID + '"/>';
    out += svgData.inner;
    out += "</svg>";
    return out;
}
class $1f75a04ded5eb2bf$var$UIElement {
    /**
   * @param {PhotoSwipe} pswp
   * @param {UIElementData} data
   */ constructor(pswp, data){
        var _container;
        const name = data.name || data.className;
        let elementHTML = data.html; // @ts-expect-error lookup only by `data.name` maybe?
        if (pswp.options[name] === false) // exit if element is disabled from options
        return;
         // Allow to override SVG icons from options
        // @ts-expect-error lookup only by `data.name` maybe?
        if (typeof pswp.options[name + "SVG"] === "string") // arrowPrevSVG
        // arrowNextSVG
        // closeSVG
        // zoomSVG
        // @ts-expect-error lookup only by `data.name` maybe?
        elementHTML = pswp.options[name + "SVG"];
        pswp.dispatch("uiElementCreate", {
            data: data
        });
        let className = "";
        if (data.isButton) {
            className += "pswp__button ";
            className += data.className || `pswp__button--${data.name}`;
        } else className += data.className || `pswp__${data.name}`;
        let tagName = data.isButton ? data.tagName || "button" : data.tagName || "div";
        tagName = /** @type {keyof HTMLElementTagNameMap} */ tagName.toLowerCase();
        /** @type {HTMLElement} */ const element = $1f75a04ded5eb2bf$var$createElement(className, tagName);
        if (data.isButton) {
            if (tagName === "button") /** @type {HTMLButtonElement} */ element.type = "button";
            let { title: title } = data;
            const { ariaLabel: ariaLabel } = data; // @ts-expect-error lookup only by `data.name` maybe?
            if (typeof pswp.options[name + "Title"] === "string") // @ts-expect-error lookup only by `data.name` maybe?
            title = pswp.options[name + "Title"];
            if (title) element.title = title;
            const ariaText = ariaLabel || title;
            if (ariaText) element.setAttribute("aria-label", ariaText);
        }
        element.innerHTML = $1f75a04ded5eb2bf$var$addElementHTML(elementHTML);
        if (data.onInit) data.onInit(element, pswp);
        if (data.onClick) element.onclick = (e)=>{
            if (typeof data.onClick === "string") // @ts-ignore
            pswp[data.onClick]();
            else if (typeof data.onClick === "function") data.onClick(e, element, pswp);
        };
         // Top bar is default position
        const appendTo = data.appendTo || "bar";
        /** @type {HTMLElement | undefined} root element by default */ let container = pswp.element;
        if (appendTo === "bar") {
            if (!pswp.topBar) pswp.topBar = $1f75a04ded5eb2bf$var$createElement("pswp__top-bar pswp__hide-on-close", "div", pswp.scrollWrap);
            container = pswp.topBar;
        } else {
            // element outside of top bar gets a secondary class
            // that makes element fade out on close
            element.classList.add("pswp__hide-on-close");
            if (appendTo === "wrapper") container = pswp.scrollWrap;
        }
        (_container = container) === null || _container === void 0 || _container.appendChild(pswp.applyFilters("uiElement", element, data));
    }
}
/*
  Backward and forward arrow buttons
 */ /** @typedef {import('./ui-element.js').UIElementData} UIElementData */ /** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /**
 *
 * @param {HTMLElement} element
 * @param {PhotoSwipe} pswp
 * @param {boolean} [isNextButton]
 */ function $1f75a04ded5eb2bf$var$initArrowButton(element, pswp, isNextButton) {
    element.classList.add("pswp__button--arrow"); // TODO: this should point to a unique id for this instance
    element.setAttribute("aria-controls", "pswp__items");
    pswp.on("change", ()=>{
        if (!pswp.options.loop) {
            if (isNextButton) /** @type {HTMLButtonElement} */ element.disabled = !(pswp.currIndex < pswp.getNumItems() - 1);
            else /** @type {HTMLButtonElement} */ element.disabled = !(pswp.currIndex > 0);
        }
    });
}
/** @type {UIElementData} */ const $1f75a04ded5eb2bf$var$arrowPrev = {
    name: "arrowPrev",
    className: "pswp__button--arrow--prev",
    title: "Previous",
    order: 10,
    isButton: true,
    appendTo: "wrapper",
    html: {
        isCustomSVG: true,
        size: 60,
        inner: '<path d="M29 43l-3 3-16-16 16-16 3 3-13 13 13 13z" id="pswp__icn-arrow"/>',
        outlineID: "pswp__icn-arrow"
    },
    onClick: "prev",
    onInit: $1f75a04ded5eb2bf$var$initArrowButton
};
/** @type {UIElementData} */ const $1f75a04ded5eb2bf$var$arrowNext = {
    name: "arrowNext",
    className: "pswp__button--arrow--next",
    title: "Next",
    order: 11,
    isButton: true,
    appendTo: "wrapper",
    html: {
        isCustomSVG: true,
        size: 60,
        inner: '<use xlink:href="#pswp__icn-arrow"/>',
        outlineID: "pswp__icn-arrow"
    },
    onClick: "next",
    onInit: (el, pswp)=>{
        $1f75a04ded5eb2bf$var$initArrowButton(el, pswp, true);
    }
};
/** @type {import('./ui-element.js').UIElementData} UIElementData */ const $1f75a04ded5eb2bf$var$closeButton = {
    name: "close",
    title: "Close",
    order: 20,
    isButton: true,
    html: {
        isCustomSVG: true,
        inner: '<path d="M24 10l-2-2-6 6-6-6-2 2 6 6-6 6 2 2 6-6 6 6 2-2-6-6z" id="pswp__icn-close"/>',
        outlineID: "pswp__icn-close"
    },
    onClick: "close"
};
/** @type {import('./ui-element.js').UIElementData} UIElementData */ const $1f75a04ded5eb2bf$var$zoomButton = {
    name: "zoom",
    title: "Zoom",
    order: 10,
    isButton: true,
    html: {
        isCustomSVG: true,
        // eslint-disable-next-line max-len
        inner: '<path d="M17.426 19.926a6 6 0 1 1 1.5-1.5L23 22.5 21.5 24l-4.074-4.074z" id="pswp__icn-zoom"/><path fill="currentColor" class="pswp__zoom-icn-bar-h" d="M11 16v-2h6v2z"/><path fill="currentColor" class="pswp__zoom-icn-bar-v" d="M13 12h2v6h-2z"/>',
        outlineID: "pswp__icn-zoom"
    },
    onClick: "toggleZoom"
};
/** @type {import('./ui-element.js').UIElementData} UIElementData */ const $1f75a04ded5eb2bf$var$loadingIndicator = {
    name: "preloader",
    appendTo: "bar",
    order: 7,
    html: {
        isCustomSVG: true,
        // eslint-disable-next-line max-len
        inner: '<path fill-rule="evenodd" clip-rule="evenodd" d="M21.2 16a5.2 5.2 0 1 1-5.2-5.2V8a8 8 0 1 0 8 8h-2.8Z" id="pswp__icn-loading"/>',
        outlineID: "pswp__icn-loading"
    },
    onInit: (indicatorElement, pswp)=>{
        /** @type {boolean | undefined} */ let isVisible;
        /** @type {NodeJS.Timeout | null} */ let delayTimeout = null;
        /**
     * @param {string} className
     * @param {boolean} add
     */ const toggleIndicatorClass = (className, add)=>{
            indicatorElement.classList.toggle("pswp__preloader--" + className, add);
        };
        /**
     * @param {boolean} visible
     */ const setIndicatorVisibility = (visible)=>{
            if (isVisible !== visible) {
                isVisible = visible;
                toggleIndicatorClass("active", visible);
            }
        };
        const updatePreloaderVisibility = ()=>{
            var _pswp$currSlide;
            if (!((_pswp$currSlide = pswp.currSlide) !== null && _pswp$currSlide !== void 0 && _pswp$currSlide.content.isLoading())) {
                setIndicatorVisibility(false);
                if (delayTimeout) {
                    clearTimeout(delayTimeout);
                    delayTimeout = null;
                }
                return;
            }
            if (!delayTimeout) // display loading indicator with delay
            delayTimeout = setTimeout(()=>{
                var _pswp$currSlide2;
                setIndicatorVisibility(Boolean((_pswp$currSlide2 = pswp.currSlide) === null || _pswp$currSlide2 === void 0 ? void 0 : _pswp$currSlide2.content.isLoading()));
                delayTimeout = null;
            }, pswp.options.preloaderDelay);
        };
        pswp.on("change", updatePreloaderVisibility);
        pswp.on("loadComplete", (e)=>{
            if (pswp.currSlide === e.slide) updatePreloaderVisibility();
        }); // expose the method
        if (pswp.ui) pswp.ui.updatePreloaderVisibility = updatePreloaderVisibility;
    }
};
/** @type {import('./ui-element.js').UIElementData} UIElementData */ const $1f75a04ded5eb2bf$var$counterIndicator = {
    name: "counter",
    order: 5,
    onInit: (counterElement, pswp)=>{
        pswp.on("change", ()=>{
            counterElement.innerText = pswp.currIndex + 1 + pswp.options.indexIndicatorSep + pswp.getNumItems();
        });
    }
};
/** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /** @typedef {import('./ui-element.js').UIElementData} UIElementData */ /**
 * Set special class on element when image is zoomed.
 *
 * By default, it is used to adjust
 * zoom icon and zoom cursor via CSS.
 *
 * @param {HTMLElement} el
 * @param {boolean} isZoomedIn
 */ function $1f75a04ded5eb2bf$var$setZoomedIn(el, isZoomedIn) {
    el.classList.toggle("pswp--zoomed-in", isZoomedIn);
}
class $1f75a04ded5eb2bf$var$UI {
    /**
   * @param {PhotoSwipe} pswp
   */ constructor(pswp){
        this.pswp = pswp;
        this.isRegistered = false;
        /** @type {UIElementData[]} */ this.uiElementsData = [];
        /** @type {(UIElement | UIElementData)[]} */ this.items = [];
        /** @type {() => void} */ this.updatePreloaderVisibility = ()=>{};
        /**
     * @private
     * @type {number | undefined}
     */ this._lastUpdatedZoomLevel = undefined;
    }
    init() {
        const { pswp: pswp } = this;
        this.isRegistered = false;
        this.uiElementsData = [
            $1f75a04ded5eb2bf$var$closeButton,
            $1f75a04ded5eb2bf$var$arrowPrev,
            $1f75a04ded5eb2bf$var$arrowNext,
            $1f75a04ded5eb2bf$var$zoomButton,
            $1f75a04ded5eb2bf$var$loadingIndicator,
            $1f75a04ded5eb2bf$var$counterIndicator
        ];
        pswp.dispatch("uiRegister"); // sort by order
        this.uiElementsData.sort((a, b)=>{
            // default order is 0
            return (a.order || 0) - (b.order || 0);
        });
        this.items = [];
        this.isRegistered = true;
        this.uiElementsData.forEach((uiElementData)=>{
            this.registerElement(uiElementData);
        });
        pswp.on("change", ()=>{
            var _pswp$element;
            (_pswp$element = pswp.element) === null || _pswp$element === void 0 || _pswp$element.classList.toggle("pswp--one-slide", pswp.getNumItems() === 1);
        });
        pswp.on("zoomPanUpdate", ()=>this._onZoomPanUpdate());
    }
    /**
   * @param {UIElementData} elementData
   */ registerElement(elementData) {
        if (this.isRegistered) this.items.push(new $1f75a04ded5eb2bf$var$UIElement(this.pswp, elementData));
        else this.uiElementsData.push(elementData);
    }
    /**
   * Fired each time zoom or pan position is changed.
   * Update classes that control visibility of zoom button and cursor icon.
   *
   * @private
   */ _onZoomPanUpdate() {
        const { template: template, currSlide: currSlide, options: options } = this.pswp;
        if (this.pswp.opener.isClosing || !template || !currSlide) return;
        let { currZoomLevel: currZoomLevel } = currSlide; // if not open yet - check against initial zoom level
        if (!this.pswp.opener.isOpen) currZoomLevel = currSlide.zoomLevels.initial;
        if (currZoomLevel === this._lastUpdatedZoomLevel) return;
        this._lastUpdatedZoomLevel = currZoomLevel;
        const currZoomLevelDiff = currSlide.zoomLevels.initial - currSlide.zoomLevels.secondary; // Initial and secondary zoom levels are almost equal
        if (Math.abs(currZoomLevelDiff) < 0.01 || !currSlide.isZoomable()) {
            // disable zoom
            $1f75a04ded5eb2bf$var$setZoomedIn(template, false);
            template.classList.remove("pswp--zoom-allowed");
            return;
        }
        template.classList.add("pswp--zoom-allowed");
        const potentialZoomLevel = currZoomLevel === currSlide.zoomLevels.initial ? currSlide.zoomLevels.secondary : currSlide.zoomLevels.initial;
        $1f75a04ded5eb2bf$var$setZoomedIn(template, potentialZoomLevel <= currZoomLevel);
        if (options.imageClickAction === "zoom" || options.imageClickAction === "zoom-or-close") template.classList.add("pswp--click-to-zoom");
    }
}
/** @typedef {import('./slide.js').SlideData} SlideData */ /** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /** @typedef {{ x: number; y: number; w: number; innerRect?: { w: number; h: number; x: number; y: number } }} Bounds */ /**
 * @param {HTMLElement} el
 * @returns Bounds
 */ function $1f75a04ded5eb2bf$var$getBoundsByElement(el) {
    const thumbAreaRect = el.getBoundingClientRect();
    return {
        x: thumbAreaRect.left,
        y: thumbAreaRect.top,
        w: thumbAreaRect.width
    };
}
/**
 * @param {HTMLElement} el
 * @param {number} imageWidth
 * @param {number} imageHeight
 * @returns Bounds
 */ function $1f75a04ded5eb2bf$var$getCroppedBoundsByElement(el, imageWidth, imageHeight) {
    const thumbAreaRect = el.getBoundingClientRect(); // fill image into the area
    // (do they same as object-fit:cover does to retrieve coordinates)
    const hRatio = thumbAreaRect.width / imageWidth;
    const vRatio = thumbAreaRect.height / imageHeight;
    const fillZoomLevel = hRatio > vRatio ? hRatio : vRatio;
    const offsetX = (thumbAreaRect.width - imageWidth * fillZoomLevel) / 2;
    const offsetY = (thumbAreaRect.height - imageHeight * fillZoomLevel) / 2;
    /**
   * Coordinates of the image,
   * as if it was not cropped,
   * height is calculated automatically
   *
   * @type {Bounds}
   */ const bounds = {
        x: thumbAreaRect.left + offsetX,
        y: thumbAreaRect.top + offsetY,
        w: imageWidth * fillZoomLevel
    }; // Coordinates of inner crop area
    // relative to the image
    bounds.innerRect = {
        w: thumbAreaRect.width,
        h: thumbAreaRect.height,
        x: offsetX,
        y: offsetY
    };
    return bounds;
}
/**
 * Get dimensions of thumbnail image
 * (click on which opens photoswipe or closes photoswipe to)
 *
 * @param {number} index
 * @param {SlideData} itemData
 * @param {PhotoSwipe} instance PhotoSwipe instance
 * @returns {Bounds | undefined}
 */ function $1f75a04ded5eb2bf$var$getThumbBounds(index, itemData, instance) {
    // legacy event, before filters were introduced
    const event = instance.dispatch("thumbBounds", {
        index: index,
        itemData: itemData,
        instance: instance
    }); // @ts-expect-error
    if (event.thumbBounds) // @ts-expect-error
    return event.thumbBounds;
    const { element: element } = itemData;
    /** @type {Bounds | undefined} */ let thumbBounds;
    /** @type {HTMLElement | null | undefined} */ let thumbnail;
    if (element && instance.options.thumbSelector !== false) {
        const thumbSelector = instance.options.thumbSelector || "img";
        thumbnail = element.matches(thumbSelector) ? element : /** @type {HTMLElement | null} */ element.querySelector(thumbSelector);
    }
    thumbnail = instance.applyFilters("thumbEl", thumbnail, itemData, index);
    if (thumbnail) {
        if (!itemData.thumbCropped) thumbBounds = $1f75a04ded5eb2bf$var$getBoundsByElement(thumbnail);
        else thumbBounds = $1f75a04ded5eb2bf$var$getCroppedBoundsByElement(thumbnail, itemData.width || itemData.w || 0, itemData.height || itemData.h || 0);
    }
    return instance.applyFilters("thumbBounds", thumbBounds, itemData, index);
}
/** @typedef {import('../lightbox/lightbox.js').default} PhotoSwipeLightbox */ /** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */ /** @typedef {import('../photoswipe.js').DataSource} DataSource */ /** @typedef {import('../ui/ui-element.js').UIElementData} UIElementData */ /** @typedef {import('../slide/content.js').default} ContentDefault */ /** @typedef {import('../slide/slide.js').default} Slide */ /** @typedef {import('../slide/slide.js').SlideData} SlideData */ /** @typedef {import('../slide/zoom-level.js').default} ZoomLevel */ /** @typedef {import('../slide/get-thumb-bounds.js').Bounds} Bounds */ /**
 * Allow adding an arbitrary props to the Content
 * https://photoswipe.com/custom-content/#using-webp-image-format
 * @typedef {ContentDefault & Record<string, any>} Content
 */ /** @typedef {{ x?: number; y?: number }} Point */ /**
 * @typedef {Object} PhotoSwipeEventsMap https://photoswipe.com/events/
 *
 *
 * https://photoswipe.com/adding-ui-elements/
 *
 * @prop {undefined} uiRegister
 * @prop {{ data: UIElementData }} uiElementCreate
 *
 *
 * https://photoswipe.com/events/#initialization-events
 *
 * @prop {undefined} beforeOpen
 * @prop {undefined} firstUpdate
 * @prop {undefined} initialLayout
 * @prop {undefined} change
 * @prop {undefined} afterInit
 * @prop {undefined} bindEvents
 *
 *
 * https://photoswipe.com/events/#opening-or-closing-transition-events
 *
 * @prop {undefined} openingAnimationStart
 * @prop {undefined} openingAnimationEnd
 * @prop {undefined} closingAnimationStart
 * @prop {undefined} closingAnimationEnd
 *
 *
 * https://photoswipe.com/events/#closing-events
 *
 * @prop {undefined} close
 * @prop {undefined} destroy
 *
 *
 * https://photoswipe.com/events/#pointer-and-gesture-events
 *
 * @prop {{ originalEvent: PointerEvent }} pointerDown
 * @prop {{ originalEvent: PointerEvent }} pointerMove
 * @prop {{ originalEvent: PointerEvent }} pointerUp
 * @prop {{ bgOpacity: number }} pinchClose can be default prevented
 * @prop {{ panY: number }} verticalDrag can be default prevented
 *
 *
 * https://photoswipe.com/events/#slide-content-events
 *
 * @prop {{ content: Content }} contentInit
 * @prop {{ content: Content; isLazy: boolean }} contentLoad can be default prevented
 * @prop {{ content: Content; isLazy: boolean }} contentLoadImage can be default prevented
 * @prop {{ content: Content; slide: Slide; isError?: boolean }} loadComplete
 * @prop {{ content: Content; slide: Slide }} loadError
 * @prop {{ content: Content; width: number; height: number }} contentResize can be default prevented
 * @prop {{ content: Content; width: number; height: number; slide: Slide }} imageSizeChange
 * @prop {{ content: Content }} contentLazyLoad can be default prevented
 * @prop {{ content: Content }} contentAppend can be default prevented
 * @prop {{ content: Content }} contentActivate can be default prevented
 * @prop {{ content: Content }} contentDeactivate can be default prevented
 * @prop {{ content: Content }} contentRemove can be default prevented
 * @prop {{ content: Content }} contentDestroy can be default prevented
 *
 *
 * undocumented
 *
 * @prop {{ point: Point; originalEvent: PointerEvent }} imageClickAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} bgClickAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} tapAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} doubleTapAction can be default prevented
 *
 * @prop {{ originalEvent: KeyboardEvent }} keydown can be default prevented
 * @prop {{ x: number; dragging: boolean }} moveMainScroll
 * @prop {{ slide: Slide }} firstZoomPan
 * @prop {{ slide: Slide | undefined, data: SlideData, index: number }} gettingData
 * @prop {undefined} beforeResize
 * @prop {undefined} resize
 * @prop {undefined} viewportSize
 * @prop {undefined} updateScrollOffset
 * @prop {{ slide: Slide }} slideInit
 * @prop {{ slide: Slide }} afterSetContent
 * @prop {{ slide: Slide }} slideLoad
 * @prop {{ slide: Slide }} appendHeavy can be default prevented
 * @prop {{ slide: Slide }} appendHeavyContent
 * @prop {{ slide: Slide }} slideActivate
 * @prop {{ slide: Slide }} slideDeactivate
 * @prop {{ slide: Slide }} slideDestroy
 * @prop {{ destZoomLevel: number, centerPoint: Point | undefined, transitionDuration: number | false | undefined }} beforeZoomTo
 * @prop {{ slide: Slide }} zoomPanUpdate
 * @prop {{ slide: Slide }} initialZoomPan
 * @prop {{ slide: Slide }} calcSlideSize
 * @prop {undefined} resolutionChanged
 * @prop {{ originalEvent: WheelEvent }} wheel can be default prevented
 * @prop {{ content: Content }} contentAppendImage can be default prevented
 * @prop {{ index: number; itemData: SlideData }} lazyLoadSlide can be default prevented
 * @prop {undefined} lazyLoad
 * @prop {{ slide: Slide }} calcBounds
 * @prop {{ zoomLevels: ZoomLevel, slideData: SlideData }} zoomLevelsUpdate
 *
 *
 * legacy
 *
 * @prop {undefined} init
 * @prop {undefined} initialZoomIn
 * @prop {undefined} initialZoomOut
 * @prop {undefined} initialZoomInEnd
 * @prop {undefined} initialZoomOutEnd
 * @prop {{ dataSource: DataSource | undefined, numItems: number }} numItems
 * @prop {{ itemData: SlideData; index: number }} itemData
 * @prop {{ index: number, itemData: SlideData, instance: PhotoSwipe }} thumbBounds
 */ /**
 * @typedef {Object} PhotoSwipeFiltersMap https://photoswipe.com/filters/
 *
 * @prop {(numItems: number, dataSource: DataSource | undefined) => number} numItems
 * Modify the total amount of slides. Example on Data sources page.
 * https://photoswipe.com/filters/#numitems
 *
 * @prop {(itemData: SlideData, index: number) => SlideData} itemData
 * Modify slide item data. Example on Data sources page.
 * https://photoswipe.com/filters/#itemdata
 *
 * @prop {(itemData: SlideData, element: HTMLElement, linkEl: HTMLAnchorElement) => SlideData} domItemData
 * Modify item data when it's parsed from DOM element. Example on Data sources page.
 * https://photoswipe.com/filters/#domitemdata
 *
 * @prop {(clickedIndex: number, e: MouseEvent, instance: PhotoSwipeLightbox) => number} clickedIndex
 * Modify clicked gallery item index.
 * https://photoswipe.com/filters/#clickedindex
 *
 * @prop {(placeholderSrc: string | false, content: Content) => string | false} placeholderSrc
 * Modify placeholder image source.
 * https://photoswipe.com/filters/#placeholdersrc
 *
 * @prop {(isContentLoading: boolean, content: Content) => boolean} isContentLoading
 * Modify if the content is currently loading.
 * https://photoswipe.com/filters/#iscontentloading
 *
 * @prop {(isContentZoomable: boolean, content: Content) => boolean} isContentZoomable
 * Modify if the content can be zoomed.
 * https://photoswipe.com/filters/#iscontentzoomable
 *
 * @prop {(useContentPlaceholder: boolean, content: Content) => boolean} useContentPlaceholder
 * Modify if the placeholder should be used for the content.
 * https://photoswipe.com/filters/#usecontentplaceholder
 *
 * @prop {(isKeepingPlaceholder: boolean, content: Content) => boolean} isKeepingPlaceholder
 * Modify if the placeholder should be kept after the content is loaded.
 * https://photoswipe.com/filters/#iskeepingplaceholder
 *
 *
 * @prop {(contentErrorElement: HTMLElement, content: Content) => HTMLElement} contentErrorElement
 * Modify an element when the content has error state (for example, if image cannot be loaded).
 * https://photoswipe.com/filters/#contenterrorelement
 *
 * @prop {(element: HTMLElement, data: UIElementData) => HTMLElement} uiElement
 * Modify a UI element that's being created.
 * https://photoswipe.com/filters/#uielement
 *
 * @prop {(thumbnail: HTMLElement | null | undefined, itemData: SlideData, index: number) => HTMLElement} thumbEl
 * Modify the thumbnail element from which opening zoom animation starts or ends.
 * https://photoswipe.com/filters/#thumbel
 *
 * @prop {(thumbBounds: Bounds | undefined, itemData: SlideData, index: number) => Bounds} thumbBounds
 * Modify the thumbnail bounds from which opening zoom animation starts or ends.
 * https://photoswipe.com/filters/#thumbbounds
 *
 * @prop {(srcsetSizesWidth: number, content: Content) => number} srcsetSizesWidth
 *
 * @prop {(preventPointerEvent: boolean, event: PointerEvent, pointerType: string) => boolean} preventPointerEvent
 *
 */ /**
 * @template {keyof PhotoSwipeFiltersMap} T
 * @typedef {{ fn: PhotoSwipeFiltersMap[T], priority: number }} Filter
 */ /**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {PhotoSwipeEventsMap[T] extends undefined ? PhotoSwipeEvent<T> : PhotoSwipeEvent<T> & PhotoSwipeEventsMap[T]} AugmentedEvent
 */ /**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {(event: AugmentedEvent<T>) => void} EventCallback
 */ /**
 * Base PhotoSwipe event object
 *
 * @template {keyof PhotoSwipeEventsMap} T
 */ class $1f75a04ded5eb2bf$var$PhotoSwipeEvent {
    /**
   * @param {T} type
   * @param {PhotoSwipeEventsMap[T]} [details]
   */ constructor(type, details){
        this.type = type;
        this.defaultPrevented = false;
        if (details) Object.assign(this, details);
    }
    preventDefault() {
        this.defaultPrevented = true;
    }
}
/**
 * PhotoSwipe base class that can listen and dispatch for events.
 * Shared by PhotoSwipe Core and PhotoSwipe Lightbox, extended by base.js
 */ class $1f75a04ded5eb2bf$var$Eventable {
    constructor(){
        /**
     * @type {{ [T in keyof PhotoSwipeEventsMap]?: ((event: AugmentedEvent<T>) => void)[] }}
     */ this._listeners = {};
        /**
     * @type {{ [T in keyof PhotoSwipeFiltersMap]?: Filter<T>[] }}
     */ this._filters = {};
        /** @type {PhotoSwipe | undefined} */ this.pswp = undefined;
        /** @type {PhotoSwipeOptions | undefined} */ this.options = undefined;
    }
    /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   * @param {number} priority
   */ addFilter(name, fn, priority = 100) {
        var _this$_filters$name, _this$_filters$name2, _this$pswp;
        if (!this._filters[name]) this._filters[name] = [];
        (_this$_filters$name = this._filters[name]) === null || _this$_filters$name === void 0 || _this$_filters$name.push({
            fn: fn,
            priority: priority
        });
        (_this$_filters$name2 = this._filters[name]) === null || _this$_filters$name2 === void 0 || _this$_filters$name2.sort((f1, f2)=>f1.priority - f2.priority);
        (_this$pswp = this.pswp) === null || _this$pswp === void 0 || _this$pswp.addFilter(name, fn, priority);
    }
    /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   */ removeFilter(name, fn) {
        if (this._filters[name]) // @ts-expect-error
        this._filters[name] = this._filters[name].filter((filter)=>filter.fn !== fn);
        if (this.pswp) this.pswp.removeFilter(name, fn);
    }
    /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {Parameters<PhotoSwipeFiltersMap[T]>} args
   * @returns {Parameters<PhotoSwipeFiltersMap[T]>[0]}
   */ applyFilters(name, ...args) {
        var _this$_filters$name3;
        (_this$_filters$name3 = this._filters[name]) === null || _this$_filters$name3 === void 0 || _this$_filters$name3.forEach((filter)=>{
            // @ts-expect-error
            args[0] = filter.fn.apply(this, args);
        });
        return args[0];
    }
    /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {EventCallback<T>} fn
   */ on(name, fn) {
        var _this$_listeners$name, _this$pswp2;
        if (!this._listeners[name]) this._listeners[name] = [];
        (_this$_listeners$name = this._listeners[name]) === null || _this$_listeners$name === void 0 || _this$_listeners$name.push(fn); // When binding events to lightbox,
        // also bind events to PhotoSwipe Core,
        // if it's open.
        (_this$pswp2 = this.pswp) === null || _this$pswp2 === void 0 || _this$pswp2.on(name, fn);
    }
    /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {EventCallback<T>} fn
   */ off(name, fn) {
        var _this$pswp3;
        if (this._listeners[name]) // @ts-expect-error
        this._listeners[name] = this._listeners[name].filter((listener)=>fn !== listener);
        (_this$pswp3 = this.pswp) === null || _this$pswp3 === void 0 || _this$pswp3.off(name, fn);
    }
    /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {PhotoSwipeEventsMap[T]} [details]
   * @returns {AugmentedEvent<T>}
   */ dispatch(name, details) {
        var _this$_listeners$name2;
        if (this.pswp) return this.pswp.dispatch(name, details);
        const event = /** @type {AugmentedEvent<T>} */ new $1f75a04ded5eb2bf$var$PhotoSwipeEvent(name, details);
        (_this$_listeners$name2 = this._listeners[name]) === null || _this$_listeners$name2 === void 0 || _this$_listeners$name2.forEach((listener)=>{
            listener.call(this, event);
        });
        return event;
    }
}
class $1f75a04ded5eb2bf$var$Placeholder {
    /**
   * @param {string | false} imageSrc
   * @param {HTMLElement} container
   */ constructor(imageSrc, container){
        // Create placeholder
        // (stretched thumbnail or simple div behind the main image)
        /** @type {HTMLImageElement | HTMLDivElement | null} */ this.element = $1f75a04ded5eb2bf$var$createElement("pswp__img pswp__img--placeholder", imageSrc ? "img" : "div", container);
        if (imageSrc) {
            const imgEl = /** @type {HTMLImageElement} */ this.element;
            imgEl.decoding = "async";
            imgEl.alt = "";
            imgEl.src = imageSrc;
            imgEl.setAttribute("role", "presentation");
        }
        this.element.setAttribute("aria-hidden", "true");
    }
    /**
   * @param {number} width
   * @param {number} height
   */ setDisplayedSize(width, height) {
        if (!this.element) return;
        if (this.element.tagName === "IMG") {
            // Use transform scale() to modify img placeholder size
            // (instead of changing width/height directly).
            // This helps with performance, specifically in iOS15 Safari.
            $1f75a04ded5eb2bf$var$setWidthHeight(this.element, 250, "auto");
            this.element.style.transformOrigin = "0 0";
            this.element.style.transform = $1f75a04ded5eb2bf$var$toTransformString(0, 0, width / 250);
        } else $1f75a04ded5eb2bf$var$setWidthHeight(this.element, width, height);
    }
    destroy() {
        var _this$element;
        if ((_this$element = this.element) !== null && _this$element !== void 0 && _this$element.parentNode) this.element.remove();
        this.element = null;
    }
}
/** @typedef {import('./slide.js').default} Slide */ /** @typedef {import('./slide.js').SlideData} SlideData */ /** @typedef {import('../core/base.js').default} PhotoSwipeBase */ /** @typedef {import('../util/util.js').LoadState} LoadState */ class $1f75a04ded5eb2bf$var$Content {
    /**
   * @param {SlideData} itemData Slide data
   * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
   * @param {number} index
   */ constructor(itemData, instance, index){
        this.instance = instance;
        this.data = itemData;
        this.index = index;
        /** @type {HTMLImageElement | HTMLDivElement | undefined} */ this.element = undefined;
        /** @type {Placeholder | undefined} */ this.placeholder = undefined;
        /** @type {Slide | undefined} */ this.slide = undefined;
        this.displayedImageWidth = 0;
        this.displayedImageHeight = 0;
        this.width = Number(this.data.w) || Number(this.data.width) || 0;
        this.height = Number(this.data.h) || Number(this.data.height) || 0;
        this.isAttached = false;
        this.hasSlide = false;
        this.isDecoding = false;
        /** @type {LoadState} */ this.state = $1f75a04ded5eb2bf$var$LOAD_STATE.IDLE;
        if (this.data.type) this.type = this.data.type;
        else if (this.data.src) this.type = "image";
        else this.type = "html";
        this.instance.dispatch("contentInit", {
            content: this
        });
    }
    removePlaceholder() {
        if (this.placeholder && !this.keepPlaceholder()) // With delay, as image might be loaded, but not rendered
        setTimeout(()=>{
            if (this.placeholder) {
                this.placeholder.destroy();
                this.placeholder = undefined;
            }
        }, 1000);
    }
    /**
   * Preload content
   *
   * @param {boolean} isLazy
   * @param {boolean} [reload]
   */ load(isLazy, reload) {
        if (this.slide && this.usePlaceholder()) {
            if (!this.placeholder) {
                const placeholderSrc = this.instance.applyFilters("placeholderSrc", // as rendering (even small stretched thumbnail) is an expensive operation
                this.data.msrc && this.slide.isFirstSlide ? this.data.msrc : false, this);
                this.placeholder = new $1f75a04ded5eb2bf$var$Placeholder(placeholderSrc, this.slide.container);
            } else {
                const placeholderEl = this.placeholder.element; // Add placeholder to DOM if it was already created
                if (placeholderEl && !placeholderEl.parentElement) this.slide.container.prepend(placeholderEl);
            }
        }
        if (this.element && !reload) return;
        if (this.instance.dispatch("contentLoad", {
            content: this,
            isLazy: isLazy
        }).defaultPrevented) return;
        if (this.isImageContent()) {
            this.element = $1f75a04ded5eb2bf$var$createElement("pswp__img", "img"); // Start loading only after width is defined, as sizes might depend on it.
            // Due to Safari feature, we must define sizes before srcset.
            if (this.displayedImageWidth) this.loadImage(isLazy);
        } else {
            this.element = $1f75a04ded5eb2bf$var$createElement("pswp__content", "div");
            this.element.innerHTML = this.data.html || "";
        }
        if (reload && this.slide) this.slide.updateContentSize(true);
    }
    /**
   * Preload image
   *
   * @param {boolean} isLazy
   */ loadImage(isLazy) {
        var _this$data$src, _this$data$alt;
        if (!this.isImageContent() || !this.element || this.instance.dispatch("contentLoadImage", {
            content: this,
            isLazy: isLazy
        }).defaultPrevented) return;
        const imageElement = /** @type HTMLImageElement */ this.element;
        this.updateSrcsetSizes();
        if (this.data.srcset) imageElement.srcset = this.data.srcset;
        imageElement.src = (_this$data$src = this.data.src) !== null && _this$data$src !== void 0 ? _this$data$src : "";
        imageElement.alt = (_this$data$alt = this.data.alt) !== null && _this$data$alt !== void 0 ? _this$data$alt : "";
        this.state = $1f75a04ded5eb2bf$var$LOAD_STATE.LOADING;
        if (imageElement.complete) this.onLoaded();
        else {
            imageElement.onload = ()=>{
                this.onLoaded();
            };
            imageElement.onerror = ()=>{
                this.onError();
            };
        }
    }
    /**
   * Assign slide to content
   *
   * @param {Slide} slide
   */ setSlide(slide) {
        this.slide = slide;
        this.hasSlide = true;
        this.instance = slide.pswp; // todo: do we need to unset slide?
    }
    /**
   * Content load success handler
   */ onLoaded() {
        this.state = $1f75a04ded5eb2bf$var$LOAD_STATE.LOADED;
        if (this.slide && this.element) {
            this.instance.dispatch("loadComplete", {
                slide: this.slide,
                content: this
            }); // if content is reloaded
            if (this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode) {
                this.append();
                this.slide.updateContentSize(true);
            }
            if (this.state === $1f75a04ded5eb2bf$var$LOAD_STATE.LOADED || this.state === $1f75a04ded5eb2bf$var$LOAD_STATE.ERROR) this.removePlaceholder();
        }
    }
    /**
   * Content load error handler
   */ onError() {
        this.state = $1f75a04ded5eb2bf$var$LOAD_STATE.ERROR;
        if (this.slide) {
            this.displayError();
            this.instance.dispatch("loadComplete", {
                slide: this.slide,
                isError: true,
                content: this
            });
            this.instance.dispatch("loadError", {
                slide: this.slide,
                content: this
            });
        }
    }
    /**
   * @returns {Boolean} If the content is currently loading
   */ isLoading() {
        return this.instance.applyFilters("isContentLoading", this.state === $1f75a04ded5eb2bf$var$LOAD_STATE.LOADING, this);
    }
    /**
   * @returns {Boolean} If the content is in error state
   */ isError() {
        return this.state === $1f75a04ded5eb2bf$var$LOAD_STATE.ERROR;
    }
    /**
   * @returns {boolean} If the content is image
   */ isImageContent() {
        return this.type === "image";
    }
    /**
   * Update content size
   *
   * @param {Number} width
   * @param {Number} height
   */ setDisplayedSize(width, height) {
        if (!this.element) return;
        if (this.placeholder) this.placeholder.setDisplayedSize(width, height);
        if (this.instance.dispatch("contentResize", {
            content: this,
            width: width,
            height: height
        }).defaultPrevented) return;
        $1f75a04ded5eb2bf$var$setWidthHeight(this.element, width, height);
        if (this.isImageContent() && !this.isError()) {
            const isInitialSizeUpdate = !this.displayedImageWidth && width;
            this.displayedImageWidth = width;
            this.displayedImageHeight = height;
            if (isInitialSizeUpdate) this.loadImage(false);
            else this.updateSrcsetSizes();
            if (this.slide) this.instance.dispatch("imageSizeChange", {
                slide: this.slide,
                width: width,
                height: height,
                content: this
            });
        }
    }
    /**
   * @returns {boolean} If the content can be zoomed
   */ isZoomable() {
        return this.instance.applyFilters("isContentZoomable", this.isImageContent() && this.state !== $1f75a04ded5eb2bf$var$LOAD_STATE.ERROR, this);
    }
    /**
   * Update image srcset sizes attribute based on width and height
   */ updateSrcsetSizes() {
        // Handle srcset sizes attribute.
        //
        // Never lower quality, if it was increased previously.
        // Chrome does this automatically, Firefox and Safari do not,
        // so we store largest used size in dataset.
        if (!this.isImageContent() || !this.element || !this.data.srcset) return;
        const image = /** @type HTMLImageElement */ this.element;
        const sizesWidth = this.instance.applyFilters("srcsetSizesWidth", this.displayedImageWidth, this);
        if (!image.dataset.largestUsedSize || sizesWidth > parseInt(image.dataset.largestUsedSize, 10)) {
            image.sizes = sizesWidth + "px";
            image.dataset.largestUsedSize = String(sizesWidth);
        }
    }
    /**
   * @returns {boolean} If content should use a placeholder (from msrc by default)
   */ usePlaceholder() {
        return this.instance.applyFilters("useContentPlaceholder", this.isImageContent(), this);
    }
    /**
   * Preload content with lazy-loading param
   */ lazyLoad() {
        if (this.instance.dispatch("contentLazyLoad", {
            content: this
        }).defaultPrevented) return;
        this.load(true);
    }
    /**
   * @returns {boolean} If placeholder should be kept after content is loaded
   */ keepPlaceholder() {
        return this.instance.applyFilters("isKeepingPlaceholder", this.isLoading(), this);
    }
    /**
   * Destroy the content
   */ destroy() {
        this.hasSlide = false;
        this.slide = undefined;
        if (this.instance.dispatch("contentDestroy", {
            content: this
        }).defaultPrevented) return;
        this.remove();
        if (this.placeholder) {
            this.placeholder.destroy();
            this.placeholder = undefined;
        }
        if (this.isImageContent() && this.element) {
            this.element.onload = null;
            this.element.onerror = null;
            this.element = undefined;
        }
    }
    /**
   * Display error message
   */ displayError() {
        if (this.slide) {
            var _this$instance$option, _this$instance$option2;
            let errorMsgEl = $1f75a04ded5eb2bf$var$createElement("pswp__error-msg", "div");
            errorMsgEl.innerText = (_this$instance$option = (_this$instance$option2 = this.instance.options) === null || _this$instance$option2 === void 0 ? void 0 : _this$instance$option2.errorMsg) !== null && _this$instance$option !== void 0 ? _this$instance$option : "";
            errorMsgEl = /** @type {HTMLDivElement} */ this.instance.applyFilters("contentErrorElement", errorMsgEl, this);
            this.element = $1f75a04ded5eb2bf$var$createElement("pswp__content pswp__error-msg-container", "div");
            this.element.appendChild(errorMsgEl);
            this.slide.container.innerText = "";
            this.slide.container.appendChild(this.element);
            this.slide.updateContentSize(true);
            this.removePlaceholder();
        }
    }
    /**
   * Append the content
   */ append() {
        if (this.isAttached || !this.element) return;
        this.isAttached = true;
        if (this.state === $1f75a04ded5eb2bf$var$LOAD_STATE.ERROR) {
            this.displayError();
            return;
        }
        if (this.instance.dispatch("contentAppend", {
            content: this
        }).defaultPrevented) return;
        const supportsDecode = "decode" in this.element;
        if (this.isImageContent()) {
            // Use decode() on nearby slides
            //
            // Nearby slide images are in DOM and not hidden via display:none.
            // However, they are placed offscreen (to the left and right side).
            //
            // Some browsers do not composite the image until it's actually visible,
            // using decode() helps.
            //
            // You might ask "why dont you just decode() and then append all images",
            // that's because I want to show image before it's fully loaded,
            // as browser can render parts of image while it is loading.
            // We do not do this in Safari due to partial loading bug.
            if (supportsDecode && this.slide && (!this.slide.isActive || $1f75a04ded5eb2bf$var$isSafari())) {
                this.isDecoding = true; // purposefully using finally instead of then,
                // as if srcset sizes changes dynamically - it may cause decode error
                /** @type {HTMLImageElement} */ this.element.decode().catch(()=>{}).finally(()=>{
                    this.isDecoding = false;
                    this.appendImage();
                });
            } else this.appendImage();
        } else if (this.slide && !this.element.parentNode) this.slide.container.appendChild(this.element);
    }
    /**
   * Activate the slide,
   * active slide is generally the current one,
   * meaning the user can see it.
   */ activate() {
        if (this.instance.dispatch("contentActivate", {
            content: this
        }).defaultPrevented || !this.slide) return;
        if (this.isImageContent() && this.isDecoding && !$1f75a04ded5eb2bf$var$isSafari()) // add image to slide when it becomes active,
        // even if it's not finished decoding
        this.appendImage();
        else if (this.isError()) this.load(false, true); // try to reload
        if (this.slide.holderElement) this.slide.holderElement.setAttribute("aria-hidden", "false");
    }
    /**
   * Deactivate the content
   */ deactivate() {
        this.instance.dispatch("contentDeactivate", {
            content: this
        });
        if (this.slide && this.slide.holderElement) this.slide.holderElement.setAttribute("aria-hidden", "true");
    }
    /**
   * Remove the content from DOM
   */ remove() {
        this.isAttached = false;
        if (this.instance.dispatch("contentRemove", {
            content: this
        }).defaultPrevented) return;
        if (this.element && this.element.parentNode) this.element.remove();
        if (this.placeholder && this.placeholder.element) this.placeholder.element.remove();
    }
    /**
   * Append the image content to slide container
   */ appendImage() {
        if (!this.isAttached) return;
        if (this.instance.dispatch("contentAppendImage", {
            content: this
        }).defaultPrevented) return;
         // ensure that element exists and is not already appended
        if (this.slide && this.element && !this.element.parentNode) this.slide.container.appendChild(this.element);
        if (this.state === $1f75a04ded5eb2bf$var$LOAD_STATE.LOADED || this.state === $1f75a04ded5eb2bf$var$LOAD_STATE.ERROR) this.removePlaceholder();
    }
}
/** @typedef {import('./content.js').default} Content */ /** @typedef {import('./slide.js').default} Slide */ /** @typedef {import('./slide.js').SlideData} SlideData */ /** @typedef {import('../core/base.js').default} PhotoSwipeBase */ /** @typedef {import('../photoswipe.js').default} PhotoSwipe */ const $1f75a04ded5eb2bf$var$MIN_SLIDES_TO_CACHE = 5;
/**
 * Lazy-load an image
 * This function is used both by Lightbox and PhotoSwipe core,
 * thus it can be called before dialog is opened.
 *
 * @param {SlideData} itemData Data about the slide
 * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
 * @param {number} index
 * @returns {Content} Image that is being decoded or false.
 */ function $1f75a04ded5eb2bf$var$lazyLoadData(itemData, instance, index) {
    const content = instance.createContentFromData(itemData, index);
    /** @type {ZoomLevel | undefined} */ let zoomLevel;
    const { options: options } = instance; // We need to know dimensions of the image to preload it,
    // as it might use srcset, and we need to define sizes
    if (options) {
        zoomLevel = new $1f75a04ded5eb2bf$var$ZoomLevel(options, itemData, -1);
        let viewportSize;
        if (instance.pswp) viewportSize = instance.pswp.viewportSize;
        else viewportSize = $1f75a04ded5eb2bf$var$getViewportSize(options, instance);
        const panAreaSize = $1f75a04ded5eb2bf$var$getPanAreaSize(options, viewportSize, itemData, index);
        zoomLevel.update(content.width, content.height, panAreaSize);
    }
    content.lazyLoad();
    if (zoomLevel) content.setDisplayedSize(Math.ceil(content.width * zoomLevel.initial), Math.ceil(content.height * zoomLevel.initial));
    return content;
}
/**
 * Lazy-loads specific slide.
 * This function is used both by Lightbox and PhotoSwipe core,
 * thus it can be called before dialog is opened.
 *
 * By default, it loads image based on viewport size and initial zoom level.
 *
 * @param {number} index Slide index
 * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox eventable instance
 * @returns {Content | undefined}
 */ function $1f75a04ded5eb2bf$var$lazyLoadSlide(index, instance) {
    const itemData = instance.getItemData(index);
    if (instance.dispatch("lazyLoadSlide", {
        index: index,
        itemData: itemData
    }).defaultPrevented) return;
    return $1f75a04ded5eb2bf$var$lazyLoadData(itemData, instance, index);
}
class $1f75a04ded5eb2bf$var$ContentLoader {
    /**
   * @param {PhotoSwipe} pswp
   */ constructor(pswp){
        this.pswp = pswp; // Total amount of cached images
        this.limit = Math.max(pswp.options.preload[0] + pswp.options.preload[1] + 1, $1f75a04ded5eb2bf$var$MIN_SLIDES_TO_CACHE);
        /** @type {Content[]} */ this._cachedItems = [];
    }
    /**
   * Lazy load nearby slides based on `preload` option.
   *
   * @param {number} [diff] Difference between slide indexes that was changed recently, or 0.
   */ updateLazy(diff) {
        const { pswp: pswp } = this;
        if (pswp.dispatch("lazyLoad").defaultPrevented) return;
        const { preload: preload } = pswp.options;
        const isForward = diff === undefined ? true : diff >= 0;
        let i; // preload[1] - num items to preload in forward direction
        for(i = 0; i <= preload[1]; i++)this.loadSlideByIndex(pswp.currIndex + (isForward ? i : -i));
         // preload[0] - num items to preload in backward direction
        for(i = 1; i <= preload[0]; i++)this.loadSlideByIndex(pswp.currIndex + (isForward ? -i : i));
    }
    /**
   * @param {number} initialIndex
   */ loadSlideByIndex(initialIndex) {
        const index = this.pswp.getLoopedIndex(initialIndex); // try to get cached content
        let content = this.getContentByIndex(index);
        if (!content) {
            // no cached content, so try to load from scratch:
            content = $1f75a04ded5eb2bf$var$lazyLoadSlide(index, this.pswp); // if content can be loaded, add it to cache:
            if (content) this.addToCache(content);
        }
    }
    /**
   * @param {Slide} slide
   * @returns {Content}
   */ getContentBySlide(slide) {
        let content = this.getContentByIndex(slide.index);
        if (!content) {
            // create content if not found in cache
            content = this.pswp.createContentFromData(slide.data, slide.index);
            this.addToCache(content);
        } // assign slide to content
        content.setSlide(slide);
        return content;
    }
    /**
   * @param {Content} content
   */ addToCache(content) {
        // move to the end of array
        this.removeByIndex(content.index);
        this._cachedItems.push(content);
        if (this._cachedItems.length > this.limit) {
            // Destroy the first content that's not attached
            const indexToRemove = this._cachedItems.findIndex((item)=>{
                return !item.isAttached && !item.hasSlide;
            });
            if (indexToRemove !== -1) {
                const removedItem = this._cachedItems.splice(indexToRemove, 1)[0];
                removedItem.destroy();
            }
        }
    }
    /**
   * Removes an image from cache, does not destroy() it, just removes.
   *
   * @param {number} index
   */ removeByIndex(index) {
        const indexToRemove = this._cachedItems.findIndex((item)=>item.index === index);
        if (indexToRemove !== -1) this._cachedItems.splice(indexToRemove, 1);
    }
    /**
   * @param {number} index
   * @returns {Content | undefined}
   */ getContentByIndex(index) {
        return this._cachedItems.find((content)=>content.index === index);
    }
    destroy() {
        this._cachedItems.forEach((content)=>content.destroy());
        this._cachedItems = [];
    }
}
/** @typedef {import("../photoswipe.js").default} PhotoSwipe */ /** @typedef {import("../slide/slide.js").SlideData} SlideData */ /**
 * PhotoSwipe base class that can retrieve data about every slide.
 * Shared by PhotoSwipe Core and PhotoSwipe Lightbox
 */ class $1f75a04ded5eb2bf$var$PhotoSwipeBase extends $1f75a04ded5eb2bf$var$Eventable {
    /**
   * Get total number of slides
   *
   * @returns {number}
   */ getNumItems() {
        var _this$options;
        let numItems = 0;
        const dataSource = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.dataSource;
        if (dataSource && "length" in dataSource) // may be an array or just object with length property
        numItems = dataSource.length;
        else if (dataSource && "gallery" in dataSource) {
            // query DOM elements
            if (!dataSource.items) dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
            if (dataSource.items) numItems = dataSource.items.length;
        } // legacy event, before filters were introduced
        const event = this.dispatch("numItems", {
            dataSource: dataSource,
            numItems: numItems
        });
        return this.applyFilters("numItems", event.numItems, dataSource);
    }
    /**
   * @param {SlideData} slideData
   * @param {number} index
   * @returns {Content}
   */ createContentFromData(slideData, index) {
        return new $1f75a04ded5eb2bf$var$Content(slideData, this, index);
    }
    /**
   * Get item data by index.
   *
   * "item data" should contain normalized information that PhotoSwipe needs to generate a slide.
   * For example, it may contain properties like
   * `src`, `srcset`, `w`, `h`, which will be used to generate a slide with image.
   *
   * @param {number} index
   * @returns {SlideData}
   */ getItemData(index) {
        var _this$options2;
        const dataSource = (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.dataSource;
        /** @type {SlideData | HTMLElement} */ let dataSourceItem = {};
        if (Array.isArray(dataSource)) // Datasource is an array of elements
        dataSourceItem = dataSource[index];
        else if (dataSource && "gallery" in dataSource) {
            // dataSource has gallery property,
            // thus it was created by Lightbox, based on
            // gallery and children options
            // query DOM elements
            if (!dataSource.items) dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
            dataSourceItem = dataSource.items[index];
        }
        let itemData = dataSourceItem;
        if (itemData instanceof Element) itemData = this._domElementToItemData(itemData);
         // Dispatching the itemData event,
        // it's a legacy verion before filters were introduced
        const event = this.dispatch("itemData", {
            itemData: itemData || {},
            index: index
        });
        return this.applyFilters("itemData", event.itemData, index);
    }
    /**
   * Get array of gallery DOM elements,
   * based on childSelector and gallery element.
   *
   * @param {HTMLElement} galleryElement
   * @returns {HTMLElement[]}
   */ _getGalleryDOMElements(galleryElement) {
        var _this$options3, _this$options4;
        if ((_this$options3 = this.options) !== null && _this$options3 !== void 0 && _this$options3.children || (_this$options4 = this.options) !== null && _this$options4 !== void 0 && _this$options4.childSelector) return $1f75a04ded5eb2bf$var$getElementsFromOption(this.options.children, this.options.childSelector, galleryElement) || [];
        return [
            galleryElement
        ];
    }
    /**
   * Converts DOM element to item data object.
   *
   * @param {HTMLElement} element DOM element
   * @returns {SlideData}
   */ _domElementToItemData(element) {
        /** @type {SlideData} */ const itemData = {
            element: element
        };
        const linkEl = /** @type {HTMLAnchorElement} */ element.tagName === "A" ? element : element.querySelector("a");
        if (linkEl) {
            // src comes from data-pswp-src attribute,
            // if it's empty link href is used
            itemData.src = linkEl.dataset.pswpSrc || linkEl.href;
            if (linkEl.dataset.pswpSrcset) itemData.srcset = linkEl.dataset.pswpSrcset;
            itemData.width = linkEl.dataset.pswpWidth ? parseInt(linkEl.dataset.pswpWidth, 10) : 0;
            itemData.height = linkEl.dataset.pswpHeight ? parseInt(linkEl.dataset.pswpHeight, 10) : 0; // support legacy w & h properties
            itemData.w = itemData.width;
            itemData.h = itemData.height;
            if (linkEl.dataset.pswpType) itemData.type = linkEl.dataset.pswpType;
            const thumbnailEl = element.querySelector("img");
            if (thumbnailEl) {
                var _thumbnailEl$getAttri;
                // msrc is URL to placeholder image that's displayed before large image is loaded
                // by default it's displayed only for the first slide
                itemData.msrc = thumbnailEl.currentSrc || thumbnailEl.src;
                itemData.alt = (_thumbnailEl$getAttri = thumbnailEl.getAttribute("alt")) !== null && _thumbnailEl$getAttri !== void 0 ? _thumbnailEl$getAttri : "";
            }
            if (linkEl.dataset.pswpCropped || linkEl.dataset.cropped) itemData.thumbCropped = true;
        }
        return this.applyFilters("domItemData", itemData, element, linkEl);
    }
    /**
   * Lazy-load by slide data
   *
   * @param {SlideData} itemData Data about the slide
   * @param {number} index
   * @returns {Content} Image that is being decoded or false.
   */ lazyLoadData(itemData, index) {
        return $1f75a04ded5eb2bf$var$lazyLoadData(itemData, this, index);
    }
}
/** @typedef {import('./photoswipe.js').default} PhotoSwipe */ /** @typedef {import('./slide/get-thumb-bounds.js').Bounds} Bounds */ /** @typedef {import('./util/animations.js').AnimationProps} AnimationProps */ // some browsers do not paint
// elements which opacity is set to 0,
// since we need to pre-render elements for the animation -
// we set it to the minimum amount
const $1f75a04ded5eb2bf$var$MIN_OPACITY = 0.003;
/**
 * Manages opening and closing transitions of the PhotoSwipe.
 *
 * It can perform zoom, fade or no transition.
 */ class $1f75a04ded5eb2bf$var$Opener {
    /**
   * @param {PhotoSwipe} pswp
   */ constructor(pswp){
        this.pswp = pswp;
        this.isClosed = true;
        this.isOpen = false;
        this.isClosing = false;
        this.isOpening = false;
        /**
     * @private
     * @type {number | false | undefined}
     */ this._duration = undefined;
        /** @private */ this._useAnimation = false;
        /** @private */ this._croppedZoom = false;
        /** @private */ this._animateRootOpacity = false;
        /** @private */ this._animateBgOpacity = false;
        /**
     * @private
     * @type { HTMLDivElement | HTMLImageElement | null | undefined }
     */ this._placeholder = undefined;
        /**
     * @private
     * @type { HTMLDivElement | undefined }
     */ this._opacityElement = undefined;
        /**
     * @private
     * @type { HTMLDivElement | undefined }
     */ this._cropContainer1 = undefined;
        /**
     * @private
     * @type { HTMLElement | null | undefined }
     */ this._cropContainer2 = undefined;
        /**
     * @private
     * @type {Bounds | undefined}
     */ this._thumbBounds = undefined;
        this._prepareOpen = this._prepareOpen.bind(this); // Override initial zoom and pan position
        pswp.on("firstZoomPan", this._prepareOpen);
    }
    open() {
        this._prepareOpen();
        this._start();
    }
    close() {
        if (this.isClosed || this.isClosing || this.isOpening) // if we close during opening animation
        // for now do nothing,
        // browsers aren't good at changing the direction of the CSS transition
        return;
        const slide = this.pswp.currSlide;
        this.isOpen = false;
        this.isOpening = false;
        this.isClosing = true;
        this._duration = this.pswp.options.hideAnimationDuration;
        if (slide && slide.currZoomLevel * slide.width >= this.pswp.options.maxWidthToAnimate) this._duration = 0;
        this._applyStartProps();
        setTimeout(()=>{
            this._start();
        }, this._croppedZoom ? 30 : 0);
    }
    /** @private */ _prepareOpen() {
        this.pswp.off("firstZoomPan", this._prepareOpen);
        if (!this.isOpening) {
            const slide = this.pswp.currSlide;
            this.isOpening = true;
            this.isClosing = false;
            this._duration = this.pswp.options.showAnimationDuration;
            if (slide && slide.zoomLevels.initial * slide.width >= this.pswp.options.maxWidthToAnimate) this._duration = 0;
            this._applyStartProps();
        }
    }
    /** @private */ _applyStartProps() {
        const { pswp: pswp } = this;
        const slide = this.pswp.currSlide;
        const { options: options } = pswp;
        if (options.showHideAnimationType === "fade") {
            options.showHideOpacity = true;
            this._thumbBounds = undefined;
        } else if (options.showHideAnimationType === "none") {
            options.showHideOpacity = false;
            this._duration = 0;
            this._thumbBounds = undefined;
        } else if (this.isOpening && pswp._initialThumbBounds) // Use initial bounds if defined
        this._thumbBounds = pswp._initialThumbBounds;
        else this._thumbBounds = this.pswp.getThumbBounds();
        this._placeholder = slide === null || slide === void 0 ? void 0 : slide.getPlaceholderElement();
        pswp.animations.stopAll(); // Discard animations when duration is less than 50ms
        this._useAnimation = Boolean(this._duration && this._duration > 50);
        this._animateZoom = Boolean(this._thumbBounds) && (slide === null || slide === void 0 ? void 0 : slide.content.usePlaceholder()) && (!this.isClosing || !pswp.mainScroll.isShifted());
        if (!this._animateZoom) {
            this._animateRootOpacity = true;
            if (this.isOpening && slide) {
                slide.zoomAndPanToInitial();
                slide.applyCurrentZoomPan();
            }
        } else {
            var _options$showHideOpac;
            this._animateRootOpacity = (_options$showHideOpac = options.showHideOpacity) !== null && _options$showHideOpac !== void 0 ? _options$showHideOpac : false;
        }
        this._animateBgOpacity = !this._animateRootOpacity && this.pswp.options.bgOpacity > $1f75a04ded5eb2bf$var$MIN_OPACITY;
        this._opacityElement = this._animateRootOpacity ? pswp.element : pswp.bg;
        if (!this._useAnimation) {
            this._duration = 0;
            this._animateZoom = false;
            this._animateBgOpacity = false;
            this._animateRootOpacity = true;
            if (this.isOpening) {
                if (pswp.element) pswp.element.style.opacity = String($1f75a04ded5eb2bf$var$MIN_OPACITY);
                pswp.applyBgOpacity(1);
            }
            return;
        }
        if (this._animateZoom && this._thumbBounds && this._thumbBounds.innerRect) {
            var _this$pswp$currSlide;
            // Properties are used when animation from cropped thumbnail
            this._croppedZoom = true;
            this._cropContainer1 = this.pswp.container;
            this._cropContainer2 = (_this$pswp$currSlide = this.pswp.currSlide) === null || _this$pswp$currSlide === void 0 ? void 0 : _this$pswp$currSlide.holderElement;
            if (pswp.container) {
                pswp.container.style.overflow = "hidden";
                pswp.container.style.width = pswp.viewportSize.x + "px";
            }
        } else this._croppedZoom = false;
        if (this.isOpening) {
            // Apply styles before opening transition
            if (this._animateRootOpacity) {
                if (pswp.element) pswp.element.style.opacity = String($1f75a04ded5eb2bf$var$MIN_OPACITY);
                pswp.applyBgOpacity(1);
            } else {
                if (this._animateBgOpacity && pswp.bg) pswp.bg.style.opacity = String($1f75a04ded5eb2bf$var$MIN_OPACITY);
                if (pswp.element) pswp.element.style.opacity = "1";
            }
            if (this._animateZoom) {
                this._setClosedStateZoomPan();
                if (this._placeholder) {
                    // tell browser that we plan to animate the placeholder
                    this._placeholder.style.willChange = "transform"; // hide placeholder to allow hiding of
                    // elements that overlap it (such as icons over the thumbnail)
                    this._placeholder.style.opacity = String($1f75a04ded5eb2bf$var$MIN_OPACITY);
                }
            }
        } else if (this.isClosing) {
            // hide nearby slides to make sure that
            // they are not painted during the transition
            if (pswp.mainScroll.itemHolders[0]) pswp.mainScroll.itemHolders[0].el.style.display = "none";
            if (pswp.mainScroll.itemHolders[2]) pswp.mainScroll.itemHolders[2].el.style.display = "none";
            if (this._croppedZoom) {
                if (pswp.mainScroll.x !== 0) {
                    // shift the main scroller to zero position
                    pswp.mainScroll.resetPosition();
                    pswp.mainScroll.resize();
                }
            }
        }
    }
    /** @private */ _start() {
        if (this.isOpening && this._useAnimation && this._placeholder && this._placeholder.tagName === "IMG") // To ensure smooth animation
        // we wait till the current slide image placeholder is decoded,
        // but no longer than 250ms,
        // and no shorter than 50ms
        // (just using requestanimationframe is not enough in Firefox,
        // for some reason)
        new Promise((resolve)=>{
            let decoded = false;
            let isDelaying = true;
            $1f75a04ded5eb2bf$var$decodeImage(/** @type {HTMLImageElement} */ this._placeholder).finally(()=>{
                decoded = true;
                if (!isDelaying) resolve(true);
            });
            setTimeout(()=>{
                isDelaying = false;
                if (decoded) resolve(true);
            }, 50);
            setTimeout(resolve, 250);
        }).finally(()=>this._initiate());
        else this._initiate();
    }
    /** @private */ _initiate() {
        var _this$pswp$element, _this$pswp$element2;
        (_this$pswp$element = this.pswp.element) === null || _this$pswp$element === void 0 || _this$pswp$element.style.setProperty("--pswp-transition-duration", this._duration + "ms");
        this.pswp.dispatch(this.isOpening ? "openingAnimationStart" : "closingAnimationStart"); // legacy event
        this.pswp.dispatch(/** @type {'initialZoomIn' | 'initialZoomOut'} */ "initialZoom" + (this.isOpening ? "In" : "Out"));
        (_this$pswp$element2 = this.pswp.element) === null || _this$pswp$element2 === void 0 || _this$pswp$element2.classList.toggle("pswp--ui-visible", this.isOpening);
        if (this.isOpening) {
            if (this._placeholder) // unhide the placeholder
            this._placeholder.style.opacity = "1";
            this._animateToOpenState();
        } else if (this.isClosing) this._animateToClosedState();
        if (!this._useAnimation) this._onAnimationComplete();
    }
    /** @private */ _onAnimationComplete() {
        const { pswp: pswp } = this;
        this.isOpen = this.isOpening;
        this.isClosed = this.isClosing;
        this.isOpening = false;
        this.isClosing = false;
        pswp.dispatch(this.isOpen ? "openingAnimationEnd" : "closingAnimationEnd"); // legacy event
        pswp.dispatch(/** @type {'initialZoomInEnd' | 'initialZoomOutEnd'} */ "initialZoom" + (this.isOpen ? "InEnd" : "OutEnd"));
        if (this.isClosed) pswp.destroy();
        else if (this.isOpen) {
            var _pswp$currSlide;
            if (this._animateZoom && pswp.container) {
                pswp.container.style.overflow = "visible";
                pswp.container.style.width = "100%";
            }
            (_pswp$currSlide = pswp.currSlide) === null || _pswp$currSlide === void 0 || _pswp$currSlide.applyCurrentZoomPan();
        }
    }
    /** @private */ _animateToOpenState() {
        const { pswp: pswp } = this;
        if (this._animateZoom) {
            if (this._croppedZoom && this._cropContainer1 && this._cropContainer2) {
                this._animateTo(this._cropContainer1, "transform", "translate3d(0,0,0)");
                this._animateTo(this._cropContainer2, "transform", "none");
            }
            if (pswp.currSlide) {
                pswp.currSlide.zoomAndPanToInitial();
                this._animateTo(pswp.currSlide.container, "transform", pswp.currSlide.getCurrentTransform());
            }
        }
        if (this._animateBgOpacity && pswp.bg) this._animateTo(pswp.bg, "opacity", String(pswp.options.bgOpacity));
        if (this._animateRootOpacity && pswp.element) this._animateTo(pswp.element, "opacity", "1");
    }
    /** @private */ _animateToClosedState() {
        const { pswp: pswp } = this;
        if (this._animateZoom) this._setClosedStateZoomPan(true);
         // do not animate opacity if it's already at 0
        if (this._animateBgOpacity && pswp.bgOpacity > 0.01 && pswp.bg) this._animateTo(pswp.bg, "opacity", "0");
        if (this._animateRootOpacity && pswp.element) this._animateTo(pswp.element, "opacity", "0");
    }
    /**
   * @private
   * @param {boolean} [animate]
   */ _setClosedStateZoomPan(animate) {
        if (!this._thumbBounds) return;
        const { pswp: pswp } = this;
        const { innerRect: innerRect } = this._thumbBounds;
        const { currSlide: currSlide, viewportSize: viewportSize } = pswp;
        if (this._croppedZoom && innerRect && this._cropContainer1 && this._cropContainer2) {
            const containerOnePanX = -viewportSize.x + (this._thumbBounds.x - innerRect.x) + innerRect.w;
            const containerOnePanY = -viewportSize.y + (this._thumbBounds.y - innerRect.y) + innerRect.h;
            const containerTwoPanX = viewportSize.x - innerRect.w;
            const containerTwoPanY = viewportSize.y - innerRect.h;
            if (animate) {
                this._animateTo(this._cropContainer1, "transform", $1f75a04ded5eb2bf$var$toTransformString(containerOnePanX, containerOnePanY));
                this._animateTo(this._cropContainer2, "transform", $1f75a04ded5eb2bf$var$toTransformString(containerTwoPanX, containerTwoPanY));
            } else {
                $1f75a04ded5eb2bf$var$setTransform(this._cropContainer1, containerOnePanX, containerOnePanY);
                $1f75a04ded5eb2bf$var$setTransform(this._cropContainer2, containerTwoPanX, containerTwoPanY);
            }
        }
        if (currSlide) {
            $1f75a04ded5eb2bf$var$equalizePoints(currSlide.pan, innerRect || this._thumbBounds);
            currSlide.currZoomLevel = this._thumbBounds.w / currSlide.width;
            if (animate) this._animateTo(currSlide.container, "transform", currSlide.getCurrentTransform());
            else currSlide.applyCurrentZoomPan();
        }
    }
    /**
   * @private
   * @param {HTMLElement} target
   * @param {'transform' | 'opacity'} prop
   * @param {string} propValue
   */ _animateTo(target, prop, propValue) {
        if (!this._duration) {
            target.style[prop] = propValue;
            return;
        }
        const { animations: animations } = this.pswp;
        /** @type {AnimationProps} */ const animProps = {
            duration: this._duration,
            easing: this.pswp.options.easing,
            onComplete: ()=>{
                if (!animations.activeAnimations.length) this._onAnimationComplete();
            },
            target: target
        };
        animProps[prop] = propValue;
        animations.startTransition(animProps);
    }
}
/**
 * @template T
 * @typedef {import('./types.js').Type<T>} Type<T>
 */ /** @typedef {import('./slide/slide.js').SlideData} SlideData */ /** @typedef {import('./slide/zoom-level.js').ZoomLevelOption} ZoomLevelOption */ /** @typedef {import('./ui/ui-element.js').UIElementData} UIElementData */ /** @typedef {import('./main-scroll.js').ItemHolder} ItemHolder */ /** @typedef {import('./core/eventable.js').PhotoSwipeEventsMap} PhotoSwipeEventsMap */ /** @typedef {import('./core/eventable.js').PhotoSwipeFiltersMap} PhotoSwipeFiltersMap */ /** @typedef {import('./slide/get-thumb-bounds').Bounds} Bounds */ /**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {import('./core/eventable.js').EventCallback<T>} EventCallback<T>
 */ /**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {import('./core/eventable.js').AugmentedEvent<T>} AugmentedEvent<T>
 */ /** @typedef {{ x: number; y: number; id?: string | number }} Point */ /** @typedef {{ top: number; bottom: number; left: number; right: number }} Padding */ /** @typedef {SlideData[]} DataSourceArray */ /** @typedef {{ gallery: HTMLElement; items?: HTMLElement[] }} DataSourceObject */ /** @typedef {DataSourceArray | DataSourceObject} DataSource */ /** @typedef {(point: Point, originalEvent: PointerEvent) => void} ActionFn */ /** @typedef {'close' | 'next' | 'zoom' | 'zoom-or-close' | 'toggle-controls'} ActionType */ /** @typedef {Type<PhotoSwipe> | { default: Type<PhotoSwipe> }} PhotoSwipeModule */ /** @typedef {PhotoSwipeModule | Promise<PhotoSwipeModule> | (() => Promise<PhotoSwipeModule>)} PhotoSwipeModuleOption */ /**
 * @typedef {string | NodeListOf<HTMLElement> | HTMLElement[] | HTMLElement} ElementProvider
 */ /** @typedef {Partial<PreparedPhotoSwipeOptions>} PhotoSwipeOptions https://photoswipe.com/options/ */ /**
 * @typedef {Object} PreparedPhotoSwipeOptions
 *
 * @prop {DataSource} [dataSource]
 * Pass an array of any items via dataSource option. Its length will determine amount of slides
 * (which may be modified further from numItems event).
 *
 * Each item should contain data that you need to generate slide
 * (for image slide it would be src (image URL), width (image width), height, srcset, alt).
 *
 * If these properties are not present in your initial array, you may "pre-parse" each item from itemData filter.
 *
 * @prop {number} bgOpacity
 * Background backdrop opacity, always define it via this option and not via CSS rgba color.
 *
 * @prop {number} spacing
 * Spacing between slides. Defined as ratio relative to the viewport width (0.1 = 10% of viewport).
 *
 * @prop {boolean} allowPanToNext
 * Allow swipe navigation to the next slide when the current slide is zoomed. Does not apply to mouse events.
 *
 * @prop {boolean} loop
 * If set to true you'll be able to swipe from the last to the first image.
 * Option is always false when there are less than 3 slides.
 *
 * @prop {boolean} [wheelToZoom]
 * By default PhotoSwipe zooms image with ctrl-wheel, if you enable this option - image will zoom just via wheel.
 *
 * @prop {boolean} pinchToClose
 * Pinch touch gesture to close the gallery.
 *
 * @prop {boolean} closeOnVerticalDrag
 * Vertical drag gesture to close the PhotoSwipe.
 *
 * @prop {Padding} [padding]
 * Slide area padding (in pixels).
 *
 * @prop {(viewportSize: Point, itemData: SlideData, index: number) => Padding} [paddingFn]
 * The option is checked frequently, so make sure it's performant. Overrides padding option if defined. For example:
 *
 * @prop {number | false} hideAnimationDuration
 * Transition duration in milliseconds, can be 0.
 *
 * @prop {number | false} showAnimationDuration
 * Transition duration in milliseconds, can be 0.
 *
 * @prop {number | false} zoomAnimationDuration
 * Transition duration in milliseconds, can be 0.
 *
 * @prop {string} easing
 * String, 'cubic-bezier(.4,0,.22,1)'. CSS easing function for open/close/zoom transitions.
 *
 * @prop {boolean} escKey
 * Esc key to close.
 *
 * @prop {boolean} arrowKeys
 * Left/right arrow keys for navigation.
 *
 * @prop {boolean} trapFocus
 * Trap focus within PhotoSwipe element while it's open.
 *
 * @prop {boolean} returnFocus
 * Restore focus the last active element after PhotoSwipe is closed.
 *
 * @prop {boolean} clickToCloseNonZoomable
 * If image is not zoomable (for example, smaller than viewport) it can be closed by clicking on it.
 *
 * @prop {ActionType | ActionFn | false} imageClickAction
 * Refer to click and tap actions page.
 *
 * @prop {ActionType | ActionFn | false} bgClickAction
 * Refer to click and tap actions page.
 *
 * @prop {ActionType | ActionFn | false} tapAction
 * Refer to click and tap actions page.
 *
 * @prop {ActionType | ActionFn | false} doubleTapAction
 * Refer to click and tap actions page.
 *
 * @prop {number} preloaderDelay
 * Delay before the loading indicator will be displayed,
 * if image is loaded during it - the indicator will not be displayed at all. Can be zero.
 *
 * @prop {string} indexIndicatorSep
 * Used for slide count indicator ("1 of 10 ").
 *
 * @prop {(options: PhotoSwipeOptions, pswp: PhotoSwipeBase) => Point} [getViewportSizeFn]
 * A function that should return slide viewport width and height, in format {x: 100, y: 100}.
 *
 * @prop {string} errorMsg
 * Message to display when the image wasn't able to load. If you need to display HTML - use contentErrorElement filter.
 *
 * @prop {[number, number]} preload
 * Lazy loading of nearby slides based on direction of movement. Should be an array with two integers,
 * first one - number of items to preload before the current image, second one - after the current image.
 * Two nearby images are always loaded.
 *
 * @prop {string} [mainClass]
 * Class that will be added to the root element of PhotoSwipe, may contain multiple separated by space.
 * Example on Styling page.
 *
 * @prop {HTMLElement} [appendToEl]
 * Element to which PhotoSwipe dialog will be appended when it opens.
 *
 * @prop {number} maxWidthToAnimate
 * Maximum width of image to animate, if initial rendered image width
 * is larger than this value - the opening/closing transition will be automatically disabled.
 *
 * @prop {string} [closeTitle]
 * Translating
 *
 * @prop {string} [zoomTitle]
 * Translating
 *
 * @prop {string} [arrowPrevTitle]
 * Translating
 *
 * @prop {string} [arrowNextTitle]
 * Translating
 *
 * @prop {'zoom' | 'fade' | 'none'} [showHideAnimationType]
 * To adjust opening or closing transition type use lightbox option `showHideAnimationType` (`String`).
 * It supports three values - `zoom` (default), `fade` (default if there is no thumbnail) and `none`.
 *
 * Animations are automatically disabled if user `(prefers-reduced-motion: reduce)`.
 *
 * @prop {number} index
 * Defines start slide index.
 *
 * @prop {(e: MouseEvent) => number} [getClickedIndexFn]
 *
 * @prop {boolean} [arrowPrev]
 * @prop {boolean} [arrowNext]
 * @prop {boolean} [zoom]
 * @prop {boolean} [close]
 * @prop {boolean} [counter]
 *
 * @prop {string} [arrowPrevSVG]
 * @prop {string} [arrowNextSVG]
 * @prop {string} [zoomSVG]
 * @prop {string} [closeSVG]
 * @prop {string} [counterSVG]
 *
 * @prop {string} [arrowPrevTitle]
 * @prop {string} [arrowNextTitle]
 * @prop {string} [zoomTitle]
 * @prop {string} [closeTitle]
 * @prop {string} [counterTitle]
 *
 * @prop {ZoomLevelOption} [initialZoomLevel]
 * @prop {ZoomLevelOption} [secondaryZoomLevel]
 * @prop {ZoomLevelOption} [maxZoomLevel]
 *
 * @prop {boolean} [mouseMovePan]
 * @prop {Point | null} [initialPointerPos]
 * @prop {boolean} [showHideOpacity]
 *
 * @prop {PhotoSwipeModuleOption} [pswpModule]
 * @prop {() => Promise<any>} [openPromise]
 * @prop {boolean} [preloadFirstSlide]
 * @prop {ElementProvider} [gallery]
 * @prop {string} [gallerySelector]
 * @prop {ElementProvider} [children]
 * @prop {string} [childSelector]
 * @prop {string | false} [thumbSelector]
 */ /** @type {PreparedPhotoSwipeOptions} */ const $1f75a04ded5eb2bf$var$defaultOptions = {
    allowPanToNext: true,
    spacing: 0.1,
    loop: true,
    pinchToClose: true,
    closeOnVerticalDrag: true,
    hideAnimationDuration: 333,
    showAnimationDuration: 333,
    zoomAnimationDuration: 333,
    escKey: true,
    arrowKeys: true,
    trapFocus: true,
    returnFocus: true,
    maxWidthToAnimate: 4000,
    clickToCloseNonZoomable: true,
    imageClickAction: "zoom-or-close",
    bgClickAction: "close",
    tapAction: "toggle-controls",
    doubleTapAction: "zoom",
    indexIndicatorSep: " / ",
    preloaderDelay: 2000,
    bgOpacity: 0.8,
    index: 0,
    errorMsg: "The image cannot be loaded",
    preload: [
        1,
        2
    ],
    easing: "cubic-bezier(.4,0,.22,1)"
};
/**
 * PhotoSwipe Core
 */ class $1f75a04ded5eb2bf$export$2e2bcd8739ae039 extends $1f75a04ded5eb2bf$var$PhotoSwipeBase {
    /**
   * @param {PhotoSwipeOptions} [options]
   */ constructor(options){
        super();
        this.options = this._prepareOptions(options || {});
        /**
     * offset of viewport relative to document
     *
     * @type {Point}
     */ this.offset = {
            x: 0,
            y: 0
        };
        /**
     * @type {Point}
     * @private
     */ this._prevViewportSize = {
            x: 0,
            y: 0
        };
        /**
     * Size of scrollable PhotoSwipe viewport
     *
     * @type {Point}
     */ this.viewportSize = {
            x: 0,
            y: 0
        };
        /**
     * background (backdrop) opacity
     */ this.bgOpacity = 1;
        this.currIndex = 0;
        this.potentialIndex = 0;
        this.isOpen = false;
        this.isDestroying = false;
        this.hasMouse = false;
        /**
     * @private
     * @type {SlideData}
     */ this._initialItemData = {};
        /** @type {Bounds | undefined} */ this._initialThumbBounds = undefined;
        /** @type {HTMLDivElement | undefined} */ this.topBar = undefined;
        /** @type {HTMLDivElement | undefined} */ this.element = undefined;
        /** @type {HTMLDivElement | undefined} */ this.template = undefined;
        /** @type {HTMLDivElement | undefined} */ this.container = undefined;
        /** @type {HTMLElement | undefined} */ this.scrollWrap = undefined;
        /** @type {Slide | undefined} */ this.currSlide = undefined;
        this.events = new $1f75a04ded5eb2bf$var$DOMEvents();
        this.animations = new $1f75a04ded5eb2bf$var$Animations();
        this.mainScroll = new $1f75a04ded5eb2bf$var$MainScroll(this);
        this.gestures = new $1f75a04ded5eb2bf$var$Gestures(this);
        this.opener = new $1f75a04ded5eb2bf$var$Opener(this);
        this.keyboard = new $1f75a04ded5eb2bf$var$Keyboard(this);
        this.contentLoader = new $1f75a04ded5eb2bf$var$ContentLoader(this);
    }
    /** @returns {boolean} */ init() {
        if (this.isOpen || this.isDestroying) return false;
        this.isOpen = true;
        this.dispatch("init"); // legacy
        this.dispatch("beforeOpen");
        this._createMainStructure(); // add classes to the root element of PhotoSwipe
        let rootClasses = "pswp--open";
        if (this.gestures.supportsTouch) rootClasses += " pswp--touch";
        if (this.options.mainClass) rootClasses += " " + this.options.mainClass;
        if (this.element) this.element.className += " " + rootClasses;
        this.currIndex = this.options.index || 0;
        this.potentialIndex = this.currIndex;
        this.dispatch("firstUpdate"); // starting index can be modified here
        // initialize scroll wheel handler to block the scroll
        this.scrollWheel = new $1f75a04ded5eb2bf$var$ScrollWheel(this); // sanitize index
        if (Number.isNaN(this.currIndex) || this.currIndex < 0 || this.currIndex >= this.getNumItems()) this.currIndex = 0;
        if (!this.gestures.supportsTouch) // enable mouse features if no touch support detected
        this.mouseDetected();
         // causes forced synchronous layout
        this.updateSize();
        this.offset.y = window.pageYOffset;
        this._initialItemData = this.getItemData(this.currIndex);
        this.dispatch("gettingData", {
            index: this.currIndex,
            data: this._initialItemData,
            slide: undefined
        }); // *Layout* - calculate size and position of elements here
        this._initialThumbBounds = this.getThumbBounds();
        this.dispatch("initialLayout");
        this.on("openingAnimationEnd", ()=>{
            const { itemHolders: itemHolders } = this.mainScroll; // Add content to the previous and next slide
            if (itemHolders[0]) {
                itemHolders[0].el.style.display = "block";
                this.setContent(itemHolders[0], this.currIndex - 1);
            }
            if (itemHolders[2]) {
                itemHolders[2].el.style.display = "block";
                this.setContent(itemHolders[2], this.currIndex + 1);
            }
            this.appendHeavy();
            this.contentLoader.updateLazy();
            this.events.add(window, "resize", this._handlePageResize.bind(this));
            this.events.add(window, "scroll", this._updatePageScrollOffset.bind(this));
            this.dispatch("bindEvents");
        }); // set content for center slide (first time)
        if (this.mainScroll.itemHolders[1]) this.setContent(this.mainScroll.itemHolders[1], this.currIndex);
        this.dispatch("change");
        this.opener.open();
        this.dispatch("afterInit");
        return true;
    }
    /**
   * Get looped slide index
   * (for example, -1 will return the last slide)
   *
   * @param {number} index
   * @returns {number}
   */ getLoopedIndex(index) {
        const numSlides = this.getNumItems();
        if (this.options.loop) {
            if (index > numSlides - 1) index -= numSlides;
            if (index < 0) index += numSlides;
        }
        return $1f75a04ded5eb2bf$var$clamp(index, 0, numSlides - 1);
    }
    appendHeavy() {
        this.mainScroll.itemHolders.forEach((itemHolder)=>{
            var _itemHolder$slide;
            (_itemHolder$slide = itemHolder.slide) === null || _itemHolder$slide === void 0 || _itemHolder$slide.appendHeavy();
        });
    }
    /**
   * Change the slide
   * @param {number} index New index
   */ goTo(index) {
        this.mainScroll.moveIndexBy(this.getLoopedIndex(index) - this.potentialIndex);
    }
    /**
   * Go to the next slide.
   */ next() {
        this.goTo(this.potentialIndex + 1);
    }
    /**
   * Go to the previous slide.
   */ prev() {
        this.goTo(this.potentialIndex - 1);
    }
    /**
   * @see slide/slide.js zoomTo
   *
   * @param {Parameters<Slide['zoomTo']>} args
   */ zoomTo(...args) {
        var _this$currSlide;
        (_this$currSlide = this.currSlide) === null || _this$currSlide === void 0 || _this$currSlide.zoomTo(...args);
    }
    /**
   * @see slide/slide.js toggleZoom
   */ toggleZoom() {
        var _this$currSlide2;
        (_this$currSlide2 = this.currSlide) === null || _this$currSlide2 === void 0 || _this$currSlide2.toggleZoom();
    }
    /**
   * Close the gallery.
   * After closing transition ends - destroy it
   */ close() {
        if (!this.opener.isOpen || this.isDestroying) return;
        this.isDestroying = true;
        this.dispatch("close");
        this.events.removeAll();
        this.opener.close();
    }
    /**
   * Destroys the gallery:
   * - instantly closes the gallery
   * - unbinds events,
   * - cleans intervals and timeouts
   * - removes elements from DOM
   */ destroy() {
        var _this$element;
        if (!this.isDestroying) {
            this.options.showHideAnimationType = "none";
            this.close();
            return;
        }
        this.dispatch("destroy");
        this._listeners = {};
        if (this.scrollWrap) {
            this.scrollWrap.ontouchmove = null;
            this.scrollWrap.ontouchend = null;
        }
        (_this$element = this.element) === null || _this$element === void 0 || _this$element.remove();
        this.mainScroll.itemHolders.forEach((itemHolder)=>{
            var _itemHolder$slide2;
            (_itemHolder$slide2 = itemHolder.slide) === null || _itemHolder$slide2 === void 0 || _itemHolder$slide2.destroy();
        });
        this.contentLoader.destroy();
        this.events.removeAll();
    }
    /**
   * Refresh/reload content of a slide by its index
   *
   * @param {number} slideIndex
   */ refreshSlideContent(slideIndex) {
        this.contentLoader.removeByIndex(slideIndex);
        this.mainScroll.itemHolders.forEach((itemHolder, i)=>{
            var _this$currSlide$index, _this$currSlide3;
            let potentialHolderIndex = ((_this$currSlide$index = (_this$currSlide3 = this.currSlide) === null || _this$currSlide3 === void 0 ? void 0 : _this$currSlide3.index) !== null && _this$currSlide$index !== void 0 ? _this$currSlide$index : 0) - 1 + i;
            if (this.canLoop()) potentialHolderIndex = this.getLoopedIndex(potentialHolderIndex);
            if (potentialHolderIndex === slideIndex) {
                // set the new slide content
                this.setContent(itemHolder, slideIndex, true); // activate the new slide if it's current
                if (i === 1) {
                    var _itemHolder$slide3;
                    this.currSlide = itemHolder.slide;
                    (_itemHolder$slide3 = itemHolder.slide) === null || _itemHolder$slide3 === void 0 || _itemHolder$slide3.setIsActive(true);
                }
            }
        });
        this.dispatch("change");
    }
    /**
   * Set slide content
   *
   * @param {ItemHolder} holder mainScroll.itemHolders array item
   * @param {number} index Slide index
   * @param {boolean} [force] If content should be set even if index wasn't changed
   */ setContent(holder, index, force) {
        if (this.canLoop()) index = this.getLoopedIndex(index);
        if (holder.slide) {
            if (holder.slide.index === index && !force) // exit if holder already contains this slide
            // this could be common when just three slides are used
            return;
             // destroy previous slide
            holder.slide.destroy();
            holder.slide = undefined;
        } // exit if no loop and index is out of bounds
        if (!this.canLoop() && (index < 0 || index >= this.getNumItems())) return;
        const itemData = this.getItemData(index);
        holder.slide = new $1f75a04ded5eb2bf$var$Slide(itemData, index, this); // set current slide
        if (index === this.currIndex) this.currSlide = holder.slide;
        holder.slide.append(holder.el);
    }
    /** @returns {Point} */ getViewportCenterPoint() {
        return {
            x: this.viewportSize.x / 2,
            y: this.viewportSize.y / 2
        };
    }
    /**
   * Update size of all elements.
   * Executed on init and on page resize.
   *
   * @param {boolean} [force] Update size even if size of viewport was not changed.
   */ updateSize(force) {
        // let item;
        // let itemIndex;
        if (this.isDestroying) // exit if PhotoSwipe is closed or closing
        // (to avoid errors, as resize event might be delayed)
        return;
         //const newWidth = this.scrollWrap.clientWidth;
        //const newHeight = this.scrollWrap.clientHeight;
        const newViewportSize = $1f75a04ded5eb2bf$var$getViewportSize(this.options, this);
        if (!force && $1f75a04ded5eb2bf$var$pointsEqual(newViewportSize, this._prevViewportSize)) // Exit if dimensions were not changed
        return;
         //this._prevViewportSize.x = newWidth;
        //this._prevViewportSize.y = newHeight;
        $1f75a04ded5eb2bf$var$equalizePoints(this._prevViewportSize, newViewportSize);
        this.dispatch("beforeResize");
        $1f75a04ded5eb2bf$var$equalizePoints(this.viewportSize, this._prevViewportSize);
        this._updatePageScrollOffset();
        this.dispatch("viewportSize"); // Resize slides only after opener animation is finished
        // and don't re-calculate size on inital size update
        this.mainScroll.resize(this.opener.isOpen);
        if (!this.hasMouse && window.matchMedia("(any-hover: hover)").matches) this.mouseDetected();
        this.dispatch("resize");
    }
    /**
   * @param {number} opacity
   */ applyBgOpacity(opacity) {
        this.bgOpacity = Math.max(opacity, 0);
        if (this.bg) this.bg.style.opacity = String(this.bgOpacity * this.options.bgOpacity);
    }
    /**
   * Whether mouse is detected
   */ mouseDetected() {
        if (!this.hasMouse) {
            var _this$element2;
            this.hasMouse = true;
            (_this$element2 = this.element) === null || _this$element2 === void 0 || _this$element2.classList.add("pswp--has_mouse");
        }
    }
    /**
   * Page resize event handler
   *
   * @private
   */ _handlePageResize() {
        this.updateSize(); // In iOS webview, if element size depends on document size,
        // it'll be measured incorrectly in resize event
        //
        // https://bugs.webkit.org/show_bug.cgi?id=170595
        // https://hackernoon.com/onresize-event-broken-in-mobile-safari-d8469027bf4d
        if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) setTimeout(()=>{
            this.updateSize();
        }, 500);
    }
    /**
   * Page scroll offset is used
   * to get correct coordinates
   * relative to PhotoSwipe viewport.
   *
   * @private
   */ _updatePageScrollOffset() {
        this.setScrollOffset(0, window.pageYOffset);
    }
    /**
   * @param {number} x
   * @param {number} y
   */ setScrollOffset(x, y) {
        this.offset.x = x;
        this.offset.y = y;
        this.dispatch("updateScrollOffset");
    }
    /**
   * Create main HTML structure of PhotoSwipe,
   * and add it to DOM
   *
   * @private
   */ _createMainStructure() {
        // root DOM element of PhotoSwipe (.pswp)
        this.element = $1f75a04ded5eb2bf$var$createElement("pswp", "div");
        this.element.setAttribute("tabindex", "-1");
        this.element.setAttribute("role", "dialog"); // template is legacy prop
        this.template = this.element; // Background is added as a separate element,
        // as animating opacity is faster than animating rgba()
        this.bg = $1f75a04ded5eb2bf$var$createElement("pswp__bg", "div", this.element);
        this.scrollWrap = $1f75a04ded5eb2bf$var$createElement("pswp__scroll-wrap", "section", this.element);
        this.container = $1f75a04ded5eb2bf$var$createElement("pswp__container", "div", this.scrollWrap); // aria pattern: carousel
        this.scrollWrap.setAttribute("aria-roledescription", "carousel");
        this.container.setAttribute("aria-live", "off");
        this.container.setAttribute("id", "pswp__items");
        this.mainScroll.appendHolders();
        this.ui = new $1f75a04ded5eb2bf$var$UI(this);
        this.ui.init(); // append to DOM
        (this.options.appendToEl || document.body).appendChild(this.element);
    }
    /**
   * Get position and dimensions of small thumbnail
   *   {x:,y:,w:}
   *
   * Height is optional (calculated based on the large image)
   *
   * @returns {Bounds | undefined}
   */ getThumbBounds() {
        return $1f75a04ded5eb2bf$var$getThumbBounds(this.currIndex, this.currSlide ? this.currSlide.data : this._initialItemData, this);
    }
    /**
   * If the PhotoSwipe can have continuous loop
   * @returns Boolean
   */ canLoop() {
        return this.options.loop && this.getNumItems() > 2;
    }
    /**
   * @private
   * @param {PhotoSwipeOptions} options
   * @returns {PreparedPhotoSwipeOptions}
   */ _prepareOptions(options) {
        if (window.matchMedia("(prefers-reduced-motion), (update: slow)").matches) {
            options.showHideAnimationType = "none";
            options.zoomAnimationDuration = 0;
        }
        /** @type {PreparedPhotoSwipeOptions} */ return {
            ...$1f75a04ded5eb2bf$var$defaultOptions,
            ...options
        };
    }
}


function $c14c71c4ee9ecf42$var$getOptimalImageSource(imgElement) {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    const srcset = imgElement.srcset;
    const sources = srcset.split(",").map((source)=>{
        const [url, width] = source.trim().split(" ");
        return {
            url: url,
            width: parseInt(width.slice(0, -1))
        };
    });
    // Sort sources by width in descending order
    sources.sort((a, b)=>b.width - a.width);
    // Find the smallest source that fits the screen
    const { url: url, width: width } = sources.find((source)=>source.width <= screenWidth) || sources[sources.length - 1];
    // Calculate the height based on the aspect ratio of the original image dimensions
    const aspectRatio = imgElement.width / imgElement.height;
    const height = Math.round(width / aspectRatio);
    return {
        src: url,
        width: width,
        height: height
    };
}
function $c14c71c4ee9ecf42$var$createLightBox(dataSource, index = 0) {
    const lightbox = new (0, $1f75a04ded5eb2bf$export$2e2bcd8739ae039)({
        dataSource: dataSource,
        index: index,
        showHideAnimationType: "zoom",
        arrowPrevSVG: "\u27F5",
        arrowNextSVG: "\u27F6"
    });
    lightbox.addFilter("thumbEl", (thumbEl, data)=>{
        const el = document.querySelector('img[src="' + data.src + '"]');
        return el || thumbEl;
    });
    lightbox.init();
}
function $c14c71c4ee9ecf42$var$createGalleryLightbox($galleryElement, $startingImage) {
    const items = Array.from($galleryElement.querySelectorAll("img")).map((img)=>{
        const { srcset: srcset, src: src, alt: alt } = img;
        return {
            ...$c14c71c4ee9ecf42$var$getOptimalImageSource(img),
            srcset: srcset,
            msrc: src,
            alt: alt
        };
    });
    const index = Array.from($galleryElement.querySelectorAll("img")).indexOf($startingImage);
    $c14c71c4ee9ecf42$var$createLightBox(items, index);
}
function $c14c71c4ee9ecf42$var$createSingleImageLightbox($imageElement) {
    const { srcset: srcset, src: src, alt: alt } = $imageElement;
    const items = [
        {
            ...$c14c71c4ee9ecf42$var$getOptimalImageSource($imageElement),
            srcset: srcset,
            msrc: src,
            alt: alt
        }
    ];
    $c14c71c4ee9ecf42$var$createLightBox(items);
}
function $c14c71c4ee9ecf42$export$2e6dbd0d67bfffc9() {
    document.addEventListener("click", (event)=>{
        const $target = event.target;
        if ($target.matches(".kg-gallery-card img")) $c14c71c4ee9ecf42$var$createGalleryLightbox($target.closest(".kg-gallery-card"), $target);
        if ($target.matches(".kg-image-card img")) $c14c71c4ee9ecf42$var$createSingleImageLightbox($target);
    });
}


function $a6e9b0a57eaa7db2$export$9b40324a19701c18(href) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = href;
    return link;
}
function $a6e9b0a57eaa7db2$export$28503efd90ff36be(src) {
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    return script;
}


function $847a7e6050ced907$var$injectStylesToIframe(iframe) {
    const interval = setInterval(()=>{
        if (iframe.contentDocument && iframe.contentDocument.head?.children.length > 0) {
            const sharedStyles = document.querySelectorAll("[data-theme-shared-styles]");
            sharedStyles.forEach((style)=>{
                iframe.contentDocument.head.appendChild(style.cloneNode(true));
            });
            const iframeStylesHref = document.querySelector(`[data-theme-styles-for="[title='${iframe.title}']"]`)?.getAttribute("data-theme-styles-href");
            if (iframeStylesHref) {
                const iframeStyles = (0, $a6e9b0a57eaa7db2$export$9b40324a19701c18)(iframeStylesHref);
                iframe.contentDocument.head.appendChild(iframeStyles);
            }
            const bodyClasses = document.body.classList.toString().split(" ");
            iframe.contentDocument.body.classList.add(...bodyClasses);
            // Add data-theme attribute handling
            const parentTheme = document.body.getAttribute("data-theme");
            if (parentTheme) iframe.contentDocument.body.setAttribute("data-theme", parentTheme);
            clearInterval(interval);
        }
    }, 10);
}
function $847a7e6050ced907$var$observeDataThemeChanges(iframe) {
    const observer = new MutationObserver((mutations)=>{
        mutations.forEach((mutation)=>{
            if (mutation.type === "attributes" && mutation.attributeName === "data-theme") {
                const parentTheme = document.body.getAttribute("data-theme");
                if (iframe.contentDocument && iframe.contentDocument.body) {
                    if (parentTheme) iframe.contentDocument.body.setAttribute("data-theme", parentTheme);
                    else iframe.contentDocument.body.removeAttribute("data-theme");
                }
            }
        });
    });
    observer.observe(document.body, {
        attributes: true,
        attributeFilter: [
            "data-theme"
        ]
    });
}
function $847a7e6050ced907$var$observeIframeAdded(callback) {
    const observer = new MutationObserver((mutations)=>{
        mutations.forEach((mutation)=>{
            mutation.addedNodes.forEach((node)=>{
                const iframe = node?.tagName === "iframe" ? node : node?.querySelector?.("iframe");
                if (iframe) callback(iframe);
            });
        });
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}
function $847a7e6050ced907$export$e77c596238f0ddb6() {
    $847a7e6050ced907$var$observeIframeAdded((iframe)=>{
        $847a7e6050ced907$var$injectStylesToIframe(iframe);
        $847a7e6050ced907$var$observeDataThemeChanges(iframe);
    });
}


const $5de13232811c9860$var$selectors = {
    carousel: "[data-theme-carousel]",
    container: "[data-theme-carousel-container]",
    prev: "[data-theme-carousel-prev]",
    next: "[data-theme-carousel-next]"
};
function $5de13232811c9860$export$16aebf8358953f89() {
    document.querySelectorAll($5de13232811c9860$var$selectors.carousel).forEach($5de13232811c9860$var$setupCarousel);
}
function $5de13232811c9860$var$setupCarousel(carousel) {
    const container = carousel.querySelector($5de13232811c9860$var$selectors.container);
    if (!container) return;
    const prevButton = carousel.parentElement?.querySelector($5de13232811c9860$var$selectors.prev);
    const nextButton = carousel.parentElement?.querySelector($5de13232811c9860$var$selectors.next);
    const scrollAmount = ()=>carousel.offsetWidth;
    prevButton?.addEventListener("click", ()=>{
        container.scrollBy({
            left: -scrollAmount(),
            behavior: "smooth"
        });
    });
    nextButton?.addEventListener("click", ()=>{
        container.scrollBy({
            left: scrollAmount(),
            behavior: "smooth"
        });
    });
    const updateButtonStates = ()=>{
        const isAtStart = container.scrollLeft <= 0;
        const isAtEnd = container.scrollLeft + container.clientWidth + 10 >= container.scrollWidth;
        prevButton?.toggleAttribute("disabled", isAtStart);
        nextButton?.toggleAttribute("disabled", isAtEnd);
    };
    container.addEventListener("scroll", updateButtonStates);
    updateButtonStates();
    new ResizeObserver(()=>{
        const padding = carousel.offsetLeft;
        Object.assign(container.style, {
            paddingLeft: `${padding}px`,
            paddingRight: `${padding}px`,
            transform: `translateX(-${padding}px)`,
            scrollPaddingInlineStart: `${padding}px`
        });
        if (prevButton) prevButton.style.left = `-${padding}px`;
        if (nextButton) nextButton.style.right = `-${padding}px`;
        updateButtonStates();
    }).observe(carousel);
}



const $b71c93170524549c$var$HIGHLIGHT_STYLES_URL = "https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.9.0/styles/default.min.css";
const $b71c93170524549c$var$HIGHLIGHT_SCRIPT_URL = "https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.9.0/highlight.min.js";
function $b71c93170524549c$export$78a66f71d7847357() {
    document.addEventListener("DOMContentLoaded", ()=>{
        const codeBlocks = document.querySelectorAll("pre code");
        if (codeBlocks.length > 0) {
            const highlightStyles = (0, $a6e9b0a57eaa7db2$export$9b40324a19701c18)($b71c93170524549c$var$HIGHLIGHT_STYLES_URL);
            document.head.appendChild(highlightStyles);
            const highlightScript = (0, $a6e9b0a57eaa7db2$export$28503efd90ff36be)($b71c93170524549c$var$HIGHLIGHT_SCRIPT_URL);
            document.body.appendChild(highlightScript);
            highlightScript.onload = ()=>{
                codeBlocks.forEach((block)=>{
                    window.hljs?.highlightBlock(block);
                });
            };
        }
    });
}


const $45de40cadc239d7c$var$FEED_SELECTOR = ".posts-feed";
const $45de40cadc239d7c$var$NEXT_PAGE_SELECTOR = ".pagination__next";
const $45de40cadc239d7c$var$LOAD_MORE_SELECTOR = ".pagination__load-more";
const $45de40cadc239d7c$var$POST_SELECTOR = ".post-card";
const $45de40cadc239d7c$var$PAGINATION_SELECTOR = ".pagination";
const $45de40cadc239d7c$var$PAGINATION_NAV_SELECTOR = ".pagination nav";
var $45de40cadc239d7c$export$cb062a58cbf4753e;
(function(PaginationType) {
    PaginationType["Classic"] = "Classic";
    PaginationType["InfiniteScroll"] = "Infinite Scroll";
    PaginationType["LoadMore"] = "Load More";
})($45de40cadc239d7c$export$cb062a58cbf4753e || ($45de40cadc239d7c$export$cb062a58cbf4753e = {}));
async function $45de40cadc239d7c$export$b6b1e4af0d914db5() {
    const config = {
        path: $45de40cadc239d7c$var$NEXT_PAGE_SELECTOR,
        append: $45de40cadc239d7c$var$POST_SELECTOR,
        hideNav: $45de40cadc239d7c$var$PAGINATION_SELECTOR,
        history: false,
        historyTitle: false
    };
    await $45de40cadc239d7c$var$initializeInfiniteScroll(config);
}
async function $45de40cadc239d7c$export$9f1bf15843aa213a() {
    const config = {
        path: $45de40cadc239d7c$var$NEXT_PAGE_SELECTOR,
        append: $45de40cadc239d7c$var$POST_SELECTOR,
        scrollThreshold: false,
        hideNav: $45de40cadc239d7c$var$PAGINATION_NAV_SELECTOR,
        button: $45de40cadc239d7c$var$LOAD_MORE_SELECTOR,
        history: false,
        historyTitle: false
    };
    await $45de40cadc239d7c$var$initializeInfiniteScroll(config);
}

async function $45de40cadc239d7c$var$initializeInfiniteScroll(config) {
    const $feed = document.querySelector($45de40cadc239d7c$var$FEED_SELECTOR);
    if ($feed) {
        const InfiniteScroll = await (parcelRequire("9gXoD"));
        new InfiniteScroll($feed, config);
        return true;
    }
}


function $ece5cd3b1c714598$export$98b6358179a0e2b1(config) {
    const manifest = JSON.stringify({
        id: "/",
        name: config.title,
        short_name: config.title,
        start_url: config.url,
        background_color: "#fff",
        theme_color: config.accentColor,
        description: config.description,
        display: "standalone",
        display_override: [
            "standalone",
            "fullscreen",
            "minimal-ui",
            "browser"
        ],
        icons: [
            {
                src: config.icon,
                sizes: "512x512",
                type: "image/png"
            }
        ]
    });
    const blob = new Blob([
        manifest
    ], {
        type: "application/json"
    });
    const manifestURL = URL.createObjectURL(blob);
    document.querySelector("[data-theme-manifest]").setAttribute("href", manifestURL);
}


const $3b722884625b4201$var$SCROLL_INDICATOR_SELECTOR = ".scroll-indicator";
const $3b722884625b4201$var$POST_CONTENT_SELECTOR = ".post-content";
const $3b722884625b4201$var$handleScroll = (postContent, scrollIndicator)=>{
    const postContentHeight = postContent.scrollHeight;
    const postContentOffset = postContent.offsetTop;
    const postContentBottom = postContentOffset + postContentHeight - window.innerHeight;
    const percentage = window.scrollY / postContentBottom;
    const scrollPercentage = Math.min(1, Math.max(0, percentage));
    scrollIndicator.style.transform = `scaleX(${scrollPercentage})`;
};
function $3b722884625b4201$export$81595a76552714fe() {
    const scrollIndicator = document.querySelector($3b722884625b4201$var$SCROLL_INDICATOR_SELECTOR);
    const postContent = document.querySelector($3b722884625b4201$var$POST_CONTENT_SELECTOR);
    if (!scrollIndicator || !postContent) return;
    const throttledHandleScroll = ()=>requestAnimationFrame(()=>$3b722884625b4201$var$handleScroll(postContent, scrollIndicator));
    throttledHandleScroll();
    window.addEventListener("scroll", throttledHandleScroll);
}


const $bb6ddd9b19ae6dbc$var$FOOTER_NAV_SELECTOR = ".site-footer__nav";
const $bb6ddd9b19ae6dbc$var$FOOTER_SOCIAL_SELECTOR = ".site-footer__social";
function $bb6ddd9b19ae6dbc$export$90c215f287ea4365() {
    // Remove items from main nav if they contain an SVG (social icons)
    const $nav = document.querySelector($bb6ddd9b19ae6dbc$var$FOOTER_NAV_SELECTOR);
    $nav.querySelectorAll("a").forEach(($a)=>{
        if ($a.querySelector("svg")) $a.remove();
    });
    // Remove items from social nav if they don't contain an SVG (regular links)
    const $social = document.querySelector($bb6ddd9b19ae6dbc$var$FOOTER_SOCIAL_SELECTOR);
    $social.querySelectorAll("a").forEach(($a)=>{
        if (!$a.querySelector("svg")) $a.remove();
    });
}


const $ac8beaa04662a130$var$TOOLTIP_CLASSNAME = "tooltip";
function $ac8beaa04662a130$export$3896786ee28ba04e() {
    document.addEventListener("click", (event)=>{
        const target = event.target;
        if (target.classList.contains($ac8beaa04662a130$var$TOOLTIP_CLASSNAME)) {
            const rect = target.getBoundingClientRect();
            const isClickInside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
            if (!isClickInside) document.activeElement?.blur();
        }
    });
}


function $b5b314a2bd1b8dc0$export$11da5b37022bf7b2(darkColorScheme) {
    // Function to update the data-theme attribute
    const updateTheme = (isDark)=>{
        if (isDark && darkColorScheme) document.documentElement.setAttribute("data-theme", darkColorScheme);
        else document.documentElement.removeAttribute("data-theme");
    };
    // Initial theme setup
    updateTheme(window.matchMedia("(prefers-color-scheme: dark)").matches);
    // Listen for changes in the system color scheme
    window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", (e)=>{
        updateTheme(e.matches);
    });
}


(0, $dd19d2e942a38898$export$2e2bcd8739ae039)("iframe");
(0, $bb6ddd9b19ae6dbc$export$90c215f287ea4365)();
(0, $e27bb98248bac4e5$export$62e4ec31312c380a)();
(0, $6a40b2965ad474f9$export$4b674c99747dd23b)();
(0, $ac8beaa04662a130$export$3896786ee28ba04e)();
(0, $8c48e21f2c823446$export$71732d635643fc60)();
(0, $c14c71c4ee9ecf42$export$2e6dbd0d67bfffc9)();
(0, $847a7e6050ced907$export$e77c596238f0ddb6)();
(0, $5de13232811c9860$export$16aebf8358953f89)();
const $63549763a1b9929d$var$themeConfig = window.themeConfig;
if ($63549763a1b9929d$var$themeConfig.enableSyntaxHighlighting) (0, $b71c93170524549c$export$78a66f71d7847357)();
if ($63549763a1b9929d$var$themeConfig.enableAppMode) (0, $ece5cd3b1c714598$export$98b6358179a0e2b1)($63549763a1b9929d$var$themeConfig.site);
if ($63549763a1b9929d$var$themeConfig.enableScrollIndicator) (0, $3b722884625b4201$export$81595a76552714fe)();
if ($63549763a1b9929d$var$themeConfig.darkColorScheme) (0, $b5b314a2bd1b8dc0$export$11da5b37022bf7b2)($63549763a1b9929d$var$themeConfig.darkColorScheme);
switch($63549763a1b9929d$var$themeConfig.paginationType){
    case (0, $45de40cadc239d7c$export$cb062a58cbf4753e).InfiniteScroll:
        (0, $45de40cadc239d7c$export$b6b1e4af0d914db5)();
        break;
    case (0, $45de40cadc239d7c$export$cb062a58cbf4753e).LoadMore:
        (0, $45de40cadc239d7c$export$9f1bf15843aa213a)();
        break;
}

})();
//# sourceMappingURL=index.js.map
